export const translations = {
    en: {
        client: "Client",
        fleetPartner: "Fleet Partner",
        dashboard: "Go to Dashboard",
        aboutUs: "About Us",
        help: "Help",
        contactUs: "Contact Us",
        logout: "Logout",
        heroTitle1: "Construction Machinery,",
        heroTitle2: "Booked in Just a Few Steps.",
        heroSub: "India's first cab-style hail booking platform for JCBs and equipment machineries in few steps.",
        bookVehicle: "Book Machinery",
        joinFleet: "Join as a Fleet Partner",
        hireTrucksTitle: "Hire Trucks & Machinery",
        enterPickupLocation: "Enter pickup location",
        enterDropLocation: "Enter drop location",
        getPriceQuotes: "Get Price Quotes",
        onePlatform: "One Platform for All Heavy Vehicle Needs",
        onePlatformSub: "Manage bookings, track jobs, and connect directly with verified fleet partners—without middlemen.",
        equipmentTitle: "Find the right equipment for your next project.",
        equipmentRentals: "Equipment Rentals",
        viewAllEquipment: "View all equipment categories →",
        clientTitle: "Client",
        clientDesc: "Revolutionize your project logistics with KaroTrukk. Whether you need a single JCB for a day or a fleet of heavy trucks for a large-scale construction project, our platform connects you with verified owners instantly.",
        fleetTitle: "Fleet Partner",
        fleetDesc: "Put your heavy machinery to work and maximize your ROI. KaroTrukk connects JCB, Crane, and Truck owners with consistent, high-value project leads.",
        trackVehicles: "Track your On-Service vehicles",
        track: "Track",
        needVehicle: "Need a Vehicle?",
        bookRentalSub: "Book a rental or a quick spot trip now.",
        bookRentalSubDesc: "Access thousands of verified partners across India.",
        trackVehiclesDesc: "Monitor your shipments and On-Service bookings in real-time.",
        bookNow: "BookNow",
        searchByCompany: "Search by Company",
        trustCompanies: "Book with companies you trust",
        searchPlaceholder: "Search for companies...",
        search: "Search",
        availableVehicles: "Available Vehicles",
        premiumSolutions: "Premium Logistics Solutions Across India",
        filterBy: "Filter By",
        viewDetails: "View Details",
        reserveNow: "Reserve Now",
        requestedBookings: "Requested Bookings",
        acceptedBookings: "Accepted Bookings",
        pastBookings: "Past Completed Bookings",
        bookingsCount: "Bookings",
        locateFleet: "Locate Your Fleet",
        personalSolutions: "Reliable Delivery Solutions for Everyone",
        searchTypePlaceholder: "Search by vehicle type or model...",
        matchesFound: "Matches Found",
        personalAccount: "Personal Account",
        businessAccount: "Business Account",
        trackFleetTab: "Track Fleet",
        bookingsTab: "Bookings",
        shipmentsTab: "My Shipments",
        dashboardTab: "Dashboard",
        menu: "Menu",
        myBookings: "My Bookings",
        premiumPass: "Premium Pass",
        liveMap: "Live Map",
        liveTracking: "Live Tracking",
        inbox: "Inbox",
        documents: "Documents",
        settings: "Settings",
        account: "Account",
        theme: "Theme",
        supportChat: "Support Chat",
        signOut: "Sign Out",
        scissorLiftTitle: "Scissor Lift Rental",
        scissorLiftDesc: "With their stable platforms, high load capacity, versatility, and extensive reach, scissor lifts are the workhorses of commercial and industrial sites.",
        generatorTitle: "Generator Rental",
        generatorDesc: "Reliable power solutions for construction sites and industrial needs. Portable and trailer-mounted generators available.",
        boomLiftTitle: "Boom Lift Rental",
        boomLiftDesc: "Articulating and telescopic boom lifts for reaching difficult areas. Ideal for construction and maintenance work.",
        forkliftTitle: "Forklift & Material Handling Rental",
        forkliftDesc: "Efficient material handling solutions for warehouses, construction sites, and industrial facilities.",
        singleManLiftTitle: "Single Man Lift Rental",
        singleManLiftDesc: "Compact vertical lifts designed for single operator use. Perfect for maintenance and light construction work.",
        earthmovingTitle: "Earthmoving Equipment Rental",
        earthmovingDesc: "Heavy-duty machinery for excavation, grading, and earthwork. From mini excavators to large dozers.",
        compactionTitle: "Compaction Equipment Rental",
        compactionDesc: "Road construction and soil compaction machinery. Ensure proper ground preparation and surface finishing.",
        craneTitle: "Crane Rental",
        craneDesc: "Heavy lifting solutions for construction and industrial projects. Mobile and tower cranes available.",
        equipmentId: "Equipment ID",
        by: "By",
        setLocationRates: "Set location to view rates",
        showMore: "Show More",
        details: "Details",
        waterTankerTitle: "Need a Water Tanker?",
        waterTankerSubTitle: "Connect With a Water Tanker Near You",
        waterTankerDesc: "Need water for construction, events, industrial use, or emergency supply? KaroTrukk helps you instantly find and book verified operators in your area.",
        fastAvailability: "Fast availability",
        flexibleCapacity: "Flexible capacity",
        transparentPricing: "Transparent Pricing",
        reliablePartners: "Reliable partners",
        waterTankerServices: "Water Tanker Services",
        waterTankerServicesDesc: "Reliable water delivery solutions for all your needs. From drinking water to construction site requirements, book the right capacity instantly.",
        backToHome: "Back to Home",
        bulkBookingTitle: "One Platform to Book Single or Bulk Heavy Vehicles",
        realTimeVisibilityTitle: "Real-time Visibility",
        realTimeVisibilityDesc: "Track every movement of your goods with our advanced GPS integration. Know exactly where your shipment is, anytime, anywhere.",
        secureBusinessTitle: "Secure business",
        secureBusinessDesc: "Construction companies and business owners can search contractor fleets and book trucks or machinery in minutes.",
        dataDrivenTitle: "Data-Driven Insights",
        dataDrivenDesc: "Leverage historical data and predictive analytics to optimize routes, reduce costs, and improve overall fleet efficiency.",
        gpsTrackingTitle: "Real-Time Tracking for Total Peace of Mind",
        gpsTrackingDesc: "Protect your assets and maximize efficiency with industry-leading GPS technology from KarossStore. From theft prevention to fuel optimization, keeping an eye on your trucks has never been easier.",
        liveGeofencing: "Live Geofencing & Instant Alerts",
        routeHistory: "Route History & Fuel Optimization",
        durableHardware: "Compact, Waterproof & Durable Hardware",
        shopNow: "Shop at KarossStore.in",
        testimonials: "Testimonials",
        testimonialsSub: "Here's what people are saying",
        company: "Company",
        quickLinks: "Quick Links",
        support: "Support",
        countries: "Countries",
        tnCities: "Tamil Nadu Cities",
        allRightsReserved: "All rights reserved.",
        followUs: "Follow us on",
        careers: "Careers",
        blog: "Blog",
        privacyPolicy: "Privacy Policy",
        termsOfService: "Terms of Service",
        insuranceFaqs: "Insurance FAQs",
        bookTruck: "Book Truck",
        construction: "Construction",
        gpsTrackers: "GPS Trackers",
        onlyClientCanBook: "Only Client Can Book Services",
        myProfile: "My Profile",
        dashboardText: "Dashboard",
        requests: "Requests",
        returnLoad: "Return Load",
        fleetManagement: "Fleet Management",
        shipments: "Shipments",
        routePlanning: "Route Planning",
        analytics: "Analytics",
        history: "History",
        reviews: "Reviews",
        settlement: "Settlement",
        font: "Font",
        searchVehicle: "Search vehicle number...",
        partnerDashboard: "PARTNER DASHBOARD",
        planRoute: "Plan Route",
        loadingDashboard: "Loading Dashboard...",
        vsYesterday: "vs yesterday",
        performanceAnalytics: "Performance Analytics",
        analyticsSubtitle: "Deep insights into your fleet operations & revenue",
        operationalMetrics: "Operational Metrics",
        active: "On-Trip",
        idle: "Idle",
        service: "Service",
        noVehicles: "No Vehicles",
        fleetUtilization: "Fleet Utilization",
        awaitingFleetData: "Awaiting Fleet Data",
        addVehiclesToTrack: "Add vehicles to track utilization",
        units: "Units",
        weeklyRevenue: "Weekly Revenue",
        realTimeEarningsByDay: "Real-time earnings by day",
        noDataAvailableThisWeek: "No data available this week",
        last7Days: "Last 7 Days",
        waitingForData: "Waiting for data...",
        totalVehicles: "Total Vehicles",
        acceptedRequestsDash: "Accepted Requests",
        onTripBookings: "On-Service Bookings",
        totalEarnings: "Total Earnings",
        fullScreen: "Full Screen",
        fleetLiveTrack: "Fleet Live Track",
        earnings: "Earnings",
        thisMonth: "This Month",
        onTrip: "On-Service",
        potentialPending: "Potential/Pending",
        realTimeGrowth: "Real-time Growth",
        viewStatement: "View Statement",
        fleetStatus: "Fleet Status",
        vehiclesCount: "Vehicles",
        online: "Online",
        deliveryPerformance: "Delivery performance",
        weekly: "Weekly",
        waitingPerformanceData: "Waiting for Performance Data",
        completeFirstTrip: "Complete your first trip to unlock analytics",
        orderStatus: "Order status",
        calculatingStatus: "Calculating status...",
        yourVehiclesOverview: "Your Vehicles Overview",
        total: "Total",
        ratings: "Ratings",
        noVehiclesActive: "No vehicles On-Service yet. Start by adding one!",
        youLabel: "YOU",
        onTripManagement: "On-Service Management",
        bookingLabel: "Booking:",
        inTransit: "In Transit",
        confirmed: "Confirmed",
        stepLabel: "Step",
        clientLabel: "Client:",
        earningsLabel: "Earnings:",
        startedLabel: "Started:",
        endingLabel: "Ending:",
        markDelivered: "MARK DELIVERED",
        contactAction: "CONTACT",
        reportAction: "REPORT",
        activeStatusObj: "● On-Service",
        ratingLabel: "Rating",
        bookingsLabel: "Bookings",
        needLabel: "Need",
        priceLabel: "Price",
        routeLabel: "Route",
        profitabilityLabel: "Profitability",
        viewDetailsAction: "View Details",
        acceptAction: "Accept",
        routeLocations: "Route & Locations",
        arrivalPickup: "Arrival (Pickup)",
        viewInMap: "View in Map",
        targetDropoff: "Target (Primary Dropoff)",
        localDelivery: "Local Delivery",
        datesTimeline: "Dates & Timeline",
        pickupLabel: "Pickup",
        estimatedCompletion: "Estimated Completion",
        cargoDetails: "Cargo Details",
        typeLabel: "Type",
        weightLabel: "Weight",
        offeredPrice: "Offered Price",
        distanceArrivalTarget: "Distance (Arrival to Target)",
        fuelRequired: "Fuel Required (@ 7 KM/L)",
        totalEstimatedCost: "Total Estimated Cost",
        netProfit: "Net Profit",
        marginLabel: "Margin",
        clientTrust: "Client Trust",
        securedLabel: "Secured",
        verifiedPaymentCarrier: "Verified Payment Carrier",
        acceptRequestBtn: "Accept Request",
        declineBtn: "Decline",
        selectAllotment: "Select Vehicle for Allotment",
        requiredLabel: "Required",
        noCompatibleVehicles: "No Compatible Vehicles Available",
        ensureRegisteredLabel: "Please ensure you have registered vehicles that are currently IDLE or ACTIVE.",
        allotBtn: "Allot",
        bookingRequests: "Booking Requests",
        acceptedOverall: "Accepted Overall",
        recommendedFilter: "Best Match",
        nearYouFilter: "Nearby",
        highProfitFilter: "Best Earnings",
        urgentFilter: "Urgent",
        allFilter: "All Loads",
        noMatchingRequests: "No matching requests found",
        processingState: "Processing",
        arrivalSpot: "Arrival (Spot)",
        targetLabel: "Target",
        estimatedCosts: "Estimated Costs",
        commissionLabel: "Commission",
        returnLoadMatching: "Return Load Matching",
        findCargoDesc: "Find cargo for your return journey and maximize profits.",
        currentLabel: "Current: ",
        nativeLabel: "Native: ",
        toNativeLocation: "To Native Location",
        toNearby: "To Nearby",
        noReturnLoads: "No Return Loads Found",
        noReturnLoadsDescBase: "We couldn't find any requests from",
        onTripShipments: "On-Service Shipments",
        completedShipments: "Completed Shipments",
        reviewCompletedDesc: "Review your completed and delivered shipments",
        trackOngoingDesc: "Track and manage your ongoing deliveries",
        searchShipmentsPh: "Search by ID, route, or client...",
        allStatusOption: "ALL STATUS",
        readyStatusLabel: "READY",
        arrivingStatusLabel: "ARRIVING",
        onTripStatusLabel: "ON SERVICE",
        completedStatusLabel: "COMPLETED",
        deliveredStatusLabel: "DELIVERED",
        noShipmentsFound: "No shipments found",
        checkBackLater: "Check back later or adjust your filters",
        unknownStatus: "Unknown",
        cancelShipmentConfirm: "Are you sure you want to cancel this shipment?",
        failedUpdateStatus: "Failed to update booking status",
        failedCancelShipment: "Failed to cancel shipment",
        proofSubmittedSuccess: "Proof of Delivery submitted successfully!",
        submissionFailed: "Submission failed",
        linkCopied: "Link copied to clipboard! You can also copy it manually below:",
        failedGenerateLink: "Failed to generate share link",
        unassignedVehicle: "UNASSIGNED",
        fromLabel: "FROM",
        toLabel: "TO",
        revenueLabel: "REVENUE",
        startAction: "Start",
        trackAction: "Track",
        arriveAction: "Arrive",
        callAction: "Call",
        cancelAction: "Cancel",
        reviewProofAction: "Review Proof",
        uploadProofAction: "Upload Proof",
        verificationPortal: "Verification Portal",
        snapImagesHint: "Snap 3 clear images to complete",
        snapLabel: "SNAP",
        processingVerification: "Processing...",
        submitVerification: "Submit Verification",
        originLabel: "Origin",
        destinationLabel: "Destination",
        fleetManagementTitle: "Fleet Management",
        fleetManagementDesc: "Manage and monitor your registered vehicles",
        addNewVehicle: "Add New Vehicle",
        searchVehiclesPh: "Search by ID, plate, or name...",
        noVehiclesFoundMsg: "No vehicles found matching your criteria",
        noCategoryFound: "No {{category}} Found",
        startBusinessVehicle: "Start your business by adding your first {{vehicle}} to the KaroTrukk platform.",
        confirmDeleteVehicle: "Are you sure you want to delete this vehicle?",
        deleteSuccess: "Vehicle deleted successfully",
        deleteFailed: "Delete failed: ",
        editComingSoon: "Edit functionality coming soon",
        trackVehicleAction: "Track Vehicle",
        viewDetailsFleetAction: "View Details",
        wheelsLabel: "Wheels",
        unnamedVehicle: "Vehicle",
        statusLabels: {"active":"On-Service","onRoute":"On Route","idle":"Idle","service":"Service","maintenance":"Maintenance","draft":"Draft","inactive":"Inactive"},
        categoryLabel: "Category",
        yearLabel: "Year",
        conditionLabel: "Condition",
        locationLabel: "Location",
        basicInfoLabel: "Basic Information",
        techSpecsLabel: "Technical Specifications",
        equipSpecsLabel: "Equipment Specifications",
        driverDetailsLabel: "Driver Details",
        pricingRatesLabel: "Pricing & Rates",
        discountsLabel: "Discounts",
        specialFeaturesLabel: "Special Features",
        additionalNotesLabel: "Additional Notes",
        payloadCapacity: "Payload Capacity",
        lengthLabel: "Length",
        widthLabel: "Width",
        heightLabel: "Height",
        volumeLabel: "Volume",
        wizardSelectCategory: "Select Category",
        wizardAddVehicle: "Add New {{vehicle}}",
        wizardWhatAdding: "What are you adding today?",
        wizardStepBasic: "Step 1 of 4: Basic Details",
        wizardStepTech: "Step 2 of 4: Technical Specs",
        wizardStepPhotos: "Step 3 of 4: Photos & Docs",
        wizardStepPricing: "Step 4 of 4: Pricing",
        wizardCancel: "Cancel",
        wizardSaveCont: "Save & Continue",
        wizardPrev: "Previous",
        wizardPublish: "Publish Vehicle",
        wizardSaving: "Saving...",
        wizardPublishing: "Publishing...",
        wizardHeavy: "HEAVY",
        wizardHeavyDesc: "Trucks, LCVs, Trailers",
        wizardEquip: "EQUIPMENT",
        wizardEquipDesc: "Cranes, Forklifts, Generators",
        wizardConst: "CONSTRUCTION",
        wizardConstDesc: "JCBs, Mixers, Excavators",
        wizardTanker: "TANKER",
        wizardTankerDesc: "Water, Fuel, Milk Tankers",
        wizardSuccessTitle: "{{vehicle}} PUBLISHED SUCCESSFULLY!",
        wizardSuccessDesc: "Your {{vehicleType}} is now visible to all clients in your service area.",
        wizardViewListing: "View Your Listing",
        wizardNextSteps: "What happens next:",
        wizardStep1Help: "1. Clients will search for your equipment",
        wizardStep2Help: "2. You'll receive booking requests",
        wizardStep3Help: "3. Accept/decline requests in real-time",
        wizardStep4Help: "4. Complete trips and earn money",
        decisionTab: "Decision",
        analyticsTab: "Analytics",
        recurringTab: "Recurring",
        comingSoonText: "Coming Soon",
        deadTripDev: "Dead Trip Detection module in development",
        smartLoadDev: "Smart Load Matching integration arriving soon",
        profitCheckTitle: "Profitability Check",
        distanceLabel: "DISTANCE",
        fuelPriceLabel: "Fuel Price (₹/L)",
        clientPaymentLabel: "Client Payment (₹)",
        perKmPriceLabel: "Per km price (₹)",
        estClientPaymentLabel: "Est. Client Payment",
        selectedPickup: "Selected Pick-up",
        selectedDropoff: "Selected Drop-off",
        vehicleRegLabel: "Vehicle Reg No",
        mileageLabel: "Mileage (km/l)",
        tollsLabel: "Tolls (₹)",
        driverCostLabel: "Driver Cost / Trip (₹)",
        maintCostLabel: "Maint / Trip (₹)",
        calcRoutePrompt: "Please calculate a route on the map first to get distance.",
        runDecisionEngine: "RUN DECISION ENGINE",
        evaluatingBtn: "Evaluating...",
        tripProfitable: "✅ Trip is Profitable",
        potentialLoss: "⚠️ Potential Loss Detected",
        estProfit: "Est. Profit",
        estFuelCost: "Est Fuel Cost",
        platformComm: "Platform Commission",
        driverCost: "Driver Cost",
        tollsMaint: "Tolls & Maint",
        totalCosts: "Total Costs",
        smartOptionsTitle: "Smart Options",
        calcRouteSuggest: "Calculate a route on the map to see intelligent suggestions.",
        smartFromLabel: "From",
        smartToLabel: "To",
        shortestRoute: "Shortest Route",
        smartViewInMap: "View Shortest Route in Map",
        fastestRoute: "Fastest Route",
        fuelEfficient: "Fuel Efficient",
        balancedOption: "Balanced Option",
        alternative: "Alternative",
        routeSelected: "Selected",
        routeStandard: "Route Standard",
        mapComingSoonDesc: "In-platform interactive map with live route visualization",
        startPointPlaceholder: "Start Point (e.g. Chennai)",
        destinationPlaceholder: "Destination (e.g. Bangalore)",
        plotRouteBtn: "Plot Route",
        locationNotFound: "Could not find one or more locations. Please check your spelling.",
        calcError: "Could not calculate distance. Please try again.",
        suggestedRoute: "Suggested Route",
        openGoogleMaps: "Open Google Maps",
        loadingAnalytics: "Loading Analytics...",
        noDataYet: "No Data Yet",
        runCalcPrompt: "Run route profit calculations to see your performance analytics here.",
        totalTripsAnalyzed: "Total Trips Analyzed",
        profitableRoutesKPI: "Profitable Routes",
        avgProfitTrip: "Avg Profit / Trip",
        topRoutes: "Top Routes",
        tripsAnalyzed: "trips analyzed",
        loadingRecurring: "Loading Recurring Routes...",
        noRecurringRoutes: "No Recurring Routes",
        automateTripsSummary: "Automate your regular trips by saving them as recurring routes.",
        setupAutomationBtn: "+ Setup Automation",
        activeSchedules: "Active Schedules",
        routesCount: "{{count}} Routes",
        flexibleSched: "Flexible",
        assignedStatus: "- Assigned -",
        noVehicleAssigned: "No Vehicle Assigned",
        assignNow: "Assign Now",
        activityHistoryTitle: "Activity History",
        trackHistoryDesc: "Track your previous shipments and financial records",
        tabTransactions: "Transactions",
        tabPastShipments: "Past Shipments",
        tabMaintenanceLogs: "Maintenance Logs",
        noMaintenanceLogs: "No maintenance logs recorded yet",
        colDate: "Date",
        colTransactionID: "Transaction ID",
        colClient: "Client",
        colAmount: "Amount",
        colStatus: "Status",
        directClient: "Direct Client",
        statusPaid: "PAID",
        statusPending: "PENDING",
        noTransactionsFound: "No transactions found",
        earningHistoryDesc: "Your earning history will appear here",
        statusCompleted: "COMPLETED",
        tonsFormat: "{{weight}} TONS",
        noPastShipmentsFound: "No past shipments found",
        customerRatingsTitle: "Customer Ratings",
        feedbackSubtitle: "Feedback from your fleet clients",
        totalReviews: "total reviews",
        loadingReviews: "Loading Reviews...",
        noReviewsYet: "No reviews yet",
        completeTripsFeedback: "Complete trips to start receiving feedback",
        clientDefault: "Client",
        defaultReviewComment: "Performance met expectations.",
        linkedAssetLabel: "Linked Asset",
        truckServiceDefault: "Truck Service",
        helpSupportTitle: "Help & Support",
        supportSubtitle: "Get assistance and find answers to your questions",
        prioritySupportTitle: "24/7 Priority Support",
        prioritySupportDesc: "Our dedicated support team is here to help you with any issues.",
        startLiveChatBtn: "START LIVE CHAT",
        accountManagerLbl: "Account Manager",
        relationshipManagerLbl: "Relationship Manager",
        loadingTickets: "Loading Tickets...",
        activeTicketsTitle: "Active Tickets",
        noActiveTickets: "No Active Tickets",
        raiseTicketHelp: "Need help? Raise a new ticket below",
        raiseNewTicketBtn: "RAISE NEW TICKET",
        helpCenterTitle: "Help Center",
        searchHelpPlaceholder: "Search for help...",
        noResultsFound: "No results found",
        shortFaq1Q: "How do I add a new vehicle?",
        shortFaq1A: "Go to Fleet Management and click 'Add New Vehicle'. Fill in the RC and permit details.",
        shortFaq2Q: "When will I receive payment?",
        shortFaq2A: "Payments are processed every Friday for all completed shipments from the previous week.",
        shortFaq3Q: "How to track a specific truck?",
        shortFaq3A: "Use the 'Live Tracking' feature in either Fleet Management or the Shipments module.",
        shortFaq4Q: "What to do in case of delay?",
        shortFaq4A: "Update the shipment status to 'In Transit - Delayed' and notify the client through the dashboard.",
        contactDetails: "Contact Details",
        emailLbl: "Email",
        phoneLbl: "Phone",
        alternateLbl: "Alternate",
        baseLbl: "Base",
        businessIdentity: "Business Identity",
        gstLbl: "GST No",
        panLbl: "PAN No",
        entityLbl: "Entity",
        joinedLbl: "Joined",
        bankDetailsTitle: "Bank Details",
        holderLbl: "Holder",
        bankLbl: "Bank",
        accountLbl: "Account",
        ifscLbl: "IFSC",
        typeLbl: "Type",
        verifiedWithdrawalsDesc: "Verified details ensure instant withdrawals.",
        endOfMonthReports: "End-of-Month Reports",
        recordingLbl: "Recording",
        reportFinalizedDesc: "Report finalized & verified",
        availableOn: "Available on {{date}}",
        downloadDataSheetBtn: "Download Data Sheet",
        processingLbl: "Processing...",
        noHistoryObserved: "No operational history observed yet",
        businessShowcaseTitle: "Business Showcase",
        viewBusinessPage: "View Business Page",
        createBusinessPage: "Create Business Page",
        hasBusinessPageDesc: "Your professional showcase page used by clients to evaluate your fleet and services.",
        noBusinessPageDesc: "Build a professional advertising page for your fleet business and share with potential clients.",
        showPageBtn: "Show Page",
        startSetupBtn: "Start Setup",
        backToProfile: "Back to Profile",
        liveBusinessPage: "Live Business Page",
        livePreviewBtn: "Live Preview",
        liveFleetInventory: "Live Fleet Inventory",
        synchingProfileData: "Synching Profile Data...",
        editDetailsHint: "To edit details, go to settings",
        accountSettingsTitle: "Account Settings",
        settingsSubtitle: "Manage your profile, payments, and preferences",
        profileDetailsTab: "Profile Details",
        bankDetailsTab: "Bank Details",
        securityTab: "Security",
        notificationsTab: "Notifications",
        securitySettingsTitle: "Security Settings",
        securitySettingsDesc: "Change your password and manage session security.",
        resetPasswordBtn: "RESET PASSWORD",
        notifPrefTitle: "Notification Preferences",
        emailAlertsBookings: "Email alerts for new bookings",
        smsAlertsSettlement: "SMS alerts for payment settlement",
        accountInfoTitle: "Account Information",
        fullNameLbl: "Full Name",
        companyNameLbl: "Company Name",
        emailAddressLbl: "Email Address",
        mobileNumberLbl: "Mobile Number",
        stateLbl: "State",
        cityLbl: "City",
        businessNameLbl: "Business Name",
        businessTypeLbl: "Business Type",
        editProfile: "Edit Profile",
        companyAddressLbl: "Company Address",
        saveChangesBtn: "SAVE CHANGES",
        paymentSettlementTitle: "Payment Settlement",
        bankNameLbl: "Bank Name",
        bankNamePlaceholder: "e.g. HDFC Bank",
        accountNumberLbl: "Account Number",
        accountNumberPlaceholder: "Enter 12-16 digit account number",
        ifscCodeLbl: "IFSC Code",
        ifscCodePlaceholder: "e.g. HDFC0001234",
        settlementNote: "* Payments will be settled every Friday for the previous week's completed trips.",
        updateBankDetailsBtn: "UPDATE BANK DETAILS",
        settlementHistoryTitle: "Settlement History",
        last30Days: "Last 30 Days",
        colDateSettlement: "Date",
        colReference: "Reference",
        colAmountSettlement: "Amount",
        colStatusSettlement: "Status",
        loadingHistory: "Loading History...",
        noSettlementsObserved: "No settlements observed for completed trips in the last 30 days.",
        pendingLbl: "Pending",
        settledLbl: "Settled",
        processingStatusLbl: "Processing",
        totalRevenueLbl: "Total Revenue",
        onTripFleetLbl: "On-Service Fleet",
        vsLastMonth: "vs last month",
        cumulativeEarnings: "Cumulative Earnings",
        withdrawBtn: "Withdraw",
        thisWeekLbl: "This Week",
        fromLastSession: "from last session",
        profitMarginLbl: "Profit Margin",
        calculatedRealtime: "Calculated Real-time",
        earningsPerformance: "Earnings Performance",
        revenueOverTime: "Revenue over time (Weekly View)",
        downloadDetailedReport: "Download Detailed Report",
        observingPerformance: "Observing Performance...",
        earningsVisualizationHint: "Earnings visualization will appear once trips are completed",
        withdrawFundsTitle: "Withdraw Funds",
        transferToBank: "Transfer to registered bank",
        availableForWithdrawal: "Available for Withdrawal",
        withdrawalAmountLbl: "Withdrawal Amount",
        fundsTransferNote: "Funds will be credited to your verified bank account ending in ** 4582 within 24-48 business hours.",
        confirmWithdrawalBtn: "Confirm Withdrawal",
        requestSuccessful: "Request Successful",
        withdrawalInitiated: "Your withdrawal request of ₹{{amount}} has been initiated.",
        driverDirectory: "Driver Directory",
        driverDirectorySub: "Manage your fleet personnel, view details, and onboard new drivers.",
        searchDriversPh: "Search drivers...",
        addDriver: "Add Driver",
        noDriversFound: "No Drivers Found",
        noDriversFoundSub: "You don't have any drivers registered in your company yet. Add your first driver to get started.",
        addFirstDriver: "Add First Driver",
        noMatchFound: "No Match Found",
        adjustSearchCriteria: "Try adjusting your search criteria.",
        vehicleAvailabilityTip: "Tip: Please update your vehicle's availability regularly. Vehicles marked as 'Maintenance' or 'Service' are hidden from customer search!",
        paymentPending: "Payment Pending",
        cancelledShipments: "Cancelled",
        recentShipments: "Recent Shipments",
        searchKnowledgeBase: "Search knowledge base...",
        searchKnowledgeHint: "Search tickets, FAQs, and help articles",
        quickContactOptions: "Quick Contact Options",
        callSupport: "Call Support",
        whatsAppSupport: "WhatsApp Support",
        emailSupport: "Email Support",
        liveSupport: "Live Support",
        connectToAgent: "Connect to Agent →",
        yourAccountManager: "Your Account Manager",
        relationshipManager: "Relationship Manager",
        supportHours: "Support Hours",
        emergencyHelpline: "Emergency Helpline",
        currentPasswordLbl: "Current Password",
        newPasswordLbl: "New Password",
        updatePasswordBtn: "Update Password",
        enterOtpFromEmail: "Enter OTP from Email",
        verifyConfirmBtn: "Verify & Confirm",
        emailAlertsLbl: "Email Alerts",
        emailAlertsSub: "Booking and trip updates via email",
        smsAlertsLbl: "SMS Alerts",
        smsAlertsSub: "Critical alerts via text message",
        whatsAppAlertsLbl: "WhatsApp Alerts",
        whatsAppAlertsSub: "Updates via WhatsApp",
        changeEmailAddress: "Change Email Address",
        updateEmailAddress: "Update Email Address",
        newEmailAddressPh: "New Email Address",
        sendOtpBtn: "Send OTP",
        verifyApplyBtn: "Verify & Apply",
        requestChangeBtn: "Request Change",
        frequentlyAskedQuestions: "Frequently Asked Questions",
        questionsLabel: "Questions",
        questionLabel: "Question",
        noQuestionsFound: "No questions found",
        tryDifferentKeywords: "Try different keywords or raise a support ticket.",
        activeTickets: "Active Tickets",
        activeCountLabel: "Active",
        createNewTicketBtn: "Create New Ticket",
        faq1Q: "How do I add a new vehicle to the KaroTrukk network?",
        faq1A: "Navigate to the \"Fleet Management\" module on your dashboard and select \"Add New Vehicle\". You will need to provide the registration number, permit details, and clear scans of the RC and insurance documents. Verification is typically completed within 2 hours.",
        faq2Q: "How do I assign a driver to a specific vehicle?",
        faq2A: "Access the \"Fleet Management\" module and select the desired vehicle. Click \"Assign Driver\" to select an existing verified driver from your roster, or onboard a new driver by submitting their commercial licence details.",
        faq3Q: "What is the standard payment settlement cycle?",
        faq3A: "Payments are settled directly to your verified bank account. Advance payments (if negotiated) are processed upon dispatch, and the remaining balance is settled within 24-48 hours of successful proof of delivery (POD) upload.",
        faq4Q: "How do I request an advance payment for a trip?",
        faq4A: "Advance payments can be requested during the acceptance phase of a shipment. The exact percentage is negotiated directly with the client and processed securely through the KaroTrukk system.",
        faq5Q: "How can I update my registered bank account details?",
        faq5A: "Navigate to Settings > Bank Details. For security reasons, changes to financial information require OTP verification and a manual review by our support team to prevent unauthorized modifications.",
        faq6Q: "What documents are required for initial verification?",
        faq6A: "To activate your account, you must upload your PAN Card, GST Certificate (if applicable), Bank Proof (Cancelled Cheque/Passbook), and Aadhaar Card. All documents must be clear, legible, and match your registered business name.",
        faq7Q: "How does the live shipment tracking work?",
        faq7A: "Active shipments are automatically tracked via the driver's mobile application or your vehicle's integrated GPS system. Real-time telemetry is visible on your dashboard under the \"Shipments\" module.",
        faq8Q: "What is the protocol for client-initiated cancellations?",
        faq8A: "If a client cancels a confirmed dispatch, you will be notified instantly via SMS and email. Cancellation compensation is automatically calculated based on the time elapsed and advance paid, as per our standardized terms of service.",
        faq9Q: "How do I communicate with a client during transit?",
        faq9A: "Direct communication channels are unlocked once a shipment is active. You can find the client's authorized contact number in the active shipment details panel to coordinate loading or unloading operations.",
        faq10Q: "Is there a limit to the number of vehicles I can register?",
        faq10A: "No, KaroTrukk supports infinite fleet scaling. You can manage a single truck or a massive enterprise fleet of hundreds of vehicles from a single unified dashboard.",
        myShipments: "My Shipments",
        activeCompletedTransits: "Active & Completed Transits",
        trackLiveVehicleRoutesDesc: "Track live vehicle routes, driver assignment logs, and POD verification details after booking acceptance",
        filterByDate: "Filter By Date",
        selectDate: "Select Date",
        arrivingTab: "ARRIVING",
        onServiceTab: "ON SERVICE",
        completedTab: "COMPLETED",
        noTransitsDiscovered: "No Transits Discovered",
        noActiveShipmentsInState: "There are no active shipments currently in this state.",
        showDetails: "Show Details",
        hideDetails: "Hide Details",
        liveStatusUpdate: "Live Status Update",
        progress: "Progress",
        podVerified: "POD Verified",
        viewPod: "View POD",
        proofOfDelivery: "Proof of Delivery (POD)",
        podNotVerifiedByYou: "Not verified by you",
        verifyNow: "Verify Now",
        podNotReceivedYet: "POD not received yet",
        liveTrack: "Live Track",
        awaitingPlate: "Awaiting Plate",
        assigningDriver: "Assigning Driver...",
        paymentsAndInvoices: "Payments & Invoices",
        totalSpentThisMonth: "Total Spent (This Month)",
        basedOnCompletedPayments: "Based on completed payments",
        pendingInvoices: "Pending Invoices",
        awaitingPayment: "Awaiting payment",
        gstRecords: "GST Records",
        updateInProfileSettings: "Update in profile settings",
        paymentHistory: "Payment History",
        downloadInvoices: "Download Invoices",
        gstBills: "GST Bills",
        notifications: "Notifications",
        markAllRead: "Mark All Read",
        noNotificationsYet: "No notifications yet",
        loadingNotifications: "Loading notifications...",
        reserveVehicle: "Reserve Vehicle",
        confirmReservation: "Confirm Reservation",
        cancel: "Cancel",
        submitting: "Submitting...",
        careersAtKaroTrukk: "Careers at KaroTrukk",
        careersHeroSub: "Join us in building the future of logistics. We're looking for passionate individuals to help us scale across India.",
        openPositions: "Open Positions",
        applyNow: "Apply Now",
        waterTankersOnDemand: "Water Tankers On Demand",
        waterSupplySub: "Home, Construction & Commercial Water Supply",
        waterSupplyDesc: "Fast water tanker delivery for homes, swimming pools, borewell support, and construction sites with verified local fleet partners.",
        fastLocalDispatch: "Fast Local Dispatch",
        verifiedTankerFleet: "Verified Tanker Fleet",
        liveDriverTracking: "Live Driver Tracking",
        orderTanker: "Order Tanker",
        whoUsesKaroTrukk: "Who Uses KaroTrukk?",
        whoUsesKaroTrukkDesc: "Serving diverse customer needs across residential, commercial, and site projects.",
        homeowners: "Homeowners",
        builders: "Builders",
        contractors: "Contractors",
        factories: "Factories",
        warehouses: "Warehouses",
        shops: "Shops",
        eventOrganizers: "Event Organizers",
        farmers: "Farmers",
        whatWeDo: "What We Do",
        whatWeDoDesc: "Cab-style hail booking for JCBs and equipment machineries in just a few steps. Fast, verified, and direct.",
        everydayJobsTitle: "Everyday Jobs We Help With",
        moreVehicles: "More Vehicles",
        signInToViewAll: "Sign in to View All →",
        touchAndDragToScroll: "← Touch & Drag to Scroll →",
        moreArrow: "More →",
        forCustomers: "For Customers",
        forCustomersDesc: "Book JCBs and equipment machineries on demand. Submit your request digitally and get connected in minutes.",
        forFleetPartners: "For Fleet Partners",
        forFleetPartnersDesc: "List your JCBs and equipment machineries. Receive direct booking requests and maximize daily utilization.",
        howWeConnect: "How We Connect",
        howWeConnectDesc: "JCB and equipment booking made simple in 4 steps.",
        step1Title: "Choose Machinery",
        step1Desc: "Select the JCB or equipment machinery needed for your work.",
        step2Title: "Request Booking",
        step2Desc: "Submit your requirement in a few steps.",
        step3Title: "Get Connected",
        step3Desc: "Matched with verified available fleet partners.",
        step4Title: "Get Work Moving",
        step4Desc: "Confirm your booking and start work on site.",
        whyWeDoIt: "Why We Do It",
        whyWeDoItDesc: "Construction and infrastructure projects depend on timely access to the right equipment. KaroTrukk was created to make machinery access simpler, transparent and digitally accessible across India.",
        ourMission: "Our Mission",
        ourMissionDesc: "To simplify access to construction machinery and heavy equipment through an accessible, dependable booking experience.",
        ourVision: "Our Vision",
        ourVisionDesc: "To build a trusted platform that makes construction machinery booking more convenient across India.",
        ourCommitment: "Our Commitment",
        ourCommitmentDesc: "Built around convenience. Focused on reliable service, upfront clarity, and verified fleet partners.",
        whoWeAre: "Who We Are",
        whoWeAreSub: "India's first cab-style hail booking platform for JCBs and equipment machineries.",
        jcbsEarthmoving: "JCBs & Earthmoving Equipment",
        equipmentMachineries: "Equipment Machineries",
        verifiedFleetPartners: "Verified Fleet Partners",
        heavyTrucksTitle: "Heavy Trucks & Commercial Vehicles",
        heavyTrucksDesc: "Rent commercial trucks, LCVs, tippers, and trailers for industrial logistics and transport.",
        constructionVehiclesTitle: "Construction Vehicles & Earthmovers",
        constructionVehiclesDesc: "Rent verified JCBs, excavators, cranes, and compactor rollers for your construction site.",
        equipmentRentalsPageTitle: "Equipment Rentals",
        equipmentRentalsPageDesc: "Industrial generators, compressors, and specialized lifting machinery available on demand.",
        noEquipmentFound: "No equipment found in this category.",
        loadingEquipment: "Loading equipment...",
        aboutUsTitle: "About Us",
        aboutLead: "KaroTrukk is an on-demand technology platform created to make hiring JCBs, excavators, and heavy construction equipment direct, reliable, and transparent across India.",
        theProblem: "The Problem",
        theProblemP1: "Sourcing heavy construction machinery across India has historically been fragmented and inefficient. Sourcing a dependable JCB, excavator, tipper, or crane typically involves multiple brokers, unpredictable rates, and uncertain machine availability.",
        theProblemP2: "For machinery owners, costly assets often sit idle between contracts without steady demand. For contractors and site engineers, delayed machinery arrivals halt project timelines and increase expenses.",
        theSolution: "The Solution",
        theSolutionP1: "KaroTrukk introduces a unified digital marketplace. We connect contractors, builders, and developers directly with verified fleet partners.",
        theSolutionP2: "By removing middlemen markups and providing direct matching, KaroTrukk ensures fair pricing, rapid dispatch, and reliable execution on site.",
        onDemandDispatch: "On-Demand Dispatch",
        onDemandDispatchDesc: "Book JCBs, excavators, tippers, and cranes for your job site directly in just a few steps.",
        transparentTerms: "Transparent Terms",
        transparentTermsDesc: "Direct connection between clients and equipment owners with zero hidden broker fees.",
        verifiedPartnersPillar: "Verified Partners",
        verifiedPartnersPillarDesc: "Every equipment partner is verified to ensure dependable machine quality and professional site delivery.",
        leadership: "Leadership",
        founderRole: "Founder & Chief Executive Officer (CEO)",
        founderBio1: "Jaffar Saahussain founded KaroTrukk to solve the operational friction and inefficiencies in India’s heavy vehicle and construction machinery rental ecosystem.",
        founderQuote: "\"Our objective is straightforward: eliminate machine downtime for equipment owners, and give contractors the ability to book verified heavy machinery with the same ease and transparency as booking a cab. We are building this platform from the ground up on honest utility, reliability, and technology.\"",
        founderBio2: "As Founder & CEO, Jaffar oversees product development, technology, and fleet partner operations across India.",
        getStartedKaroTrukk: "Get Started with KaroTrukk",
        bookOrRegisterToday: "Book machinery for your site or register your fleet today.",
        joinAsFleetPartner: "Join as Fleet Partner",
        getInTouch: "Get in Touch",
        haveQuestionsAssistance: "Have questions about booking equipment or joining as a fleet partner? We're here to assist you.",
        directInquiries: "Direct Inquiries",
        connectOpsTeamDesc: "Connect with the KaroTrukk operations and onboarding team. We assist contractors and fleet partners across India.",
        corporateOffice: "Corporate Office",
        fleetPartnerDesk: "Fleet Partner Desk",
        platformNotice: "Platform Notice",
        platformNoticeDesc: "For immediate emergency site booking or partner onboarding queries, submit your message below and our team will connect directly.",
        connectWithKaroTrukk: "Connect with KaroTrukk",
        reachingOutAs: "I am reaching out as",
        optClient: "Client (Need to Book JCB / Heavy Machinery)",
        optFleetPartner: "Fleet Partner (Equipment / Truck Owner)",
        optEnterprise: "Enterprise / Infrastructure Contractor",
        optGeneralInquiry: "General Inquiry",
        fullName: "Full Name",
        enterYourName: "Enter your name",
        emailAddress: "Email Address",
        phoneWhatsApp: "Phone / WhatsApp Number",
        subject: "Subject",
        briefSubject: "Brief subject of inquiry",
        message: "Message",
        describeRequirement: "Describe your equipment requirement or fleet details...",
        sendInquiry: "Send Inquiry",
        thankYouContact: "Thank you for contacting us! We will get back to you shortly.",
        howCanWeHelp: "How Can We Help?",
        searchHelpInput: "Search questions (e.g., booking JCB, fleet partner, tracking)...",
        machineryBooking: "Machinery Booking",
        machineryBookingDesc: "JCBs, excavators, tippers & cranes",
        fleetPartnerNetwork: "Fleet Partner Network",
        fleetPartnerNetworkDesc: "Vehicle onboarding & verification",
        siteDispatchGps: "Site Dispatch & GPS",
        siteDispatchGpsDesc: "Live tracking & route telematics",
        directBilling: "Direct Billing",
        directBillingDesc: "0% broker markups & payments",
        helpFaq1Q: "How does cab-style hail booking work on KaroTrukk?",
        helpFaq1A: "KaroTrukk operates like an on-demand cab-style hail booking service tailored for construction machinery. You select the equipment you need (JCB Backhoe Loader, Excavator, Tipper, Crane, or Tanker), provide your site address and schedule, and get connected directly with verified available fleet partners in your area in just a few clicks.",
        helpFaq2Q: "What types of machinery and heavy vehicles can I book?",
        helpFaq2A: "You can book a wide range of verified equipment including JCB & Backhoe Loaders, Mini & Heavy Excavators, Dump Trucks & Tippers, Mobile Cranes & Lifting Units, Water Tankers, and Commercial Logistics Trucks for construction, site grading, excavation, and industrial material transit.",
        helpFaq3Q: "How do vehicle and equipment owners join as Fleet Partners?",
        helpFaq3A: "Machinery owners can register by clicking 'Join as a Fleet Partner'. You enter your vehicle details, RC, fitness documents, and service location. Once verified by our onboarding team, you start receiving direct digital booking requests on your dashboard with zero middlemen.",
        helpFaq4Q: "Are there any hidden broker commissions or middleman markups?",
        helpFaq4A: "No. KaroTrukk is built on radical transparency with a 0% hidden middleman markup policy. Contractors and equipment owners interact with transparent terms and direct settlements, eliminating traditional unorganized broker cuts.",
        helpFaq5Q: "How does site dispatch and tracking work?",
        helpFaq5A: "Once a fleet partner accepts your booking request, you can monitor the vehicle's assignment and real-time transit status through your dashboard, keeping project managers and site engineers updated with precise arrival timing.",
        helpFaq6Q: "Who founded and operates KaroTrukk?",
        helpFaq6A: "KaroTrukk is founded by Jaffar Saahussain (Founder & CEO). The platform is dedicated to digitizing India's heavy vehicle and construction machinery rental ecosystem with on-demand booking and transparent pricing.",
        haveSpecificQuery: "Have a Specific Site or Fleet Query?",
        opsTeamAssistance: "Our dedicated operations team is ready to assist contractors and machinery owners.",
        contactOpsTeam: "Contact Operations Team",
        verifiedPartner: "Verified Partner",
        driverIncluded: "Driver Included",
        helperIncluded: "Helper Included",
        kmAway: "km away",
        quoteOnRequest: "Quote on Request",
        rentalRate: "Rental Rate",
        featureComesSoon: "This feature is coming soon.",
        book: "Book",
        rentalRateNotice: "Rental Rate Notice",
        rateForRentingTime: "Rate is for rental time, not a one-way trip",
        rateForRentingTimeDesc: "The displayed price is the hourly or daily rental rate for the vehicle and equipment on your site.",
        notOneWayTrip: "Not a standard taxi ride",
        notOneWayTripDesc: "Heavy machinery stays on your site for the duration of the work required.",
        gotIt: "Got It",
        getEquipmentInstantly: "Get heavy machinery & transport vehicles on-demand",
        whatDoYouNeedToday: "What do you need today?",
        heavyVehicles: "Heavy Vehicles",
        constructionMachinery: "Construction Machinery",
        tankers: "Tankers",
        equipmentSiteMachinery: "Equipment & Site Machinery",
        lcvsTippers: "LCVs, Tippers, Trucks",
        jcbsExcavators: "JCBs, Excavators, Loaders",
        waterTankerSewage: "Water & Sewage Tankers",
        generatorsAirCompressors: "Generators, Compressors",
        siteArrivalLocation: "Site / Arrival Location",
        dropoffLocation: "Drop-off Location (Optional)",
        popularHouseholdServices: "Popular Everyday Services",
        landGardenCleaning: "Site & Land Cleaning",
        moveYourLoad: "Move Your Load",
        tankFillingWaterDelivery: "Water Tanker Delivery",
        pathHoleDebrisFilling: "Pothole & Debris Filling",
        generatorRental: "Generator Rental",
        landLevelling: "Land Levelling",
        availableNearYou: "Available Near You",
        discoveredWithinRadar: "Discovered within 0-20 km radar",
        heavyTab: "Heavy Trucks",
        constructionTab: "Construction",
        tankerTab: "Tankers",
        equipmentTab: "Equipment",
        noVehiclesNearby: "No vehicles found in this category nearby",
        noVehiclesNearbyDesc: "Try switching category or expanding your location search",
        home: "Home",
        forContractors: "For Contractors",
        requestQuote: "Request Quote",
        accountMenu: "Account Menu",
        back: "Back",
        bookNowInstant: "Book Machinery Instant",
        requestQuoteService: "Request Custom Quote",
        paymentsInvoices: "Payments & Invoices",
        favoritePartners: "Favorite Partners",
        supportCenter: "Support Center",
        myBusiness: "My Bookings & Business",
        expectedRent: "Expected Rent",
        day: "day",
        processing: "Processing...",
        reserveThisVehicle: "Reserve This Vehicle",
        reservationSent: "Reservation Request Sent!",
        confirmCancelTitle: "Cancel Booking",
        confirmCancel: "Are you sure you want to cancel this booking?",
        notApprovedNotice: "Your account is pending verification. Our onboarding team is reviewing your documents.",
        newOrders: "New Orders",
        completeProfileNotice: "Complete Profile",
        drivers: "Drivers",
        lightMode: "Light Mode",
        darkMode: "Dark Mode",
        totalFleet: "Total Fleet",
        onServiceTrips: "On-Service Trips",
        completedShipmentsStat: "Completed Shipments",
        viewAll: "View All",
        payment: "Payment",
        contact: "Contact",
        confirmDeleteTitle: "Delete Vehicle",
        delete: "Delete",
        profileDetailsSub: "Manage your profile details and business contact information",
        yardSettingsTab: "Yard Location",
        yardSettingsSub: "Configure your base yard and dispatch radius",
        bankDetailsSub: "Manage settlement accounts for automated weekly payouts",
        securitySub: "Update your account password and security preferences",
        notificationsSub: "Configure SMS, WhatsApp and portal alert preferences",
        saving: "Saving...",
        linkCopiedSuccess: "Tracking link copied to clipboard!",
        shareFailed: "Failed to share link",
        login: "Login",
        joinNow: "Join Now",
        maximizeRevenue: "Maximize Fleet Earnings",
        fleetRevenue: "Fleet Revenue",
        fleetHeroSub: "Connect your JCBs, excavators, tippers, and cranes with thousands of verified contractors and builders across India.",
        startEarningToday: "Start Earning Today",
        watchHowItWorks: "Watch How It Works",
        fleetPartners: "Fleet Partners",
        activeLoads: "Active Loads",
        citiesCovered: "Cities Covered",
        payoutsDisbursed: "Payouts Disbursed",
        helpCenter: "Help Center",
        rentNow: "Rent Now",
        noWaterTankersAvailable: "No water tankers available at the moment.",
        loadingWaterTankers: "Loading water tankers...",
        servicesNav: "Services",
    },
    ta: {
        client: "வாடிக்கையாளர்",
        fleetPartner: "வாகன உரிமையாளர்",
        dashboard: "டேஷ்போர்டிற்குச் செல்",
        aboutUs: "எங்களைப் பற்றி",
        help: "உதவி",
        contactUs: "எங்களைத் தொடர்பு கொள்ளவும்",
        logout: "வெளியேறு",
        heroTitle1: "ஜேசிபி & இயந்திரங்கள்,",
        heroTitle2: "சில படிகளில் முன்பதிவு செய்யுங்கள்.",
        heroSub: "ஜேசிபி மற்றும் உபகரண இயந்திரங்களை சில படிகளில் புக் செய்யும் இந்தியாவின் முதல் தளம்.",
        bookVehicle: "வாகனத்தை முன்பதிவு செய்",
        joinFleet: "வாகன உரிமையாளராக சேரவும்",
        hireTrucksTitle: "டிரக்குகள் & இயந்திரங்களை வாடகைக்கு எடுக்க",
        enterPickupLocation: "பிக்அப் இருப்பிடத்தை உள்ளிடவும்",
        enterDropLocation: "இறக்கும் இருப்பிடத்தை உள்ளிடவும்",
        getPriceQuotes: "விலை மேற்கோள்களைப் பெறுங்கள்",
        onePlatform: "அனைத்து கனரக வாகன தேவைகளுக்கும் ஒரே தளம்",
        onePlatformSub: "முன்பதிவுகளை நிர்வகிக்கவும், வேலைகளைக் கண்காணிக்கவும் மற்றும் சரிபார்க்கப்பட்ட வாகன உரிமையாளர்களுடன் நேரடியாக இணைக்கவும் - இடைத்தரகர்கள் இல்லாமல்.",
        equipmentTitle: "உங்கள் அடுத்த திட்டத்திற்கான சரியான உபகரணங்களைக் கண்டறியவும்.",
        equipmentRentals: "உபகரணங்கள் வாடகை",
        viewAllEquipment: "அனைத்து உபகரண வகைகளையும் காண்க →",
        scissorLiftTitle: "சிசர் லிஃப்ட் வாடகை",
        scissorLiftDesc: "அவற்றின் நிலையான தளங்கள், அதிக சுமை திறன், பன்முகத்தன்மை மற்றும் விரிவான அணுகல் ஆகியவற்றால், கத்தரிக்கோல் லிஃப்ட் வணிக மற்றும் தொழில்துறை தளங்களின் வேலை செய்யும் குதிரைகள்.",
        generatorTitle: "ஜெனரேட்டர் வாடகை",
        generatorDesc: "கட்டுமான தளங்கள் மற்றும் தொழில்துறை தேவைகளுக்கான நம்பகமான மின் தீர்வுகள். சிறிய மற்றும் டிரெய்லர் ஏற்றப்பட்ட ஜெனரேட்டர்கள் கிடைக்கின்றன.",
        boomLiftTitle: "பூம் லிஃப்ட் வாடகை",
        boomLiftDesc: "கடினமான பகுதிகளை அடைவதற்கு வெளிப்படையான மற்றும் தொலைநோக்கி பூம் லிஃப்ட். கட்டுமானம் மற்றும் பராமரிப்பு பணிகளுக்கு ஏற்றது.",
        forkliftTitle: "ஃபோர்க்லிஃப்ட் & மெட்டீரியல் ஹேண்ட்லிங் வாடகை",
        forkliftDesc: "கிடங்குகள், கட்டுமான தளங்கள் and தொழில்துறை வசதிகளுக்கான திறமையான பொருள் கையாளுதல் தீர்வுகள்.",
        singleManLiftTitle: "ஒற்றை மனிதன் லிஃப்ட் வாடகை",
        singleManLiftDesc: "ஒற்றை ஆபரேட்டர் பயன்பாட்டிற்காக வடிவமைக்கப்பட்ட சிறிய செங்குத்து லிஃப்ட். பராமரிப்பு மற்றும் லேசான கட்டுமான பணிகளுக்கு ஏற்றது.",
        earthmovingTitle: "எர்த் மூவிங் உபகரணங்கள் வாடகை",
        earthmovingDesc: "அகழ்வாராய்ச்சி, தரப்படுத்தல் மற்றும் மண் வேலைகளுக்கான கனரக இயந்திரங்கள். மினி அகழ்வாராய்ச்சிகள் முதல் பெரிய டோசர் வரை.",
        compactionTitle: "கம்பாக்ஷன் உபகரணங்கள் வாடகை",
        compactionDesc: "சாலை கட்டுமானம் மற்றும் மண் சுருக்க இயந்திரங்கள். முறையான தரை தயாரிப்பு மற்றும் மேற்பரப்பு முடித்தலை உறுதி செய்யுங்கள்.",
        craneTitle: "கிரேன் வாடகை",
        craneDesc: "கட்டுமானம் மற்றும் தொழில்துறை திட்டங்களுக்கான அதிக எடை தூக்கும் தீர்வுகள். மொபைல் மற்றும் டவர் கிரேன்கள் உள்ளன.",
        equipmentId: "உபகரணங்கள் ஐடி",
        by: "மூலம்",
        setLocationRates: "கட்டணங்களைக் காண இருப்பிடத்தை அமைக்கவும்",
        showMore: "மேலும் காட்டு",
        details: "விவரங்கள்",
        waterTankerTitle: "தண்ணீர் டேங்கர் வேண்டுமா?",
        waterTankerSubTitle: "உங்களுக்கு அருகிலுள்ள தண்ணீர் டேங்கருடன் இணையுங்கள்",
        waterTankerDesc: "கட்டுமானம், நிகழ்வுகள், தொழில்துறை பயன்பாடு அல்லது அவசரத் தேவைக்கு தண்ணீர் வேண்டுமா? காரோட்ரக் உங்கள் பகுதியில் சரிபார்க்கப்பட்ட இயக்குநர்களை உடனடியாகக் கண்டறிந்து முன்பதிவு செய்ய உதவுகிறது.",
        fastAvailability: "வேகமான கிடைக்கும் தன்மை",
        flexibleCapacity: "நெகிழ்வான திறன்",
        transparentPricing: "வெளிப்படையான கட்டணங்கள்",
        reliablePartners: "நம்பகமான பங்காளிகள்",
        waterTankerServices: "தண்ணீர் டேங்கர் சேவைகள்",
        waterTankerServicesDesc: "உங்கள் அனைத்து தேவைகளுக்கும் நம்பகமான தண்ணீர் விநியோக தீர்வுகள். குடிநீர் முதல் கட்டுமான தள தேவைகள் வரை, சரியான திறனை உடனடியாக முன்பதிவு செய்யுங்கள்.",
        backToHome: "முகப்புக்குத் திரும்பு",
        bulkBookingTitle: "ஒற்றை அல்லது மொத்த கனரக வாகனங்களை முன்பதிவு செய்ய ஒரே தளம்",
        realTimeVisibilityTitle: "நிகழ்நேர தெரிவுநிலை",
        realTimeVisibilityDesc: "எங்கள் மேம்பட்ட ஜிபிஎஸ் ஒருங்கிணைப்புடன் உங்கள் பொருட்களின் ஒவ்வொரு இயக்கத்தையும் கண்காணிக்கவும். உங்கள் ஏற்றுமதி எங்குள்ளது என்பதை எப்போது வேண்டுமானாலும் தெரிந்து கொள்ளுங்கள்.",
        secureBusinessTitle: "பாதுகாப்பான வணிகம்",
        secureBusinessDesc: "கட்டுமான நிறுவனங்கள் மற்றும் வணிக உரிமையாளர்கள் ஒப்பந்ததாரர் கடற்படைகளைத் தேடலாம் மற்றும் டிரக்குகள் அல்லது இயந்திரங்களை நிமிடங்களில் முன்பதிவு செய்யலாம்.",
        dataDrivenTitle: "தரவு சார்ந்த நுண்ணறிவு",
        dataDrivenDesc: "பாதைகளை மேம்படுத்தவும், செலவுகளைக் குறைக்கவும் மற்றும் ஒட்டுமொத்த கடற்படை செயல்திறனை மேம்படுத்தவும் வரலாற்றுத் தரவு மற்றும் முன்கணிப்பு பகுப்பாய்வுகளைப் பயன்படுத்துங்கள்.",
        gpsTrackingTitle: "முழு மன அமைதிக்கான நிகழ்நேர கண்காணிப்பு",
        gpsTrackingDesc: "காரோஸ் ஸ்டோரிலிருந்து தொழில்துறையில் முன்னணியில் உள்ள ஜிபிஎஸ் தொழில்நுட்பத்தின் மூலம் உங்கள் சொத்துக்களைப் பாதுகாக்கவும் மற்றும் செயல்திறனை அதிகரிக்கவும். திருட்டு தடுப்பு முதல் எரிபொருள் மேம்படுத்தல் வரை, உங்கள் டிரக்குகளைக் கண்காணிப்பது இப்போது மிகவும் எளிது.",
        liveGeofencing: "நேரடி ஜியோஃபென்சிங் மற்றும் உடனடி விழிப்பூட்டல்கள்",
        routeHistory: "பாதை வரலாறு மற்றும் எரிபொருள் மேம்படுத்தல்",
        durableHardware: "சிறிய, நீர்ப்புகா மற்றும் நீடித்த வன்பொருள்",
        shopNow: "KarossStore.in இல் ஷாப்பிங் செய்யுங்கள்",
        testimonials: "சான்றுகள்",
        testimonialsSub: "மக்கள் என்ன சொல்கிறார்கள் என்பது இங்கே",
        company: "நிறுவனம்",
        quickLinks: "விரைவு இணைப்புகள்",
        support: "ஆதரவு",
        countries: "நாடுகள்",
        tnCities: "தமிழ்நாடு நகரங்கள்",
        allRightsReserved: "அனைத்து உரிமைகளும் பாதுகாக்கப்பட்டவை.",
        followUs: "எங்களைப் பின்தொடரவும்",
        careers: "தொழில்",
        blog: "வலைப்பதிவு",
        privacyPolicy: "தனியுரிமைக் கொள்கை",
        termsOfService: "சேவை விதிமுறைகள்",
        insuranceFaqs: "காப்பீடு அடிக்கடி கேட்கப்படும் கேள்விகள்",
        clientTitle: "வாடிக்கையாளர்",
        clientDesc: "காரோட்ரக் மூலம் உங்கள் திட்ட தளவாடங்களில் புரட்சியை ஏற்படுத்துங்கள். உங்களுக்கு ஒரு நாளைக்கு ஒரு ஜேசிபி அல்லது பெரிய அளவிலான கட்டுமானத் திட்டத்திற்கு கனரக டிரக்குகள் தேவைப்பட்டாலும், எங்கள் தளம் உங்களை சரிபார்க்கப்பட்ட உரிமையாளர்களுடன் உடனடியாக இணைக்கிறது.",
        fleetTitle: "வாகன உரிமையாளர்",
        fleetDesc: "உங்கள் கனரக இயந்திரங்களை வேலைக்கு அமர்த்தி உங்கள் வருமானத்தை அதிகரிக்கவும். காரோட்ரக் ஜேசிபி, கிரேன் மற்றும் டிரக் உரிமையாளர்களை நிலையான, அதிக மதிப்புள்ள திட்டங்களுடன் இணைக்கிறது.",
        trackVehicles: "உங்கள் செயலில் உள்ள வாகனங்​களைக் கண்​காணிக்​கவும்",
        track: "கண்காணி",
        needVehicle: "வாகனம் வேண்டுமா?",
        bookRentalSub: "இப்போது வாடகை அல்லது விரைவான பயணத்தை முன்பதிவு செய்யுங்கள்.",
        bookRentalSubDesc: "இந்தியா முழுவதும் ஆயிரக்கணக்கான சரிபார்க்கப்பட்ட கூட்டாளர்களை அணுகவும்.",
        trackVehiclesDesc: "உங்கள் ஏற்றுமதிகள் மற்றும் செயலில் உள்ள முன்பதிவுகளை நிகழ்நேரத்தில் கண்காணிக்கவும்.",
        bookNow: "இப்போது முன்பதிவு செய்",
        searchByCompany: "நிறுவனம் மூலம் தேடுங்கள்",
        trustCompanies: "நீங்கள் நம்பும் நிறுவனங்களுடன் முன்பதிவு செய்யுங்கள்",
        searchPlaceholder: "நிறுவனங்களைத் தேடுங்கள்...",
        search: "தேடு",
        availableVehicles: "கிடைக்கக்கூடிய வாகனங்கள்",
        premiumSolutions: "இந்தியா முழுவதும் பிரீமியம் தளவாட தீர்வுகள்",
        filterBy: "வடிகட்டவும்",
        viewDetails: "விவரங்களைக் காண்க",
        reserveNow: "இப்போதே முன்பதிவு செய்",
        requestedBookings: "கோரப்பட்ட முன்பதிவுகள்",
        acceptedBookings: "ஏற்கப்பட்ட முன்பதிவுகள்",
        pastBookings: "கடந்த கால முன்பதிவுகள்",
        bookingsCount: "முன்பதிவுகள்",
        locateFleet: "உங்கள் வாகனக் குழுவைக் கண்டறியவும்",
        personalSolutions: "அனைவருக்கும் நம்பகமான விநியோக தீர்வுகள்",
        searchTypePlaceholder: "வாகன வகை அல்லது மாடல் மூலம் தேடுங்கள்...",
        matchesFound: "பொருத்தங்கள் கண்டறியப்பட்டன",
        personalAccount: "தனிப்பட்ட கணக்கு",
        businessAccount: "வணிக கணக்கு",
        trackFleetTab: "கண்காணிப்பு",
        bookingsTab: "முன்பதிவுகள்",
        shipmentsTab: "என் சரகுகள்",
        dashboardTab: "டேஷ்போர்டு",
        menu: "பட்டியல்",
        myBookings: "எனது முன்பதிவுகள்",
        premiumPass: "பிரீமியம் பாஸ்",
        liveMap: "நேரடி வரைபடம்",
        liveTracking: "நேரடி கண்காணிப்பு",
        inbox: "உள்பெட்டி",
        documents: "ஆவணங்கள்",
        settings: "அமைப்புகள்",
        account: "கணக்கு",
        theme: "தீம்",
        supportChat: "ஆதரவு அரட்டை",
        signOut: "வெளியேறு",
        bookTruck: "டிரக் முன்பதிவு",
        construction: "கட்டுமானம்",
        gpsTrackers: "ஜிபிஎஸ் டிராக்கர்ஸ்",
        onlyClientCanBook: "வாடிக்கையாளர் மட்டுமே சேவைகளை முன்பதிவு செய்ய முடியும்",
        myProfile: "எனது சுயவிவரம்",
        dashboardText: "டேஷ்போர்டு",
        requests: "கோரிக்கைகள்",
        returnLoad: "திரும்பும் சுமை",
        fleetManagement: "வாகன மேலாண்மை",
        shipments: "ஏற்றுமதிகள்",
        routePlanning: "பாதை திட்டமிடல்",
        analytics: "பகுப்பாய்வு",
        history: "வரலாறு",
        reviews: "விமர்சனங்கள்",
        settlement: "தீர்வு",
        font: "எழுத்துரு",
        searchVehicle: "வாகன எண்ணைத் தேடுக...",
        partnerDashboard: "பார்ட்னர் டேஷ்போர்டு",
        planRoute: "பாதை திட்டம்",
        loadingDashboard: "டேஷ்போர்டை ஏற்றுகிறது...",
        vsYesterday: "நேற்றோடு ஒப்பிடுகையில்",
        performanceAnalytics: "செயல்திறன் பகுப்பாய்வு",
        analyticsSubtitle: "உங்கள் வாகன செயல்பாடுகள் மற்றும் வருவாய் குறித்த ஆழமான நுண்ணறிவுகள்",
        operationalMetrics: "செயல்பாட்டு அளவீடுகள்",
        active: "செயலில்",
        idle: "சும்மா",
        service: "சேவை",
        noVehicles: "வாகனங்கள் இல்லை",
        fleetUtilization: "வாகன பயன்பாடு",
        awaitingFleetData: "வாகன தரவுக்காக காத்திருக்கிறது",
        addVehiclesToTrack: "பயன்பாட்டைக் கண்காணிக்க வாகனங்களைச் சேர்க்கவும்",
        units: "அலகுகள்",
        weeklyRevenue: "வாராந்திர வருவாய்",
        realTimeEarningsByDay: "நாள் வாரியான நிகழ்நேர வருவாய்",
        noDataAvailableThisWeek: "இந்த வாரம் தரவு கிடைக்கவில்லை",
        last7Days: "கடந்த 7 நாட்கள்",
        waitingForData: "தரவுக்காக காத்திருக்கிறது...",
        totalVehicles: "மொத்த வாகனங்கள்",
        acceptedRequestsDash: "ஏற்றுக்கொள்ளப்பட்ட கோரிக்கைகள்",
        onTripBookings: "பயணத்தில் உள்ள முன்பதிவுகள்",
        totalEarnings: "மொத்த வருவாய்கள்",
        fullScreen: "முழுத்திரை",
        fleetLiveTrack: "நேரடி கண்காணிப்பு",
        earnings: "வருவாய்கள்",
        thisMonth: "இந்த மாதம்",
        onTrip: "பயணத்தில்",
        potentialPending: "சாத்தியமான/நிலுவையில் உள்ள",
        realTimeGrowth: "நிகழ்நேர வளர்ச்சி",
        viewStatement: "அறிக்கையைக் காண்க",
        fleetStatus: "வாகன நிலை",
        vehiclesCount: "வாகனங்கள்",
        online: "நிகழ்நிலையில்",
        deliveryPerformance: "டெலிவரி செயல்பாடு",
        weekly: "வாரம்",
        waitingPerformanceData: "செயல்திறன் தரவுக்காக காத்திருக்கிறது",
        completeFirstTrip: "பகுப்பாய்வுகளைத் திறக்க உங்கள் முதல் பயணத்தை முடிக்கவும்",
        orderStatus: "ஆர்டர் நிலை",
        calculatingStatus: "நிலையை கணக்கிடுகிறது...",
        yourVehiclesOverview: "உங்கள் வாகனங்களின் கண்ணோட்டம்",
        total: "மொத்தம்",
        ratings: "மதிப்பீடுகள்",
        noVehiclesActive: "வாகனங்கள் எதுவும் செயலில் இல்லை. ஒன்றைச் சேர்ப்பதன் மூலம் தொடங்கவும்!",
        youLabel: "நீங்கள்",
        onTripManagement: "பயண மேலாண்மை",
        bookingLabel: "முன்பதிவு:",
        inTransit: "பயணத்தில்",
        confirmed: "உறுதிப்படுத்தப்பட்டது",
        stepLabel: "படி",
        clientLabel: "வாடிக்கையாளர்:",
        earningsLabel: "வருவாய்கள்:",
        startedLabel: "தொடங்கப்பட்டது:",
        endingLabel: "முடியும்:",
        markDelivered: "வழங்கப்பட்டதாக குறி",
        contactAction: "தொடர்பு கொள்க",
        reportAction: "அறிக்கை செயல்",
        activeStatusObj: "● செயலில்",
        ratingLabel: "மதிப்பீடு",
        bookingsLabel: "முன்பதிவுகள்",
        needLabel: "தேவை",
        priceLabel: "விலை",
        routeLabel: "பாதை",
        profitabilityLabel: "லாபதன்மை",
        viewDetailsAction: "விவரங்களைக் காண்க",
        acceptAction: "ஏற்றுக்கொள்ளுங்கள்",
        routeLocations: "பாதை மற்றும் இடங்கள்",
        arrivalPickup: "வருகை (பிக்அப்)",
        viewInMap: "வரைபடத்தில் காண்க",
        targetDropoff: "இலக்கு (இறக்கும் இடம்)",
        localDelivery: "உள்ளூர் டெலிவரி",
        datesTimeline: "தேதிகள் மற்றும் நேரவரிசை",
        pickupLabel: "பிக்அப்",
        estimatedCompletion: "கணிக்கப்பட்ட முடித்த நேரம்",
        cargoDetails: "சரக்கு விவரங்கள்",
        typeLabel: "வகை",
        weightLabel: "எடை",
        offeredPrice: "வழங்கப்பட்ட விலை",
        distanceArrivalTarget: "தூரம் (வருகை முதல் இலக்கு வரை)",
        fuelRequired: "தேவையான எரிபொருள் (@ 7 KM/L)",
        totalEstimatedCost: "மொத்த மதிப்பிடப்பட்ட செலவு",
        netProfit: "நிகர லாபம்",
        marginLabel: "லாபம்",
        clientTrust: "வாடிக்கையாளர் நம்பிக்கை",
        securedLabel: "பாதுகாக்கப்பட்டது",
        verifiedPaymentCarrier: "சரிபார்க்கப்பட்ட கட்டண கேரியர்",
        acceptRequestBtn: "கோரிக்கையை ஏற்கவும்",
        declineBtn: "நிராகரி",
        selectAllotment: "ஒதுக்கீடுக்கான வாகனத்தைத் தேர்ந்தெடுக்கவும்",
        requiredLabel: "தேவை",
        noCompatibleVehicles: "பொருத்தமான வாகனங்கள் கிடைக்கவில்லை",
        ensureRegisteredLabel: "தயவுசெய்து நீங்கள் தற்போதைக்கு IDLE அல்லது ACTIVE நிலையில் வாகனங்களை பதிவு செய்துள்ளீர்கள் என்பதை உறுதிப்படுத்தவும்.",
        allotBtn: "ஒதுக்கீடு",
        bookingRequests: "முன்பதிவு கோரிக்கைகள்",
        acceptedOverall: "ஒட்டுமொத்தமாக ஏற்கப்பட்டது",
        recommendedFilter: "பரிந்துரைக்கப்படுகிறது",
        nearYouFilter: "உங்களுக்கு அருகில்",
        highProfitFilter: "அதிக லாபம்",
        urgentFilter: "அவசரம்",
        allFilter: "அனைத்தும்",
        noMatchingRequests: "பொருத்தமான கோரிக்கைகள் கிடைக்கவில்லை",
        processingState: "செயலாக்கப்படுகிறது",
        arrivalSpot: "வருகை (இடம்)",
        targetLabel: "இலக்கு",
        estimatedCosts: "மதிப்பிடப்பட்ட செலவுகள்",
        commissionLabel: "கமிஷன்",
        returnLoadMatching: "திரும்பு வழிக்கான சுமை பொருத்தம்",
        findCargoDesc: "உங்கள் திரும்பும் பயணத்திற்கான சுமையைக் கண்டுபிடித்து லாபத்தை அதிகப்படுத்துங்கள்.",
        currentLabel: "தற்போதைய: ",
        nativeLabel: "சொந்த ஊர்: ",
        toNativeLocation: "சொந்த ஊருக்கு",
        toNearby: "அருகிலுள்ள இடத்திற்கு",
        noReturnLoads: "திரும்பு வழிக்கான சுமை கிடைக்கவில்லை",
        noReturnLoadsDescBase: "எந்த கோரிக்கைகளையும் எங்களால் கண்டுபிடிக்க முடியவில்லை:",
        onTripShipments: "பயணத்தில் உள்ள சரக்குகள்",
        completedShipments: "முடிந்த சரக்குகள்",
        reviewCompletedDesc: "உங்கள் முடிந்த மற்றும் வழங்கப்பட்ட சரக்குகளை மதிப்பாய்வு செய்யவும்",
        trackOngoingDesc: "உங்கள் நடப்பு விநியோகங்களை கண்காணிக்கவும் நிர்வகிக்கவும்",
        searchShipmentsPh: "ID, பாதை அல்லது வாடிக்கையாளரை வைத்து தேடவும்...",
        allStatusOption: "அனைத்து நிலை",
        readyStatusLabel: "தயார்",
        arrivingStatusLabel: "வந்துகொண்டிருக்கிறது",
        onTripStatusLabel: "பயணத்தில்",
        completedStatusLabel: "முடிந்தது",
        deliveredStatusLabel: "வழங்கப்பட்டது",
        noShipmentsFound: "சரக்குகள் எதுவும் கிடைக்கவில்லை",
        checkBackLater: "பின்னர் சரிபார்க்கவும் அல்லது உங்கள் வடிப்பான்களை மாற்றவும்",
        unknownStatus: "தெரியவில்லை",
        cancelShipmentConfirm: "இந்த சரக்கை ரத்து செய்ய விரும்புகிறீர்களா?",
        failedUpdateStatus: "முன்பதிவு நிலையைப் புதுப்பிக்க முடியவில்லை",
        failedCancelShipment: "சரக்கை ரத்து செய்ய முடியவில்லை",
        proofSubmittedSuccess: "விநியோக சான்று வெற்றிகரமாக சமர்ப்பிக்கப்பட்டது!",
        submissionFailed: "சமர்ப்பிப்பு தோல்வியடைந்தது",
        linkCopied: "இணைப்பு கிளிப்போர்டில் நகலெடுக்கப்பட்டது! கீழே நீங்களும் கைமுறையாக நகலெடுக்கலாம்:",
        failedGenerateLink: "பகிர்வு இணைப்பை உருவாக்க முடியவில்லை",
        unassignedVehicle: "ஒதுக்கப்படாதது",
        fromLabel: "இருந்து",
        toLabel: "வரை",
        revenueLabel: "வருவாய்",
        startAction: "தொடங்கு",
        trackAction: "கண்காணி",
        arriveAction: "வந்தடை",
        callAction: "அழை",
        cancelAction: "ரத்துசெய்",
        reviewProofAction: "சான்றை மதிப்பாய்வு செய்",
        uploadProofAction: "சான்றை பதிவேற்று",
        verificationPortal: "சரிபார்ப்பு போர்ட்டல்",
        snapImagesHint: "முடிக்க 3 தெளிவான படங்களை எடுக்கவும்",
        snapLabel: "படம்",
        processingVerification: "செயலாக்கப்படுகிறது...",
        submitVerification: "சரிபார்ப்பை சமர்ப்பிக்கவும்",
        originLabel: "புறப்படும் இடம்",
        destinationLabel: "செல்லும் இடம்",
        fleetManagementTitle: "வாகன மேலாண்மை",
        fleetManagementDesc: "உங்கள் பதிவு செய்யப்பட்ட வாகனங்களை நிர்வகிக்கவும் கண்காணிக்கவும்",
        addNewVehicle: "புதிய வாகனம் சேர்",
        searchVehiclesPh: "ஐடி, பலகை அல்லது பெயர் அடிப்படையில் தேடுக...",
        noVehiclesFoundMsg: "உங்கள் அளவுகோல்களுடன் தொடர்புடைய வாகனங்கள் எதுவும் கிடைக்கவில்லை",
        noCategoryFound: "{{category}} எதுவும் கிடைக்கவில்லை",
        startBusinessVehicle: "கரோட்ரக் இயங்குதளத்தில் உங்கள் முதல் {{vehicle}} சேர்த்து உங்கள் வணிகத்தைத் தொடங்கவும்.",
        confirmDeleteVehicle: "இந்த வாகனத்தை ரத்து செய்ய விரும்புகிறீர்களா?",
        deleteSuccess: "வாகனம் வெற்றிகரமாக நீக்கப்பட்டது",
        deleteFailed: "நீக்கம் தோல்வி: ",
        editComingSoon: "திருத்தம் அம்சம் விரைவில் வருகிறது",
        trackVehicleAction: "வாகனத்தை கண்காணிக்க",
        viewDetailsFleetAction: "விவரங்களை பார்க்க",
        wheelsLabel: "சக்கரங்கள்",
        unnamedVehicle: "பெயரிடப்படாத வாகனம்",
        statusLabels: {"active":"செயலில்","onRoute":"வழியில்","idle":"சும்மா","service":"சேவையில்","maintenance":"பராமரிப்பில்","draft":"வரைவு","inactive":"செயலற்ற"},
        categoryLabel: "வகை",
        yearLabel: "ஆண்டு",
        conditionLabel: "நிலை",
        locationLabel: "இடம்",
        basicInfoLabel: "அடிப்படை தகவல்",
        techSpecsLabel: "தொழில்நுட்ப விபரங்கள்",
        equipSpecsLabel: "உபகரண குறிப்புகள்",
        driverDetailsLabel: "ஓட்டுநர் விவரங்கள்",
        pricingRatesLabel: "விலைகள் மற்றும் கட்டணங்கள்",
        discountsLabel: "தள்ளுபடிகள்",
        specialFeaturesLabel: "சிறப்பு அம்சங்கள்",
        additionalNotesLabel: "கூடுதல் குறிப்புகள்",
        payloadCapacity: "சுமை கொள்ளளவு",
        lengthLabel: "நீளம்",
        widthLabel: "அகலம்",
        heightLabel: "உயரம்",
        volumeLabel: "கன அளவு",
        wizardSelectCategory: "வகை தேர்ந்தெடுக்கவும்",
        wizardAddVehicle: "புதிய {{vehicle}} சேர்",
        wizardWhatAdding: "இன்று நீங்கள் என்ன சேர்க்கிறீர்கள்?",
        wizardStepBasic: "படி 1 இல் 4: அடிப்படை விவரங்கள்",
        wizardStepTech: "படி 2 இல் 4: தொழில்நுட்ப விவரங்கள்",
        wizardStepPhotos: "படி 3 இல் 4: புகைப்படங்கள் & ஆவணங்கள்",
        wizardStepPricing: "படி 4 இல் 4: விலைப்பட்டியல்",
        wizardCancel: "ரத்து செய்",
        wizardSaveCont: "சேமி & தொடரு",
        wizardPrev: "முந்தைய",
        wizardPublish: "வாகனத்தை வெளியிடு",
        wizardSaving: "சேமிக்கப்படுகிறது...",
        wizardPublishing: "வெளியிடப்படுகிறது...",
        wizardHeavy: "கனரக வாகனங்கள்",
        wizardHeavyDesc: "லாரிகள், இலகுரக வாகனங்கள், டிரெய்லர்கள்",
        wizardEquip: "உபகரணங்கள்",
        wizardEquipDesc: "கிரேன்கள், ஃபோர்க்லிஃப்ட், ஜெனரேட்டர்கள்",
        wizardConst: "கட்டுமான வாகனங்கள்",
        wizardConstDesc: "ஜேசிபி, மிக்சர்கள், அகழ்வாராய்ச்சிகள்",
        wizardTanker: "டாங்கர்",
        wizardTankerDesc: "தண்ணீர், எரிபொருள், பால் டாங்கர்கள்",
        wizardSuccessTitle: "{{vehicle}} வெற்றிகரமாக வெளியிடப்பட்டது!",
        wizardSuccessDesc: "உங்கள் {{vehicleType}} இப்போது உங்கள் சேவை பகுதியில் உள்ள அனைத்து வாடிக்கையாளர்களுக்கும் தெரியும்.",
        wizardViewListing: "உங்கள் பட்டியலைப் பார்க்கவும்",
        wizardNextSteps: "அடுத்து என்ன நடக்கும்:",
        wizardStep1Help: "1. வாடிக்கையாளர்கள் உங்கள் வாகனத்தை தேடுவார்கள்",
        wizardStep2Help: "2. முன்பதிவு கோரிக்கைகளை பெறுவீர்கள்",
        wizardStep3Help: "3. நிகழ்நேரத்தில் கோரிக்கைகளை ஏற்று/நிராகரிக்கலாம்",
        wizardStep4Help: "4. பயணங்களை முடித்து பணம் சம்பாதிக்கலாம்",
        decisionTab: "முடிவு",
        analyticsTab: "பகுப்பாய்வு",
        recurringTab: "தொடர்",
        comingSoonText: "விரைவில்",
        deadTripDev: "டெட் ட்ரிப் கண்டறிதல் தொகுதி உருவாக்கத்தில் உள்ளது",
        smartLoadDev: "ஸ்மார்ட் લોடு பொருத்துதல் விரைவில் வரும்",
        profitCheckTitle: "லாப சோதனை",
        distanceLabel: "தூரம்",
        fuelPriceLabel: "எரிபொருள் விலை (₹/L)",
        clientPaymentLabel: "வாடிக்கையாளர் கட்டணம் (₹)",
        perKmPriceLabel: "ஒரு கிமீ விலை (₹)",
        estClientPaymentLabel: "மதிப்பிடப்பட்ட வாடிக்கையாளர் கட்டணம்",
        selectedPickup: "தேர்ந்தெடுக்கப்பட்ட பிக்-அப்",
        selectedDropoff: "தேர்ந்தெடுக்கப்பட்ட டிராப்-ஆஃப்",
        vehicleRegLabel: "வாகன பதிவு எண்",
        mileageLabel: "மைலேஜ் (km/l)",
        tollsLabel: "சுங்க கட்டணம் (₹)",
        driverCostLabel: "ஓட்டுநர் கட்டணம் / பயணம் (₹)",
        maintCostLabel: "பராமரிப்பு / பயணம் (₹)",
        calcRoutePrompt: "தூரத்தைப் பெற முகப்பு வரைபடத்தில் ஒரு வழியைக் கணக்கிடுங்கள்.",
        runDecisionEngine: "முடிவு இயந்திரத்தை இயக்கு",
        evaluatingBtn: "மதிப்பீடு...",
        tripProfitable: "✅ பயணம் லாபகரமாக உள்ளது",
        potentialLoss: "⚠️ சாத்தியமான நஷ்டம் கண்டறியப்பட்டது",
        estProfit: "மதிப்பிடப்பட்ட லாபம்",
        estFuelCost: "மதிப்பிடப்பட்ட எரிபொருள் கட்டணம்",
        platformComm: "இயங்குதள கமிஷன்",
        driverCost: "ஓட்டுநர் கட்டணம்",
        tollsMaint: "சுங்கம் & பராமரிப்பு",
        totalCosts: "மொத்த கட்டணங்கள்",
        smartOptionsTitle: "ஸ்மார்ட் விருப்பங்கள்",
        calcRouteSuggest: "புத்திசாலித்தனமான பரிந்துரைகளைக் காண வரைபடத்தில் ஒரு வழியைக் கணக்கிடுங்கள்.",
        smartFromLabel: "இருந்து",
        smartToLabel: "வரை",
        shortestRoute: "குறுகிய வழி",
        smartViewInMap: "வரைபடத்தில் குறுகிய வழியைக் காண்க",
        fastestRoute: "வேகமான வழி",
        fuelEfficient: "எரிபொருள் சிக்கனமானத",
        balancedOption: "சமநிலையான விருப்பம்",
        alternative: "மாற்று",
        routeSelected: "தேர்ந்தெடுக்கப்பட்டது",
        routeStandard: "வழக்கமான வழி",
        mapComingSoonDesc: "நேரடி வழி காட்சிப்படுத்தலுடன் இயங்குதளத்தில் உள்ள ஊடாடும் வரைபடம்",
        startPointPlaceholder: "தொடக்கப் புள்ளி (உம்: சென்னை)",
        destinationPlaceholder: "செல்லுமிடம் (உம்: பெங்களூர்)",
        plotRouteBtn: "வழியை வரை",
        locationNotFound: "ஒன்று அல்லது அதற்கு மேற்பட்ட இடங்களைக் கண்டறிய முடியவில்லை. உங்கள் எழுத்துப்பிழையைச் சரிபார்க்கவும்.",
        calcError: "தூரத்தைக் கணக்கிட முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.",
        suggestedRoute: "பரிந்துரைக்கப்பட்ட வழி",
        openGoogleMaps: "கூகுள் வரைபடத்தைத் திற",
        loadingAnalytics: "பகுப்பாய்வு ஏற்றப்படுகிறது...",
        noDataYet: "தரவு எதுவும் இல்லை",
        runCalcPrompt: "உங்கள் செயல்திறன் பகுப்பாய்வுகளைக் காண லாப வழியைக் கணக்கிடுங்கள்.",
        totalTripsAnalyzed: "மொத்தப் பயணங்கள் பகுப்பாய்வு",
        profitableRoutesKPI: "லாபகரமான வழிகள்",
        avgProfitTrip: "சராசரி லாபம் / பயணம்",
        topRoutes: "முதல் வழிகள்",
        tripsAnalyzed: "பயணங்கள் பகுப்பாய்வு செய்யப்பட்டன",
        loadingRecurring: "தொடர் வழிகள் ஏற்றப்படுகின்றன...",
        noRecurringRoutes: "தொடர் வழிகள் இல்லை",
        automateTripsSummary: "உங்கள் வழக்கமான பயணங்களை தொடர் வழிகளாக சேமித்து தானியக்கமாக்குங்கள்.",
        setupAutomationBtn: "+ தானியக்க அமைப்பை உருவாக்கு",
        activeSchedules: "செயலில் உள்ள அட்டவணைகள்",
        routesCount: "{{count}} வழிகள்",
        flexibleSched: "நெகிழ்வான",
        assignedStatus: "- ஒதுக்கப்பட்டது -",
        noVehicleAssigned: "வாகனம் ஒதுக்கப்படவில்லை",
        assignNow: "இப்போது ஒதுக்கு",
        activityHistoryTitle: "செயல்பாட்டு வரலாறு",
        trackHistoryDesc: "உங்கள் முந்தைய ஏற்றுமதிகள் மற்றும் நிதிப் பதிவுகளைக் கண்காணிக்கவும்",
        tabTransactions: "பரிவர்த்தனைகள்",
        tabPastShipments: "கடந்த ஏற்றுமதிகள்",
        tabMaintenanceLogs: "பராமரிப்பு பதிவுகள்",
        noMaintenanceLogs: "இதுவரை பராமரிப்பு பதிவுகள் எதுவும் பதிவு செய்யப்படவில்லை",
        colDate: "தேதி",
        colTransactionID: "பரிவர்த்தனை ஐடி",
        colClient: "வாடிக்கையாளர்",
        colAmount: "தொகை",
        colStatus: "நிலை",
        directClient: "நேரடி வாடிக்கையாளர்",
        statusPaid: "செலுத்தப்பட்டது",
        statusPending: "நிலுவையில் உள்ளது",
        noTransactionsFound: "பரிவர்த்தனைகள் எதுவும் இல்லை",
        earningHistoryDesc: "உங்கள் வருவாய் வரலாறு இங்கே தோன்றும்",
        statusCompleted: "முடிக்கப்பட்டது",
        tonsFormat: "{{weight}} டன்கள்",
        noPastShipmentsFound: "கடந்த ஏற்றுமதிகள் எதுவும் இல்லை",
        customerRatingsTitle: "வாடிக்கையாளர் மதிப்பீடுகள்",
        feedbackSubtitle: "உங்கள் கடற்படை வாடிக்கையாளர்களிடமிருந்து கருத்து",
        totalReviews: "மொத்த மதிப்பீடுகள்",
        loadingReviews: "மதிப்பீடுகள் ஏற்றப்படுகின்றன...",
        noReviewsYet: "இதுவரை எந்த மதிப்பீடுகளும் இல்லை",
        completeTripsFeedback: "கருத்துக்களைப் பெற பயணங்களை முடிக்கவும்",
        clientDefault: "வாடிக்கையாளர்",
        defaultReviewComment: "செயல்திறன் எதிர்பார்ப்புகளை பூர்த்தி செய்தது.",
        linkedAssetLabel: "இணைக்கப்பட்ட வாகனம்",
        truckServiceDefault: "டிரக் சேவை",
        helpSupportTitle: "உதவி & ஆதரவு",
        supportSubtitle: "உதவியைப் பெற்று, உங்கள் கேள்விகளுக்கான பதில்களைக் கண்டறியவும்",
        prioritySupportTitle: "24/7 முன்னுரிமை ஆதரவு",
        prioritySupportDesc: "எந்தவொரு சிக்கலுக்கும் உங்களுக்கு உதவ எங்கள் அர்ப்பணிப்பு ஆதரவு குழு இங்கே உள்ளது.",
        startLiveChatBtn: "நேரலை அரட்டையைத் தொடங்கு",
        accountManagerLbl: "கணக்கு மேலாளர்",
        relationshipManagerLbl: "உறவு மேலாளர்",
        loadingTickets: "டிக்கெட்டுகள் ஏற்றப்படுகின்றன...",
        activeTicketsTitle: "செயலில் உள்ள டிக்கெட்டுகள்",
        noActiveTickets: "செயலில் உள்ள டிக்கெட்டுகள் இல்லை",
        raiseTicketHelp: "உதவி தேவையா? கீழே ஒரு புதிய டிக்கெட்டை உருவாக்கவும்",
        raiseNewTicketBtn: "புதிய டிக்கெட்டை உருவாக்கு",
        helpCenterTitle: "உதவி மையம்",
        searchHelpPlaceholder: "உதவியைத் தேடுங்கள்...",
        noResultsFound: "முடிவுகள் எதுவும் கிடைக்கவில்லை",
        shortFaq1Q: "புதிய வாகனத்தை எவ்வாறு சேர்ப்பது?",
        shortFaq1A: "விமான மேலாண்மைக்குச் சென்று 'புதிய வாகனத்தைச் சேர்' என்பதைக் கிளிக் செய்யவும். ஆர்சி மற்றும் அனுமதி விவரங்களை நிரப்பவும்.",
        shortFaq2Q: "எனக்கு எப்போது பணம் கிடைக்கும்?",
        shortFaq2A: "முந்தைய வாரத்திலிருந்து அனைத்து முழுமையான ஏற்றுமதிகளுக்கும் ஒவ்வொரு வெள்ளிக்கிழமையும் பணம் செலுத்தப்படும்.",
        shortFaq3Q: "ஒரு குறிப்பிட்ட டிரக்கை எவ்வாறு கண்காணிப்பது?",
        shortFaq3A: "டிரக் மேலாண்மை அல்லது ஏற்றுமதிகள் தொகுதியில் 'நேரடி கண்காணிப்பு' அம்சத்தைப் பயன்படுத்தவும்.",
        shortFaq4Q: "தாமதம் ஏற்பட்டால் என்ன செய்வது?",
        shortFaq4A: "ஏற்றுமதி நிலையை 'போக்குவரத்தில் - தாமதம்' என்று புதுப்பித்து, அந்தத் தகவலை வாடிக்கையாளருக்கு டாஷ்போர்டு மூலம் தெரிவிக்கவும்.",
        contactDetails: "தொடர்பு விவரங்கள்",
        emailLbl: "மின்னஞ்சல்",
        phoneLbl: "தொலைபேசி",
        alternateLbl: "மாற்று",
        baseLbl: "அடிப்படை",
        businessIdentity: "வணிக அடையாளம்",
        gstLbl: "ஜிஎஸ்டி எண்",
        panLbl: "பான் எண்",
        entityLbl: "நிறுவனம்",
        joinedLbl: "இணைந்தது",
        bankDetailsTitle: "வங்கி விவரங்கள்",
        holderLbl: "உரிமையாளர்",
        bankLbl: "வங்கி",
        accountLbl: "கணக்கு",
        ifscLbl: "ஐஎஃப்எஸ்சி",
        typeLbl: "வகை",
        verifiedWithdrawalsDesc: "சரிபார்க்கப்பட்ட விவரங்கள் உடனடி பணம் பெறுவதை உறுதி செய்கின்றன.",
        endOfMonthReports: "மாத இறுதி அறிக்கைகள்",
        recordingLbl: "பதிவு செய்யப்படுகிறது",
        reportFinalizedDesc: "அறிக்கை இறுதி செய்யப்பட்டு சரிபார்க்கப்பட்டது",
        availableOn: "{{date}} முதல் கிடைக்கும்",
        downloadDataSheetBtn: "தரவு தாளைப் பதிவிறக்கு",
        processingLbl: "செயலாக்கப்படுகிறது...",
        noHistoryObserved: "இதுவரை எந்த செயல்பாட்டு வரலாறும் காணப்படவில்லை",
        businessShowcaseTitle: "வணிக காட்சி பெட்டி",
        viewBusinessPage: "வணிகப் பக்கத்தைக் காண்க",
        createBusinessPage: "வணிகப் பக்கத்தை உருவாக்கு",
        hasBusinessPageDesc: "வாடிக்கையாளர்கள் உங்கள் கடற்படை மற்றும் சேவைகளை மதிப்பிடுவதற்கு பயன்படுத்தும் தொழில்முறை காட்சி பெட்டி பக்கம்.",
        noBusinessPageDesc: "உங்கள் கடற்படை வணிகத்திற்கான ஒரு தொழில்முறை விளம்பரப் பக்கத்தை உருவாக்கி வாடிக்கையாளர்களிடம் பகிரவும்.",
        showPageBtn: "பக்கத்தைக் காட்டு",
        startSetupBtn: "அமைப்பைத் தொடங்கு",
        backToProfile: "சுயவிவரத்திற்குத் திரும்பு",
        liveBusinessPage: "நேரடி வணிகப் பக்கம்",
        livePreviewBtn: "நேரடி முன்னோட்டம்",
        liveFleetInventory: "நேரடி கடற்படை சரக்கு",
        synchingProfileData: "சுயவிவரத் தரவு ஒத்திசைக்கப்படுகிறது...",
        editDetailsHint: "விவரங்களைத் திருத்த, அமைப்புகளுக்குச் செல்லவும்",
        accountSettingsTitle: "கணக்கு அமைப்புகள்",
        settingsSubtitle: "உங்கள் சுயவிவரம், பணம் மற்றும் விருப்பங்களை மேலாண்மை செய்யவும்",
        profileDetailsTab: "சுயவிவர விவரங்கள்",
        bankDetailsTab: "வங்கி விவரங்கள்",
        securityTab: "பாதுகாப்பு",
        notificationsTab: "அறிவிப்புகள்",
        securitySettingsTitle: "பாதுகாப்பு அமைப்புகள்",
        securitySettingsDesc: "உங்கள் கடவுச்சொல்லை மாற்றவும் மற்றும் அமர்வு பாதுகாப்பை மேலாண்மை செய்யவும்.",
        resetPasswordBtn: "கடவுச்சொல்லை மீட்டமை",
        notifPrefTitle: "அறிவிப்பு விருப்பங்கள்",
        emailAlertsBookings: "புதிய பதிவுகளுக்கான மின்னஞ்சல் எச்சரிக்கைகள்",
        smsAlertsSettlement: "பணம் தீர்வுக்கான எஸ்எம்எஸ் எச்சரிக்கைகள்",
        accountInfoTitle: "கணக்கு தகவல்",
        fullNameLbl: "முழுப் பெயர்",
        companyNameLbl: "நிறுவனப் பெயர்",
        emailAddressLbl: "மின்னஞ்சல் முகவரி",
        mobileNumberLbl: "மொபைல் எண்",
        stateLbl: "மாநிலம்",
        cityLbl: "நகரம்",
        businessNameLbl: "வணிக பெயர்",
        businessTypeLbl: "வணிக வகை",
        editProfile: "சுயவிவரத்தைத் திருத்து",
        companyAddressLbl: "நிறுவனத்தின் முகவரி",
        saveChangesBtn: "மாற்றங்களைச் சேமி",
        paymentSettlementTitle: "பணம் தீர்வு",
        bankNameLbl: "வங்கி பெயர்",
        bankNamePlaceholder: "உதா: HDFC வங்கி",
        accountNumberLbl: "கணக்கு எண்",
        accountNumberPlaceholder: "12-16 இலக்க கணக்கு எண்ணை உள்ளிடவும்",
        ifscCodeLbl: "ஐஎஃப்எஸ்சி குறியீடு",
        ifscCodePlaceholder: "உதா: HDFC0001234",
        settlementNote: "* முந்தைய வாரத்தின் முடிக்கப்பட்ட பயணங்களுக்கு பணம் ஒவ்வொரு வெள்ளிக்கிழமையும் தீர்க்கப்படும்.",
        updateBankDetailsBtn: "வங்கி விவரங்களைப் புதுப்பி",
        settlementHistoryTitle: "தீர்வு வரலாறு",
        last30Days: "கடந்த 30 நாட்கள்",
        colDateSettlement: "தேதி",
        colReference: "குறிப்பு",
        colAmountSettlement: "தொகை",
        colStatusSettlement: "நிலை",
        loadingHistory: "வரலாறு ஏற்றப்படுகிறது...",
        noSettlementsObserved: "கடந்த 30 நாட்களில் முடிக்கப்பட்ட பயணங்களுக்கு தீர்வுகள் இல்லை.",
        pendingLbl: "நிலுவையில்",
        settledLbl: "தீர்க்கப்பட்டது",
        processingStatusLbl: "செயலாக்கப்படுகிறது",
        totalRevenueLbl: "மொத்த வருமானம்",
        onTripFleetLbl: "பயணத்தில் உள்ள கடற்படை",
        vsLastMonth: "கடந்த மாதத்துடன்",
        cumulativeEarnings: "மொத்த வருமானங்கள்",
        withdrawBtn: "பணம் எடு",
        thisWeekLbl: "இந்த வாரம்",
        fromLastSession: "கடந்த அமர்விலிருந்து",
        profitMarginLbl: "லாப விகிதம்",
        calculatedRealtime: "நேரடியாக கணக்கிடப்பட்டது",
        earningsPerformance: "வருமான செயல்திறன்",
        revenueOverTime: "காலப்போக்கில் வருமானம் (வாராந்திர பார்வை)",
        downloadDetailedReport: "விரிவான அறிக்கையைப் பதிவிறக்கு",
        observingPerformance: "செயல்திறனை கண்காணிக்கிறது...",
        earningsVisualizationHint: "பயணங்கள் முடிக்கப்பட்டவுடன் வருமான காட்சிப்படுத்தல் தோன்றும்",
        withdrawFundsTitle: "பணம் எடு",
        transferToBank: "பதிவு செய்யப்பட்ட வங்கிக்கு மாற்று",
        availableForWithdrawal: "எடுப்பதற்கு கிடைக்கும்",
        withdrawalAmountLbl: "எடுப்புத் தொகை",
        fundsTransferNote: "பணம் உங்கள் சரிபார்க்கப்பட்ட வங்கிக் கணக்கில் ** 4582 24-48 வணிக மணி நேரங்களில் சேர்க்கப்படும்.",
        confirmWithdrawalBtn: "எடுப்பை உறுதிப்படுத்து",
        requestSuccessful: "கோரிக்கை வெற்றிகரமானது",
        withdrawalInitiated: "உங்கள் ₹{{amount}} எடுப்புக் கோரிக்கை தொடங்கப்பட்டது.",
        driverDirectory: "ஓட்டுநர் அடைவு",
        driverDirectorySub: "உங்கள் கடற்படை பணியாளர்களை நிர்வகிக்கவும், விவரங்களைக் காணவும், புதிய ஓட்டுநர்களை சேர்க்கவும்.",
        searchDriversPh: "ஓட்டுநர்களைத் தேடுங்கள்...",
        addDriver: "ஓட்டுநரைச் சேர்",
        noDriversFound: "ஓட்டுநர்கள் எவரும் காணப்படவில்லை",
        noDriversFoundSub: "உங்கள் நிறுவனத்தில் இதுவரை எந்த ஓட்டுநரும் பதிவு செய்யப்படவில்லை. தொடங்க உங்கள் முதல் ஓட்டுநரைச் சேர்க்கவும்.",
        addFirstDriver: "முதல் ஓட்டுநரைச் சேர்",
        noMatchFound: "பொருத்தம் எதுவும் காணப்படவில்லை",
        adjustSearchCriteria: "உங்கள் தேடல் அளவுகோல்களை சரிசெய்ய முயற்சிக்கவும்.",
        vehicleAvailabilityTip: "குறிப்பு: உங்கள் வாகனத்தின் கிடைக்கும்தன்மையை தொடர்ந்து புதுப்பிக்கவும். 'பராமரிப்பு' அல்லது 'சேவை' என குறிக்கப்பட்ட வாகனங்கள் வாடிக்கையாளர் தேடலில் இருந்து மறைக்கப்படும்!",
        paymentPending: "பணம் நிலுவையில் உள்ளது",
        cancelledShipments: "ரத்து செய்யப்பட்டது",
        recentShipments: "சமீபத்திய ஏற்றுமதிகள்",
        searchKnowledgeBase: "அறிவுத் தளத்தைத் தேடுங்கள்...",
        searchKnowledgeHint: "டிக்கெட்டுகள், கேள்விகள் மற்றும் உதவி கட்டுரைகளைத் தேடுங்கள்",
        quickContactOptions: "விரைவு தொடர்பு விருப்பங்கள்",
        callSupport: "அழைப்பு ஆதரவு",
        whatsAppSupport: "வாட்ஸ்அப் ஆதரவு",
        emailSupport: "மின்னஞ்சல் ஆதரவு",
        liveSupport: "நேரலை ஆதரவு",
        connectToAgent: "முகவருடன் இணையுங்கள் →",
        yourAccountManager: "உங்கள் கணக்கு மேலாளர்",
        relationshipManager: "உறவு மேலாளர்",
        supportHours: "ஆதரவு நேரங்கள்",
        emergencyHelpline: "அவசர உதவி எண்",
        currentPasswordLbl: "தற்போதைய கடவுச்சொல்",
        newPasswordLbl: "புதிய கடவுச்சொல்",
        updatePasswordBtn: "கடவுச்சொல்லைப் புதுப்பிக்கவும்",
        enterOtpFromEmail: "மின்னஞ்சலில் இருந்து OTP ஐ உள்ளிடவும்",
        verifyConfirmBtn: "சரிபார்த்து உறுதிப்படுத்தவும்",
        emailAlertsLbl: "மின்னஞ்சல் எச்சரிக்கைகள்",
        emailAlertsSub: "மின்னஞ்சல் மூலம் முன்பதிவு மற்றும் பயண புதுப்பிப்புகள்",
        smsAlertsLbl: "எஸ்எம்எஸ் எச்சரிக்கைகள்",
        smsAlertsSub: "உரை செய்தி மூலம் முக்கியமான எச்சரிக்கைகள்",
        whatsAppAlertsLbl: "வாட்ஸ்அப் எச்சரிக்கைகள்",
        whatsAppAlertsSub: "வாட்ஸ்அப் மூலம் புதுப்பிப்புகள்",
        changeEmailAddress: "மின்னஞ்சல் முகவரியை மாற்றவும்",
        updateEmailAddress: "மின்னஞ்சல் முகவரியைப் புதுப்பிக்கவும்",
        newEmailAddressPh: "புதிய மின்னஞ்சல் முகவரி",
        sendOtpBtn: "OTP அனுப்பு",
        verifyApplyBtn: "சரிபார்த்து பொருத்து",
        requestChangeBtn: "மாற்றத்தைக் கோரு",
        frequentlyAskedQuestions: "அடிக்கடி கேட்கப்படும் கேள்விகள்",
        questionsLabel: "கேள்விகள்",
        questionLabel: "கேள்வி",
        noQuestionsFound: "கேள்விகள் எதுவும் காணப்படவில்லை",
        tryDifferentKeywords: "வெவ்வேறு முக்கிய வார்த்தைகளை முயற்சிக்கவும் அல்லது உதவி டிக்கெட்டை உயர்த்தவும்.",
        activeTickets: "செயலில் உள்ள டிக்கெட்டுகள்",
        activeCountLabel: "செயலில்",
        createNewTicketBtn: "புதிய டிக்கெட்டை உருவாக்கு",
        faq1Q: "காரோட்ருக் நெட்வொர்க்கில் புதிய வாகனத்தை எவ்வாறு சேர்ப்பது?",
        faq1A: "உங்கள் டேஷ்போர்டில் உள்ள \"கடற்படை மேலாண்மை\" தொகுதிக்குச் சென்று \"புதிய வாகனத்தைச் சேர்\" என்பதைத் தேர்ந்தெடுக்கவும். பதிவு எண், அனுமதி விவரங்கள் மற்றும் ஆர்சி மற்றும் காப்பீட்டு ஆவணங்களின் தெளிவான நகல்களை வழங்க வேண்டும். சரிபார்ப்பு வழக்கமாக 2 மணி நேரத்திற்குள் முடிக்கப்படும்.",
        faq2Q: "குறிப்பிட்ட வாகனத்திற்கு ஓட்டுநரை எவ்வாறு ஒதுக்குவது?",
        faq2A: "\"கடற்படை மேலாண்மை\" தொகுதிக்குச் சென்று தேவையான வாகனத்தைத் தேர்ந்தெடுக்கவும். உங்கள் பட்டியலிலிருந்து சரிபார்க்கப்பட்ட ஓட்டுநரைத் தேர்ந்தெடுக்க அல்லது புதிய ஓட்டுநரின் வணிக உரிம விவரங்களைச் சமர்ப்பித்து சேர்க்க \"ஓட்டுநரை ஒதுக்கு\" என்பதைக் கிளிக் செய்யவும்.",
        faq3Q: "நிலையான கட்டணத் தீர்வு சுழற்சி என்ன?",
        faq3A: "கட்டணங்கள் நேரடியாக உங்கள் சரிபார்க்கப்பட்ட வங்கிக் கணக்கில் தீர்க்கப்படும். முன்பணம் (பேசப்பட்டிருந்தால்) அனுப்பப்பட்டவுடன் செயலாக்கப்படும், மேலும் மீதித் தொகை டெலிவரி ஆதாரம் (POD) பதிவேற்றப்பட்ட 24-48 மணி நேரத்திற்குள் தீர்க்கப்படும்.",
        faq4Q: "பயணத்திற்கான முன்பணத்தை எவ்வாறு கோருவது?",
        faq4A: "சரக்கு ஏற்றுக்கொள்ளும் கட்டத்தின் போது முன்பண கோரிக்கை வைக்கலாம். துல்லியமான சதவீதம் வாடிக்கையாளருடன் நேரடியாகப் பேசப்பட்டு காரோட்ருக் அமைப்பு மூலம் பாதுகாப்பாக செயலாக்கப்படுகிறது.",
        faq5Q: "பதிவுசெய்யப்பட்ட வங்கிக் கணக்கு விவரங்களை எவ்வாறு புதுப்பிப்பது?",
        faq5A: "அமைப்புகள் > வங்கி விவரங்களுக்குச் செல்லவும். பாதுகாப்பு காரணங்களுக்காக, நிதித் தகவல்களில் செய்யப்படும் மாற்றங்களுக்கு OTP சரிபார்ப்பு மற்றும் ஆதரவுக் குழுவின் மதிப்பாய்வு தேவை.",
        faq6Q: "ஆரம்ப சரிபார்ப்பிற்கு என்ன ஆவணங்கள் தேவை?",
        faq6A: "உங்கள் கணக்கைச் செயல்படுத்த, பான் கார்டு, ஜிஎஸ்டி சான்றிதழ் (பொருந்தினால்), வங்கிச் சான்று (ரத்து செய்யப்பட்ட காசோலை/பாஸ்புக்) மற்றும் ஆதார் கார்டு ஆகியவற்றை பதிவேற்ற வேண்டும். அனைத்து ஆவணங்களும் தெளிவாக இருக்க வேண்டும்.",
        faq7Q: "நேரடி சரக்கு கண்காணிப்பு எவ்வாறு செயல்படுகிறது?",
        faq7A: "செயலில் உள்ள சரக்குகள் ஓட்டுநரின் மொபைல் பயன்பாடு அல்லது வாகனத்தின் ஒருங்கிணைந்த ஜிபிஎஸ் அமைப்பு மூலம் தானாகவே கண்காணிக்கப்படும். நேரலை கண்காணிப்பு உங்கள் டேஷ்போர்டில் உள்ள \"சரக்குகள்\" தொகுதியின் கீழ் தெரியும்.",
        faq8Q: "வாடிக்கையாளர் ரத்து செய்வதற்கான நடைமுறை என்ன?",
        faq8A: "வாடிக்கையாளர் உறுதிப்படுத்தப்பட்ட பயணத்தை ரத்து செய்தால், எஸ்எம்எஸ் மற்றும் மின்னஞ்சல் மூலம் உங்களுக்கு உடனுக்குடன் அறிவிக்கப்படும். ரத்துசெய்யும் இழப்பீடு தானாகவே கணக்கிடப்படும்.",
        faq9Q: "பயணத்தின் போது வாடிக்கையாளருடன் எவ்வாறு தொடர்புகொள்வது?",
        faq9A: "சரக்கு செயலில் இருக்கும்போது நேரடி தொடர்பு விருப்பங்கள் திறக்கப்படும். ஏற்றுதல் அல்லது இறக்குதல் பணிகளை ஒருங்கிணைக்க வாடிக்கையாளரின் தொடர்பு எண்ணை செயலில் உள்ள சரக்கு விவரங்கள் பேனலில் காணலாம்.",
        faq10Q: "நான் பதிவு செய்யக்கூடிய வாகனங்களின் எண்ணிக்கைக்கு ஏதேனும் வரம்பு உள்ளதா?",
        faq10A: "இல்லை, காரோட்ருக் எல்லையற்ற கடற்படை அளவை ஆதரிக்கிறது. ஒரு ஒற்றை டிரக் அல்லது நூற்றுக்கணக்கான வாகனங்கள் கொண்ட பெரிய கடற்படையை ஒரே டேஷ்போர்டில் இருந்து நிர்வகிக்கலாம்.",
        myShipments: "என் சரக்குகள்",
        activeCompletedTransits: "செயலில் உள்ள & முடிந்த பயணங்கள்",
        trackLiveVehicleRoutesDesc: "வாகன நேரலை வழிகள், ஓட்டுநர் விவரங்கள் மற்றும் POD சரிபார்ப்புகளை கண்காணிக்கவும்",
        filterByDate: "தேதி மூலம் வடிகட்டவும்",
        selectDate: "தேதியைத் தேர்ந்தெடுக்கவும்",
        arrivingTab: "வருகிறது",
        onServiceTab: "பணியில் உள்ளது",
        completedTab: "நிறைவடைந்தது",
        noTransitsDiscovered: "எந்த பயணமும் கண்டறியப்படவில்லை",
        noActiveShipmentsInState: "தற்போது இந்த நிலையில் எந்த சரக்குகளும் இல்லை.",
        showDetails: "விவரங்களைக் காட்டு",
        hideDetails: "விவரங்களை மறை",
        liveStatusUpdate: "நேரலை நிலை தகவல்",
        progress: "முன்னேற்றம்",
        podVerified: "POD சரிபார்க்கப்பட்டது",
        viewPod: "POD பார்க்க",
        proofOfDelivery: "டெலிவரி ஆதாரம் (POD)",
        podNotVerifiedByYou: "உங்களால் இன்னும் சரிபார்க்கப்படவில்லை",
        verifyNow: "இப்போது சரிபார்க்கவும்",
        podNotReceivedYet: "POD இன்னும் பெறப்படவில்லை",
        liveTrack: "நேரலை கண்காணிப்பு",
        awaitingPlate: "எண் பலகைக்காக காத்திருக்கிறது",
        assigningDriver: "ஓட்டுநர் நியமிக்கப்படுகிறார்...",
        paymentsAndInvoices: "பணம் செலுத்துதல்கள் & விலைப்பட்டியல்கள்",
        totalSpentThisMonth: "மொத்த செலவு (இந்த மாதம்)",
        basedOnCompletedPayments: "முடிக்கப்பட்ட பணம் செலுத்துதல்களின் அடிப்படையில்",
        pendingInvoices: "நிலுவையில் உள்ள விலைப்பட்டியல்கள்",
        awaitingPayment: "பணம் செலுத்த காத்திருக்கிறது",
        gstRecords: "ஜிஎஸ்டி பதிவுகள்",
        updateInProfileSettings: "சுயவிவர அமைப்புகளில் புதுப்பிக்கவும்",
        paymentHistory: "பணம் செலுத்திய வரலாறு",
        downloadInvoices: "விலைப்பட்டியல்களைப் பதிவிறக்கு",
        gstBills: "ஜிஎஸ்டி பில்கள்",
        notifications: "அறிவிப்புகள்",
        markAllRead: "அனைத்தையும் படித்ததாகக் குறிக்கவும்",
        noNotificationsYet: "இதுவரை அறிவிப்புகள் இல்லை",
        loadingNotifications: "அறிவிப்புகள் ஏற்றப்படுகின்றன...",
        reserveVehicle: "வாகனத்தை முன்பதிவு செய்",
        confirmReservation: "முன்பதிவை உறுதிப்படுத்து",
        cancel: "ரத்துசெய்",
        submitting: "சமர்ப்பிக்கப்படுகிறது...",
        careersAtKaroTrukk: "KaroTrukk-ல் வேலைவாய்ப்புகள்",
        careersHeroSub: "தளவாடங்களின் எதிர்காலத்தை உருவாக்குவதில் எங்களுடன் இணையுங்கள். இந்தியா முழுவதும் விரிவடைய ஆர்வமுள்ள நபர்களை நாங்கள் எதிர்பார்க்கிறோம்.",
        openPositions: "திறந்த பணியிடங்கள்",
        applyNow: "இப்போது விண்ணப்பிக்கவும்",
        waterTankersOnDemand: "தேவைக்கேற்ப தண்ணீர் டேங்கர்கள்",
        waterSupplySub: "வீடு, கட்டுமானம் & வணிக நீர் விநியோகம்",
        waterSupplyDesc: "வீடுகள், நீச்சல் குளங்கள், ஆழ்துளை கிணறு மற்றும் கட்டுமான தளங்களுக்கு சரிபார்க்கப்பட்ட உள்ளூர் வாகனங்களுடன் விரைவான தண்ணீர் விநியோகம்.",
        fastLocalDispatch: "விரைவான உள்ளூர் அனுப்புதல்",
        verifiedTankerFleet: "சரிபார்க்கப்பட்ட டேங்கர் வாகனங்கள்",
        liveDriverTracking: "நேரலை ஓட்டுநர் கண்காணிப்பு",
        orderTanker: "டேங்கர் ஆர்டர் செய்க",
        whoUsesKaroTrukk: "KaroTrukk-ஐ யார் பயன்படுத்துகிறார்கள்?",
        whoUsesKaroTrukkDesc: "குடியிருப்பு, வணிகம் மற்றும் கட்டுமான திட்டங்களில் வாடிக்கையாளர் தேவைகளை பூர்த்தி செய்கிறது.",
        homeowners: "வீட்டு உரிமையாளர்கள்",
        builders: "பில்டர்கள்",
        contractors: "ஒப்பந்ததாரர்கள்",
        factories: "தொழிற்சாலைகள்",
        warehouses: "கிடங்குகள்",
        shops: "கடைகள்",
        eventOrganizers: "நிகழ்ச்சி ஏற்பாட்டாளர்கள்",
        farmers: "விவசாயிகள்",
        whatWeDo: "நாங்கள் என்ன செய்கிறோம்",
        whatWeDoDesc: "JCB மற்றும் உபகரணங்களை சில படிகளில் எளிதாக புக் செய்யலாம். விரைவான, சரிபார்க்கப்பட்ட, நேரடி சேவை.",
        everydayJobsTitle: "நாங்கள் உதவும் அன்றாட பணிகள்",
        moreVehicles: "மேலும் வாகனங்கள்",
        signInToViewAll: "அனைத்தையும் காண உள்நுழையவும் →",
        touchAndDragToScroll: "← உருட்ட தொட்டு இழுக்கவும் →",
        moreArrow: "மேலும் →",
        forCustomers: "வாடிக்கையாளர்களுக்கு",
        forCustomersDesc: "தேவைப்படும்போது JCB மற்றும் உபகரணங்களை புக் செய்யுங்கள். உங்கள் தேவையை பதிவிட்டு சில நிமிடங்களில் இணையுங்கள்.",
        forFleetPartners: "வாகன உரிமையாளர்களுக்கு",
        forFleetPartnersDesc: "உங்கள் JCB மற்றும் உபகரணங்களை இணையுங்கள். நேரடி முன்பதிவு கோரிக்கைகளைப் பெற்று வருமானத்தை அதிகப்படுத்துங்கள்.",
        howWeConnect: "நாங்கள் எவ்வாறு இணைக்கிறோம்",
        howWeConnectDesc: "4 படிகளில் எளிய முறையில் JCB மற்றும் இயந்திர முன்பதிவு.",
        step1Title: "இயந்திரத்தைத் தேர்ந்தெடுக்கவும்",
        step1Desc: "உங்கள் பணிக்குத் தேவையான JCB அல்லது உபகரணங்களைத் தேர்ந்தெடுக்கவும்.",
        step2Title: "முன்பதிவு கோருங்கள்",
        step2Desc: "சில எளிய படிகளில் உங்கள் தேவையைச் சமர்ப்பிக்கவும்.",
        step3Title: "இணைக்கப்படுங்கள்",
        step3Desc: "சரிபார்க்கப்பட்ட அருகிலுள்ள வாகன உரிமையாளர்களுடன் இணையுங்கள்.",
        step4Title: "வேலையைத் தொடங்குங்கள்",
        step4Desc: "முன்பதிவை உறுதிசெய்து தளத்தில் பணியைத் தொடங்குங்கள்.",
        whyWeDoIt: "நாங்கள் ஏன் இதைச் செய்கிறோம்",
        whyWeDoItDesc: "கட்டுமானத் திட்டங்கள் சரியான உபகரணங்களை சரியான நேரத்தில் பெறுவதைச் சார்ந்துள்ளன. இந்தியா முழுவதும் இயந்திரங்களை எளிதாகவும் வெளிப்படையாகவும் பெற KaroTrukk உருவாக்கப்பட்டது.",
        ourMission: "எங்கள் நோக்கம்",
        ourMissionDesc: "கட்டுமான இயந்திரங்கள் மற்றும் கனரக உபகரணங்களை நம்பகமான முன்பதிவு மூலம் எளிதாக கிடைக்கச் செய்வது.",
        ourVision: "எங்கள் பார்வை",
        ourVisionDesc: "இந்தியா முழுவதும் கட்டுமான இயந்திர முன்பதிவை மிகவும் வசதியாக மாற்றும் நம்பகமான தளத்தை உருவாக்குவது.",
        ourCommitment: "எங்கள் அர்ப்பணிப்பு",
        ourCommitmentDesc: "வாடிக்கையாளர் வசதியை மையமாகக் கொண்டது. நம்பகமான சேவை, தெளிவு மற்றும் சரிபார்க்கப்பட்ட வாகன உரிமையாளர்கள்.",
        whoWeAre: "நாங்கள் யார்",
        whoWeAreSub: "JCB மற்றும் இயந்திரங்களுக்கான இந்தியாவின் முதல் கேப்-பாணி முன்பதிவு தளம்.",
        jcbsEarthmoving: "JCB மற்றும் மண் அள்ளும் இயந்திரங்கள்",
        equipmentMachineries: "உபகரண இயந்திரங்கள்",
        verifiedFleetPartners: "சரிபார்க்கப்பட்ட வாகன உரிமையாளர்கள்",
        heavyTrucksTitle: "கனரக லாரிகள் & வணிக வாகனங்கள்",
        heavyTrucksDesc: "தொழில்துறை போக்குவரத்துக்காக வணிக லாரிகள், LCV, டிப்பர் மற்றும் டிரெய்லர்களை வாடகைக்கு எடுங்கள்.",
        constructionVehiclesTitle: "கட்டுமான வாகனங்கள் & எர்த்மூவர்கள்",
        constructionVehiclesDesc: "உங்கள் கட்டுமான தள பணிகளுக்கு சரிபார்க்கப்பட்ட JCB, அகழ்வாராய்ச்சிகள், கிரேன்கள் மற்றும் ரோலர்களை வாடகைக்கு எடுங்கள்.",
        equipmentRentalsPageTitle: "உபகரண வாடகைகள்",
        equipmentRentalsPageDesc: "தொழில்துறை ஜெனரேட்டர்கள், கம்ப்ரசர்கள் மற்றும் தூக்கும் இயந்திரங்கள் தேவைக்கேற்ப கிடைக்கின்றன.",
        noEquipmentFound: "இந்த பிரிவில் உபகரணங்கள் எதுவும் கிடைக்கவில்லை.",
        loadingEquipment: "உபகரணங்கள் ஏற்றப்படுகின்றன...",
        aboutUsTitle: "எங்களைப் பற்றி",
        aboutLead: "காரோடிரக் என்பது இந்தியா முழுவதும் ஜேசிபி, அகழ்வாராய்ச்சியாளர்கள் மற்றும் கனரக கட்டுமான உபகரணங்களை நேரடியாகவும், நம்பகமாகவும், வெளிப்படையாகவும் வாடகைக்கு எடுக்க உருவாக்கப்பட்ட ஒரு தேவையின்பேரிலான தொழில்நுட்ப தளமாகும்.",
        theProblem: "சிக்கல்",
        theProblemP1: "இந்தியா முழுவதும் கனரக கட்டுமான இயந்திரங்களை பெறுவது வரலாற்று ரீதியாக துண்டுதுண்டாகவும் திறமையற்றதாகவும் இருந்து வருகிறது. நம்பகமான ஜேசிபி, அகழ்வாராய்ச்சி, டிப்பர் அல்லது கிரேனைப் பெறுவது பொதுவாக பல தரகர்கள், கணிக்க முடியாத கட்டணங்கள் மற்றும் நிலையற்ற இயந்திரக் கிடைக்கும் தன்மையை உள்ளடக்கியது.",
        theProblemP2: "இயந்திர உரிமையாளர்களுக்கு, விலையுயர்ந்த சொத்துக்கள் நிலையான தேவை இல்லாமல் ஒப்பந்தங்களுக்கு இடையே சும்மா கிடக்கின்றன. ஒப்பந்ததாரர்கள் மற்றும் தளப் பொறியாளர்களுக்கு, இயந்திர வருகை தாமதமாவது திட்ட காலக்கெடுவை நிறுத்துகிறது மற்றும் செலவுகளை அதிகரிக்கிறது.",
        theSolution: "தீர்வு",
        theSolutionP1: "காரோடிரக் ஒரு ஒருங்கிணைந்த டிஜிட்டல் சந்தையை அறிமுகப்படுத்துகிறது. ஒப்பந்தக்காரர்கள், பில்டர்கள் மற்றும் டெவலப்பர்களை சரிபார்க்கப்பட்ட வாகனக் கூட்டாளர்களுடன் நேரடியாக இணைக்கிறோம்.",
        theSolutionP2: "இடைத்தரகர் கூடுதல் கட்டணங்களை நீக்கி நேரடி பொருத்தத்தை வழங்குவதன் மூலம், காரோடிரக் நியாயமான விலை நிர்ணயம், விரைவான அனுப்புதல் மற்றும் தளத்தில் நம்பகமான செயல்பாட்டை உறுதி செய்கிறது.",
        onDemandDispatch: "தேவையின் பேரில் அனுப்புதல்",
        onDemandDispatchDesc: "உங்கள் பணியிடத்திற்கு ஜேசிபிகள், அகழ்வாராய்ச்சியாளர்கள், டிப்பர்கள் மற்றும் கிரேன்களை சில படிகளில் நேரடியாக முன்பதிவு செய்யுங்கள்.",
        transparentTerms: "வெளிப்படையான விதிமுறைகள்",
        transparentTermsDesc: "வாடிக்கையாளர்களுக்கும் உபகரண உரிமையாளர்களுக்கும் இடையே பூஜ்ஜிய மறைமுக தரகர் கட்டணங்களுடன் நேரடி இணைப்பு.",
        verifiedPartnersPillar: "சரிபார்க்கப்பட்ட கூட்டாளர்கள்",
        verifiedPartnersPillarDesc: "நம்பகமான இயந்திர தரம் மற்றும் தொழில்முறை தள விநியோகத்தை உறுதிப்படுத்த ஒவ்வொரு உபகரணக் கூட்டாளரும் சரிபார்க்கப்படுகிறார்கள்.",
        leadership: "தலைமை",
        founderRole: "நிறுவனர் மற்றும் தலைமை நிர்வாக அதிகாரி (CEO)",
        founderBio1: "இந்தியாவின் கனரக வாகனம் மற்றும் கட்டுமான இயந்திர வாடகை சூழல் அமைப்பில் உள்ள செயல்பாட்டு உராய்வு மற்றும் திறமையின்மையை தீர்க்க ஜாஃபர் சாஹுசைன் காரோடிரக்கை நிறுவினார்.",
        founderQuote: "\"எங்கள் நோக்கம் நேரடியானது: உபகரண உரிமையாளர்களுக்கான இயந்திர வேலையில்லா நேரத்தை அகற்றுவது மற்றும் கேப் முன்பதிவு செய்வது போன்ற எளிமை மற்றும் வெளிப்படைத்தன்மையுடன் சரிபார்க்கப்பட்ட கனரக இயந்திரங்களை முன்பதிவு செய்யும் திறனை ஒப்பந்தக்காரர்களுக்கு வழங்குவது. நேர்மையான பயன்பாடு, நம்பகத்தன்மை மற்றும் தொழில்நுட்பத்தின் அடிப்படையில் இந்த தளத்தை நாங்கள் உருவாக்குகிறோம்.\"",
        founderBio2: "நிறுவனர் மற்றும் தலைமை நிர்வாக அதிகாரியாக, ஜாஃபர் இந்தியா முழுவதும் தயாரிப்பு மேம்பாடு, தொழில்நுட்பம் மற்றும் வாகனக் கூட்டாளர் செயல்பாடுகளை மேற்பார்வையிடுகிறார்.",
        getStartedKaroTrukk: "காரோடிரக்குடன் தொடங்குங்கள்",
        bookOrRegisterToday: "உங்கள் தளத்திற்கு இயந்திரங்களை முன்பதிவு செய்யுங்கள் அல்லது இன்றே உங்கள் வாகனப் பிரிவை பதிவு செய்யுங்கள்.",
        joinAsFleetPartner: "வாகன கூட்டாளராக இணையுங்கள்",
        getInTouch: "தொடர்பு கொள்ளுங்கள்",
        haveQuestionsAssistance: "உபகரணங்களை முன்பதிவு செய்வது அல்லது வாகனக் கூட்டாளராக இணைவது குறித்து ஏதேனும் கேள்விகள் உள்ளதா? உங்களுக்கு உதவ நாங்கள் இங்கு இருக்கிறோம்.",
        directInquiries: "நேரடி விசாரணைகள்",
        connectOpsTeamDesc: "காரோடிரக் செயல்பாடுகள் மற்றும் ஆன்போர்டிங் குழுவுடன் இணையுங்கள். இந்தியா முழுவதும் உள்ள ஒப்பந்தக்காரர்கள் மற்றும் வாகனக் கூட்டாளர்களுக்கு நாங்கள் உதவுகிறோம்.",
        corporateOffice: "கார்ப்பரேட் அலுவலகம்",
        fleetPartnerDesk: "வாகன கூட்டாளர் மையம்",
        platformNotice: "தள அறிவிப்பு",
        platformNoticeDesc: "உடனடி அவசர தள முன்பதிவு அல்லது கூட்டாளர் ஆன்போர்டிங் விசாரணைகளுக்கு, கீழே உங்கள் செய்தியைச் சமர்ப்பிக்கவும், எங்கள் குழு நேரடியாக தொடர்பு கொள்ளும்.",
        connectWithKaroTrukk: "காரோடிரக்குடன் இணையுங்கள்",
        reachingOutAs: "நான் தொடர்பு கொள்வது",
        optClient: "வாடிக்கையாளர் (ஜேசிபி / கனரக இயந்திரங்களை முன்பதிவு செய்ய வேண்டும்)",
        optFleetPartner: "வாகன கூட்டாளர் (உபகரணங்கள் / லாரி உரிமையாளர்)",
        optEnterprise: "நிறுவனம் / உள்கட்டமைப்பு ஒப்பந்ததாரர்",
        optGeneralInquiry: "பொது விசாரணை",
        fullName: "முழு பெயர்",
        enterYourName: "உங்கள் பெயரை உள்ளிடவும்",
        emailAddress: "மின்னஞ்சல் முகவரி",
        phoneWhatsApp: "தொலைபேசி / வாட்ஸ்அப் எண்",
        subject: "பொருள்",
        briefSubject: "விசாரணையின் சுருக்கமான பொருள்",
        message: "செய்தி",
        describeRequirement: "உங்கள் உபகரண தேவை அல்லது வாகன விவரங்களை விவரிக்கவும்...",
        sendInquiry: "விசாரணையை அனுப்பவும்",
        thankYouContact: "எங்களைத் தொடர்பு கொண்டதற்கு நன்றி! விரைவில் உங்களைத் தொடர்புகொள்வோம்.",
        howCanWeHelp: "நாங்கள் எவ்வாறு உதவ முடியும்?",
        searchHelpInput: "கேள்விகளைத் தேடுங்கள் (எ.கா. ஜேசிபி முன்பதிவு, வாகனக் கூட்டாளர், கண்காணிப்பு)...",
        machineryBooking: "இயந்திர முன்பதிவு",
        machineryBookingDesc: "ஜேசிபிகள், அகழ்வாராய்ச்சியாளர்கள், டிப்பர்கள் & கிரேன்கள்",
        fleetPartnerNetwork: "வாகன கூட்டாளர் நெட்வொர்க்",
        fleetPartnerNetworkDesc: "வாகன ஆன்போர்டிங் மற்றும் சரிபார்ப்பு",
        siteDispatchGps: "தள அனுப்புதல் & ஜிபிஎஸ்",
        siteDispatchGpsDesc: "நேரலை கண்காணிப்பு & பாதை டெலிமேடிக்ஸ்",
        directBilling: "நேரடி பில்லிங்",
        directBillingDesc: "0% தரகர் கூடுதல் கட்டணங்கள் & கட்டணங்கள்",
        helpFaq1Q: "காரோடிரக்கில் கேப்-பாணி இயந்திர முன்பதிவு எவ்வாறு செயல்படுகிறது?",
        helpFaq1A: "காரோடிரக் கட்டுமான இயந்திரங்களுக்காக வடிவமைக்கப்பட்ட ஒரு தேவையின்பேரிலான சவாரி சேவை போல செயல்படுகிறது. உங்களுக்குத் தேவையான உபகரணங்களைத் தேர்ந்தெடுத்து, உங்கள் தள முகவரி மற்றும் அட்டவணையை வழங்கினால், சில கிளிக்குகளில் உங்கள் பகுதியில் உள்ள சரிபார்க்கப்பட்ட வாகனக் கூட்டாளர்களுடன் நேரடியாக இணைக்கப்படுவீர்கள்.",
        helpFaq2Q: "நான் என்ன வகையான இயந்திரங்கள் மற்றும் கனரக வாகனங்களை முன்பதிவு செய்யலாம்?",
        helpFaq2A: "கட்டுமானம், தள சமன்படுத்துதல், அகழ்வாராய்ச்சி மற்றும் தொழில்துறை பொருள் போக்குவரத்திற்காக ஜேசிபி & பேக்ஹோ லோடர்கள், அகழ்வாராய்ச்சியாளர்கள், டிப்பர்கள், கிரேன்கள், நீர் டேங்கர்கள் மற்றும் வணிக லாரிகள் உள்ளிட்ட பரந்த அளவிலான சரிபார்க்கப்பட்ட உபகரணங்களை நீங்கள் முன்பதிவு செய்யலாம்.",
        helpFaq3Q: "வாகனம் மற்றும் உபகரண உரிமையாளர்கள் வாகனக் கூட்டாளர்களாக எவ்வாறு இணைவது?",
        helpFaq3A: "இயந்திர உரிமையாளர்கள் 'வாகனக் கூட்டாளராக இணையுங்கள்' என்பதைக் கிளிக் செய்து பதிவு செய்யலாம். உங்கள் வாகன விவரங்கள், ஆர்சி, ஆவணங்கள் மற்றும் சேவை இருப்பிடத்தை உள்ளிடவும். சரிபார்க்கப்பட்டதும், இடைத்தரகர்கள் இன்றி உங்கள் டாஷ்போர்டில் நேரடி முன்பதிவு கோரிக்கைகளைப் பெறத் தொடங்குவீர்கள்.",
        helpFaq4Q: "ஏதேனும் மறைமுக தரகர் கமிஷன்கள் அல்லது இடைத்தரகர் கூடுதல் கட்டணங்கள் உள்ளதா?",
        helpFaq4A: "இல்லை. காரோடிரக் 0% மறைமுக இடைத்தரகர் கட்டணக் கொள்கையுடன் வெளிப்படைத்தன்மையுடன் கட்டமைக்கப்பட்டுள்ளது. ஒப்பந்தக்காரர்களும் உபகரண உரிமையாளர்களும் நேரடி விதிமுறைகளுடன் செயல்படுகிறார்கள், பாரம்பரிய தரகர் கமிஷன்களை நீக்குகிறார்கள்.",
        helpFaq5Q: "தள அனுப்புதல் மற்றும் கண்காணிப்பு எவ்வாறு செயல்படுகிறது?",
        helpFaq5A: "ஒரு வாகனக் கூட்டாளர் உங்கள் முன்பதிவு கோரிக்கையை ஏற்றுக்கொண்டவுடன், உங்கள் டாஷ்போர்டு மூலம் வாகனத்தின் நிகழ்நேர போக்குவரத்து நிலையை நீங்கள் கண்காணிக்கலாம், திட்ட மேலாளர்களுக்கு துல்லியமான வருகை நேரத்தை வழங்கலாம்.",
        helpFaq6Q: "காரோடிரக்கை நிறுவி இயக்குபவர் யார்?",
        helpFaq6A: "காரோடிரக் ஜாஃபர் சாஹுசைன் (நிறுவனர் மற்றும் தலைமை நிர்வாக அதிகாரி) என்பவரால் நிறுவப்பட்டது. இந்தியாவின் கனரக வாகனம் மற்றும் கட்டுமான இயந்திர வாடகை சூழலை தேவைக்கேற்ப முன்பதிவு மற்றும் வெளிப்படையான விலையுடன் டிஜிட்டல் மயமாக்குவதற்கு இந்த தளம் அர்ப்பணிக்கப்பட்டுள்ளது.",
        haveSpecificQuery: "குறிப்பிட்ட தளம் அல்லது வாகன வினவல் உள்ளதா?",
        opsTeamAssistance: "எங்கள் பிரத்யேக செயல்பாட்டுக் குழு ஒப்பந்தக்காரர்கள் மற்றும் இயந்திர உரிமையாளர்களுக்கு உதவ தயாராக உள்ளது.",
        contactOpsTeam: "செயல்பாட்டுக் குழுவைத் தொடர்பு கொள்ளுங்கள்",
        verifiedPartner: "சரிபார்க்கப்பட்ட கூட்டாளர்",
        driverIncluded: "ஓட்டுநர் சேர்க்கப்பட்டுள்ளது",
        helperIncluded: "உதவியாளர் சேர்க்கப்பட்டுள்ளது",
        kmAway: "கிமீ தொலைவில்",
        quoteOnRequest: "கோரிக்கையின் பேரில் விலை",
        rentalRate: "வாடகை விகிதம்",
        featureComesSoon: "இந்த அம்சம் விரைவில் வரவுள்ளது.",
        book: "முன்பதிவு",
        rentalRateNotice: "வாடகை விகித அறிவிப்பு",
        rateForRentingTime: "கட்டணம் வாடகை நேரத்திற்கானது, ஒரு வழிப் பயணத்திற்கு அல்ல",
        rateForRentingTimeDesc: "காட்டப்படும் விலை உங்கள் தளத்தில் உள்ள வாகனம் மற்றும் உபகரணங்களுக்கான மணிநேர அல்லது தினசரி வாடகை விகிதமாகும்.",
        notOneWayTrip: "வழக்கமான டாக்ஸி சவாரி அல்ல",
        notOneWayTripDesc: "தேவைப்படும் வேலையின் காலத்திற்கு கனரக இயந்திரங்கள் உங்கள் தளத்திலேயே இருக்கும்.",
        gotIt: "புரிந்தது",
        getEquipmentInstantly: "தேவையின் பேரில் கனரக இயந்திரங்கள் & போக்குவரத்து வாகனங்களைப் பெறுங்கள்",
        whatDoYouNeedToday: "இன்று உங்களுக்கு என்ன தேவை?",
        heavyVehicles: "கனரக வாகனங்கள்",
        constructionMachinery: "கட்டுமான இயந்திரங்கள்",
        tankers: "டேங்கர்கள்",
        equipmentSiteMachinery: "உபகரணங்கள் மற்றும் தள இயந்திரங்கள்",
        lcvsTippers: "எல்சிவி, டிப்பர்கள், லாரிகள்",
        jcbsExcavators: "ஜேசிபிகள், அகழ்வாராய்ச்சியாளர்கள், லோடர்கள்",
        waterTankerSewage: "நீர் மற்றும் கழிவுநீர் டேங்கர்கள்",
        generatorsAirCompressors: "ஜெனரேட்டர்கள், கம்ப்ரஸர்கள்",
        siteArrivalLocation: "தளம் / வருகை இடம்",
        dropoffLocation: "இறக்கும் இடம் (விருப்பத்தேர்வு)",
        popularHouseholdServices: "பிரபலமான அன்றாட சேவைகள்",
        landGardenCleaning: "தளம் & நிலம் சுத்தம் செய்தல்",
        moveYourLoad: "உங்கள் சுமையை நகர்த்தவும்",
        tankFillingWaterDelivery: "தண்ணீர் டேங்கர் விநியோகம்",
        pathHoleDebrisFilling: "குழி மற்றும் இடிபாடுகள் நிரப்புதல்",
        generatorRental: "ஜெனரேட்டர் வாடகை",
        landLevelling: "நிலம் சமன்படுத்துதல்",
        availableNearYou: "உங்கள் அருகில் கிடைப்பவை",
        discoveredWithinRadar: "0-20 கிமீ ரேடாரில் கண்டறியப்பட்டது",
        heavyTab: "கனரக லாரிகள்",
        constructionTab: "கட்டுமானம்",
        tankerTab: "டேங்கர்கள்",
        equipmentTab: "உபகரணங்கள்",
        noVehiclesNearby: "அருகில் இந்த பிரிவில் வாகனங்கள் எதுவும் கிடைக்கவில்லை",
        noVehiclesNearbyDesc: "வகையை மாற்ற முயற்சிக்கவும் அல்லது உங்கள் இருப்பிடத் தேடலை விரிவாக்கவும்",
        home: "முகப்பு",
        forContractors: "ஒப்பந்தக்காரர்களுக்கு",
        requestQuote: "விலைப்புள்ளி கோருங்கள்",
        accountMenu: "கணக்கு மெனு",
        back: "பின்செல்",
        bookNowInstant: "உடனடி இயந்திர முன்பதிவு",
        requestQuoteService: "தனிப்பயன் விலைப்புள்ளி கோரவும்",
        paymentsInvoices: "பணம் மற்றும் விலைப்பட்டியல்கள்",
        favoritePartners: "விருப்பமான கூட்டாளர்கள்",
        supportCenter: "ஆதரவு மையம்",
        myBusiness: "என் முன்பதிவுகள் & வணிகம்",
        expectedRent: "எதிர்பார்க்கப்படும் வாடகை",
        day: "நாள்",
        processing: "செயலாக்குகிறது...",
        reserveThisVehicle: "இந்த வாகனத்தை முன்பதிவு செய்",
        reservationSent: "முன்பதிவு கோரிக்கை அனுப்பப்பட்டது!",
        confirmCancelTitle: "முன்பதிவை ரத்துசெய்",
        confirmCancel: "இந்த முன்பதிவை நிச்சயமாக ரத்து செய்ய விரும்புகிறீர்களா?",
        notApprovedNotice: "உங்கள் கணக்கு சரிபார்ப்பில் உள்ளது. எங்கள் குழு உங்கள் ஆவணங்களை மதிப்பாய்வு செய்கிறது.",
        newOrders: "புதிய ஆர்டர்கள்",
        completeProfileNotice: "சுயவிவரத்தை முடிக்கவும்",
        drivers: "ஓட்டுநர்கள்",
        lightMode: "லைட் பயன்முறை",
        darkMode: "டார்க் பயன்முறை",
        totalFleet: "மொத்த வாகனங்கள்",
        onServiceTrips: "சேவையில் உள்ள பயணங்கள்",
        completedShipmentsStat: "நிறைவடைந்த பயணங்கள்",
        viewAll: "அனைத்தையும் காண்க",
        payment: "கட்டணம்",
        contact: "தொடர்பு",
        confirmDeleteTitle: "வாகனத்தை நீக்கு",
        delete: "நீக்கு",
        profileDetailsSub: "உங்கள் சுயவிவர விவரங்கள் மற்றும் தொடர்புத் தகவலை நிர்வகிக்கவும்",
        yardSettingsTab: "யார்டு இருப்பிடம்",
        yardSettingsSub: "உங்கள் அடிப்படை யார்டு மற்றும் அனுப்பும் சுற்றளவை உள்ளமைக்கவும்",
        bankDetailsSub: "வாராந்திர தானியங்கி பணம் பெறுவதற்கான வங்கிக் கணக்குகளை நிர்வகிக்கவும்",
        securitySub: "உங்கள் கணக்கு கடவுச்சொல் மற்றும் பாதுகாப்பு விருப்பங்களை புதுப்பிக்கவும்",
        notificationsSub: "எஸ்எம்எஸ், வாட்ஸ்அப் மற்றும் போர்டல் எச்சரிக்கை விருப்பங்களை உள்ளமைக்கவும்",
        saving: "சேமிக்கிறது...",
        linkCopiedSuccess: "கண்காணிப்பு இணைப்பு நகலெடுக்கப்பட்டது!",
        shareFailed: "இணைப்பைப் பகிர முடியவில்லை",
        login: "உள்நுழை",
        joinNow: "இப்போதே இணையுங்கள்",
        maximizeRevenue: "வாகன வருவாயை அதிகரிக்கவும்",
        fleetRevenue: "வாகன வருவாய்",
        fleetHeroSub: "உங்கள் ஜேசிபிகள், அகழ்வாராய்ச்சியாளர்கள், டிப்பர்கள் மற்றும் கிரேன்களை இந்தியா முழுவதும் உள்ள ஆயிரக்கணக்கான சரிபார்க்கப்பட்ட ஒப்பந்தக்காரர்களுடன் இணைக்கவும்.",
        startEarningToday: "இன்றே சம்பாதிக்கத் தொடங்குங்கள்",
        watchHowItWorks: "எப்படி செயல்படுகிறது எனப் பாருங்கள்",
        fleetPartners: "வாகன கூட்டாளர்கள்",
        activeLoads: "செயலில் உள்ள சுமை",
        citiesCovered: "நகரங்கள்",
        payoutsDisbursed: "வழங்கப்பட்ட கொடுப்பனவுகள்",
        helpCenter: "உதவி மையம்",
        rentNow: "இப்போதே வாடகைக்கு எடுக்க",
        noWaterTankersAvailable: "தற்போது தண்ணீர் டேங்கர்கள் எதுவும் கிடைக்கவில்லை.",
        loadingWaterTankers: "தண்ணீர் டேங்கர்கள் ஏற்றப்படுகின்றன...",
        servicesNav: "சேவைகள்",
    },
    hi: {
        client: "ग्राहक",
        fleetPartner: "फ्लीट पार्टनर",
        dashboard: "डैशबोर्ड पर जाएं",
        aboutUs: "हमारे बारे में",
        help: "सहायता",
        contactUs: "संपर्क करें",
        logout: "लॉगआउट",
        heroTitle1: "जेसीबी और उपकरण मशीनरी,",
        heroTitle2: "कुछ ही चरणों में बुक करें।",
        heroSub: "जेसीबी और उपकरण मशीनरी की कुछ ही चरणों में कैब जैसी बुकिंग - भारत का पहला प्लेटफॉर्म।",
        bookVehicle: "वाहन बुक करें",
        joinFleet: "फ्लीट पार्टनर के रूप में जुड़ें",
        hireTrucksTitle: "ट्रक और मशीनरी किराए पर लें",
        enterPickupLocation: "पिकअप स्थान दर्ज करें",
        enterDropLocation: "ड्रॉप स्थान दर्ज करें",
        getPriceQuotes: "मूल्य उद्धरण प्राप्त करें",
        onePlatform: "सभी भारी वाहनों की जरूरतों के लिए एक मंच",
        onePlatformSub: "बिना किसी बिचौलिये के बुकिंग प्रबंधित करें, काम ट्रैक करें और सीधे सत्यापित फ्लीट पार्टनर्स से जुड़ें।",
        equipmentTitle: "अपने अगले प्रोजेक्ट के लिए सही उपकरण खोजें।",
        equipmentRentals: "उपकरण किराया",
        viewAllEquipment: "सभी उपकरण श्रेणियां देखें →",
        scissorLiftTitle: "सिज़र लिफ्ट किराया",
        scissorLiftDesc: "अपने स्थिर प्लेटफार्मों, उच्च भार क्षमता, बहुमुखी प्रतिभा और व्यापक पहुंच के साथ, कैंची लिफ्ट वाणिज्यिक और औद्योगिक स्थलों के वर्कहॉर्स हैं।",
        generatorTitle: "जनरेटर किराया",
        generatorDesc: "निर्माण स्थलों और औद्योगिक जरूरतों के लिए विश्वसनीय बिजली समाधान। पोर्टेबल और ट्रेलर-माउंटेड जनरेटर उपलब्ध हैं।",
        boomLiftTitle: "बूम लिफ्ट किराया",
        boomLiftDesc: "कठिन क्षेत्रों तक पहुँचने के लिए आर्टिकुलेटिंग और टेलीस्कोपिक बूम लिफ्ट। निर्माण और रखरखाव के काम के लिए आदर्श।",
        forkliftTitle: "फोर्कलिफ्ट और सामग्री हैंडलिंग किराया",
        forkliftDesc: "गोदामों, निर्माण स्थलों और औद्योगिक सुविधाओं के लिए कुशल सामग्री हैंडलिंग समाधान।",
        singleManLiftTitle: "सिंगल मैन लिफ्ट किराया",
        singleManLiftDesc: "एकल ऑपरेटर उपयोग के लिए डिज़ाइन की गई कॉम्पैक्ट वर्टिकल लिफ्ट। रखरखाव और हल्के निर्माण कार्य के लिए बिल्कुल सही।",
        earthmovingTitle: "अर्थमूविंग उपकरण किराया",
        earthmovingDesc: "खुदाई, ग्रेडिंग और मिट्टी के काम के लिए भारी मशीनरी। मिनी उत्खनन से लेकर बड़े डोजर तक।",
        compactionTitle: "कम्पैक्शन उपकरण किराया",
        compactionDesc: "सड़क निर्माण और मिट्टी संघनन मशीनरी। उचित जमीन की तैयारी और सतह परिष्करण सुनिश्चित करें।",
        craneTitle: "क्रेन किराया",
        craneDesc: "निर्माण और औद्योगिक परियोजनाओं के लिए भारी उठाने के समाधान। मोबाइल और टॉवर क्रेन उपलब्ध हैं।",
        equipmentId: "उपकरण आईडी",
        by: "द्वारा",
        setLocationRates: "दरें देखने के लिए स्थान सेट करें",
        showMore: "और दिखाएं",
        details: "विवरण",
        waterTankerTitle: "पानी के टैंकर की जरूरत है?",
        waterTankerSubTitle: "अपने नजदीकी पानी के टैंकर से जुड़ें",
        waterTankerDesc: "निर्माण, कार्यक्रमों, औद्योगिक उपयोग या आपातकालीन आपूर्ति के लिए पानी चाहिए? KaroTrukk आपको अपने क्षेत्र में सत्यापित ऑपरेटरों को तुरंत खोजने और बुक करने में मदद करता है।",
        fastAvailability: "तेजी से उपलब्धता",
        flexibleCapacity: "लचीली क्षमता",
        transparentPricing: "पारदर्शी मूल्य निर्धारण",
        reliablePartners: "विश्वसनीय साथी",
        waterTankerServices: "पानी टैंकर सेवाएं",
        waterTankerServicesDesc: "आपकी सभी जरूरतों के लिए विश्वसनीय जल वितरण समाधान। पीने के पानी से लेकर निर्माण स्थल की आवश्यकताओं तक, सही क्षमता तुरंत बुक करें।",
        backToHome: "होम पर वापस जाएं",
        bulkBookingTitle: "एकल या थोक भारी वाहनों को बुक करने के लिए एक मंच",
        realTimeVisibilityTitle: "रियल-टाइम विजिबिलिटी",
        realTimeVisibilityDesc: "हमारे उन्नत जीपीएस एकीकरण के साथ अपने सामान की हर गतिविधि को ट्रैक करें। जानें कि आपका शिपमेंट कब और कहां है।",
        secureBusinessTitle: "सुरक्षित व्यवसाय",
        secureBusinessDesc: "निर्माण कंपनियां और व्यवसाय मालिक ठेकेदार बेड़े की खोज कर सकते हैं और मिनटों में ट्रक या मशीनरी बुक कर सकते हैं।",
        dataDrivenTitle: "डेटा-संचालित अंतर्दृष्टि",
        dataDrivenDesc: "मार्गों को अनुकूलित करने, लागत कम करने और समग्र बेड़े दक्षता में सुधार करने के लिए ऐतिहासिक डेटा और भविष्य कहनेवाला विश्लेषण का लाभ उठाएं।",
        gpsTrackingTitle: "पूर्ण मानसिक शांति के लिए रियल-टाइम ट्रैकिंग",
        gpsTrackingDesc: "KarossStore की उद्योग-अग्रणी जीपीएस तकनीक के साथ अपनी संपत्ति की रक्षा करें और दक्षता को अधिकतम करें। चोरी की रोकथाम से लेकर ईंधन अनुकूलन तक, अपने ट्रकों पर नज़र रखना कभी आसान नहीं रहा।",
        liveGeofencing: "लाइव जियोफेंसिंग और इंस्टेंट अलर्ट",
        routeHistory: "रूट इतिहास और ईंधन अनुकूलन",
        durableHardware: "कॉम्पैक्ट, वाटरप्रूफ और टिकाऊ हार्डवेयर",
        shopNow: "KarossStore.in पर खरीदारी करें",
        testimonials: "प्रशंसापत्र",
        testimonialsSub: "यहाँ लोग क्या कह रहे हैं",
        company: "कंपनी",
        quickLinks: "त्वरित लिंक",
        support: "सहायता",
        countries: "देश",
        tnCities: "तमिलनाडु के शहर",
        allRightsReserved: "सर्वाधिकार सुरक्षित।",
        followUs: "हमें फॉलो करें",
        careers: "करियर",
        blog: "ब्लॉग",
        privacyPolicy: "गोपनीयता नीति",
        termsOfService: "सेवा की शर्तें",
        insuranceFaqs: "बीमा अक्सर पूछे जाने वाले प्रश्न",
        clientTitle: "ग्राहक",
        clientDesc: "KaroTrukk के साथ अपने प्रोजेक्ट लॉजिस्टिक्स में क्रांति लाएं। चाहे आपको एक दिन के लिए एक जेसीबी की आवश्यकता हो या बड़े पैमाने पर निर्माण परियोजना के लिए भारी ट्रकों के बेड़े की, हमारा मंच आपको तुरंत सत्यापित मालिकों से जोड़ता है।",
        fleetTitle: "फ्लीट पार्टनर",
        fleetDesc: "अपनी भारी मशीनरी को काम पर लगाएं और अपनी कमाई को अधिकतम करें। KaroTrukk जेसीबी, क्रेन और ट्रक मालिकों को लगातार, उच्च-मूलय वाले प्रोजेक्ट लीड से जोड़ता है।",
        trackVehicles: "अपने सक्रिय वाहनों को ट्रैक करें",
        track: "ट्रैक करें",
        needVehicle: "वाहन चाहिए?",
        bookRentalSub: "अभी रेंटल या त्वरित यात्रा बुक करें।",
        bookRentalSubDesc: "पूरे भारत में हजारों सत्यापित भागीदारों तक पहुंचें।",
        trackVehiclesDesc: "वास्तविक समय में अपने शिपमेंट और सक्रिय बुकिंग की निगरानी करें।",
        bookNow: "अभी बुक करें",
        searchByCompany: "कंपनी द्वारा खोजें",
        trustCompanies: "उन कंपनियों के साथ बुक करें जिन पर आप भरोसा करते हैं",
        searchPlaceholder: "कंपनियों की खोज करें...",
        search: "खोजें",
        availableVehicles: "उपलब्ध वाहन",
        premiumSolutions: "पूरे भारत में प्रीमियम लॉजिस्टिक्स समाधान",
        filterBy: "इसके द्वारा फ़िल्टर करें",
        viewDetails: "विवरण देखें",
        reserveNow: "अभी आरक्षित करें",
        requestedBookings: "अनुरोधित बुकिंग",
        acceptedBookings: "स्वीकृत बुकिंग",
        pastBookings: "पिछली बुकिंग",
        bookingsCount: "बुकिंग",
        locateFleet: "अपने बेड़े का पता लगाएँ",
        personalSolutions: "सभी के लिए विश्वसनीय वितरण समाधान",
        searchTypePlaceholder: "वाहन के प्रकार या मॉडल द्वारा खोजें...",
        matchesFound: "मिलान मिले",
        personalAccount: "व्यक्तिगत खाता",
        businessAccount: "व्यावसायिक खाता",
        trackFleetTab: "फ्लीट ट्रैक करें",
        bookingsTab: "बुकिंग्स",
        shipmentsTab: "मेरे शिपमेंट",
        dashboardTab: "डैशबोर्ड",
        menu: "मेनू",
        myBookings: "मेरी बुकिंग",
        premiumPass: "प्रीमियम पास",
        liveMap: "लाइव मैप",
        liveTracking: "लाइव ट्रैकिंग",
        inbox: "इनबॉक्स",
        documents: "दस्तावेज़",
        settings: "सेटिंग्स",
        account: "खाता",
        theme: "थीम",
        supportChat: "सपोर्ट चैट",
        signOut: "साइन आउट",
        bookTruck: "ट्रक बुक करें",
        construction: "निर्माण",
        gpsTrackers: "जीपीएस ट्रैकर्स",
        onlyClientCanBook: "केवल ग्राहक ही सेवाएं बुक कर सकते हैं",
        myProfile: "मेरी प्रोफ़ाइल",
        dashboardText: "डैशबोर्ड",
        requests: "अनुरोध",
        returnLoad: "रिटर्न लोड",
        fleetManagement: "फ्लीट प्रबंधन",
        shipments: "शिपमेंट",
        routePlanning: "मार्ग योजना",
        analytics: "एनालिटिक्स",
        history: "इतिहास",
        reviews: "समीक्षाएं",
        settlement: "सेटलमेंट",
        font: "फ़ॉन्ट",
        searchVehicle: "वाहन नंबर खोजें...",
        partnerDashboard: "पार्टनर डैशबोर्ड",
        planRoute: "मार्ग योजना",
        loadingDashboard: "डैशबोर्ड लोड हो रहा है...",
        vsYesterday: "कल की तुलना में",
        performanceAnalytics: "प्रदर्शन विश्लेषण",
        analyticsSubtitle: "आपके बेड़े के संचालन और राजस्व की गहरी जानकारी",
        operationalMetrics: "परिचालन मेट्रिक्स",
        active: "सक्रिय",
        idle: "निष्क्रिय",
        service: "सेवा",
        noVehicles: "कोई वाहन नहीं",
        fleetUtilization: "बेड़े का उपयोग",
        awaitingFleetData: "बेड़े डेटा की प्रतीक्षा की जा रही है",
        addVehiclesToTrack: "उपयोग को ट्रैक करने के लिए वाहन जोड़ें",
        units: "इकाइयों",
        weeklyRevenue: "साप्ताहिक राजस्व",
        realTimeEarningsByDay: "दिन के अनुसार रीयल-टाइम आय",
        noDataAvailableThisWeek: "इस सप्ताह कोई डेटा उपलब्ध नहीं है",
        last7Days: "पिछले 7 दिन",
        waitingForData: "डेटा की प्रतीक्षा की जा रही है...",
        totalVehicles: "कुल वाहन",
        acceptedRequestsDash: "स्वीकृत अनुरोध",
        onTripBookings: "यात्रा बुकिंग",
        totalEarnings: "कुल आय",
        fullScreen: "पूर्ण स्क्रीन",
        fleetLiveTrack: "फ्लीट लाइव ट्रैक",
        earnings: "आय",
        thisMonth: "इस माह",
        onTrip: "यात्रा पर",
        potentialPending: "संभावित/लंबित",
        realTimeGrowth: "वास्तविक समय की वृद्धि",
        viewStatement: "विवरण देखें",
        fleetStatus: "वाहन की स्थिति",
        vehiclesCount: "वाहन",
        online: "ऑनलाइन",
        deliveryPerformance: "डिलीवरी प्रदर्शन",
        weekly: "साप्ताहिक",
        waitingPerformanceData: "प्रदर्शन डेटा की प्रतीक्षा की जा रही है",
        completeFirstTrip: "एनालिटिक्स अनलॉक करने के लिए अपनी पहली यात्रा पूरी करें",
        orderStatus: "ऑर्डर की स्थिति",
        calculatingStatus: "स्थिति की गणना की जा रही है...",
        yourVehiclesOverview: "आपके वाहनों का अवलोकन",
        total: "कुल",
        ratings: "रेटिंग",
        noVehiclesActive: "अभी तक कोई वाहन सक्रिय नहीं है। एक जोड़कर शुरू करें!",
        youLabel: "आप",
        onTripManagement: "यात्रा प्रबंधन",
        bookingLabel: "बुकिंग:",
        inTransit: "रास्ते में",
        confirmed: "पुष्टि की",
        stepLabel: "कदम",
        clientLabel: "ग्राहक:",
        earningsLabel: "कमाई:",
        startedLabel: "शुरू हुआ:",
        endingLabel: "समाप्त:",
        markDelivered: "डिलीवर किया गया मार्क करें",
        contactAction: "संपर्क करें",
        reportAction: "रिपोर्ट करें",
        activeStatusObj: "● सक्रिय",
        ratingLabel: "रेटिंग",
        bookingsLabel: "बुकिंग",
        needLabel: "जरूरत",
        priceLabel: "मूल्य",
        routeLabel: "मार्ग",
        profitabilityLabel: "लाभप्रदता",
        viewDetailsAction: "विवरण देखें",
        acceptAction: "स्वीकार करें",
        routeLocations: "मार्ग और स्थान",
        arrivalPickup: "आगमन (पिकअप)",
        viewInMap: "मानचित्र में देखें",
        targetDropoff: "लक्ष्य (ड्रॉपऑफ)",
        localDelivery: "स्थानीय डिलीवरी",
        datesTimeline: "तिथियां और समयरेखा",
        pickupLabel: "पिकअप",
        estimatedCompletion: "अनुमानित पूर्णता",
        cargoDetails: "कार्गो विवरण",
        typeLabel: "प्रकार",
        weightLabel: "वजन",
        offeredPrice: "प्रस्तावित मूल्य",
        distanceArrivalTarget: "दूरी (आगमन से लक्ष्य)",
        fuelRequired: "आवश्यक ईंधन (@ 7 KM/L)",
        totalEstimatedCost: "कुल अनुमानित लागत",
        netProfit: "शुद्ध लाभ",
        marginLabel: "मार्जिन",
        clientTrust: "ग्राहक का विश्वास",
        securedLabel: "सुरक्षित",
        verifiedPaymentCarrier: "सत्यापित भुगतान वाहक",
        acceptRequestBtn: "अनुरोध स्वीकार करें",
        declineBtn: "अस्वीकार करें",
        selectAllotment: "आवंटन के लिए वाहन का चयन करें",
        requiredLabel: "आवश्यक",
        noCompatibleVehicles: "कोई संगत वाहन उपलब्ध नहीं",
        ensureRegisteredLabel: "कृपया सुनिश्चित करें कि आपने ऐसे वाहनों को पंजीकृत किया है जो वर्तमान में IDLE या ACTIVE हैं।",
        allotBtn: "आवंटित करें",
        bookingRequests: "बुकिंग अनुरोध",
        acceptedOverall: "कुल मिलाकर स्वीकृत",
        recommendedFilter: "अनुशंसित",
        nearYouFilter: "आपके आस-पास",
        highProfitFilter: "उच्च लाभ",
        urgentFilter: "अति आवश्यक",
        allFilter: "सभी",
        noMatchingRequests: "कोई मेल खाने वाला अनुरोध नहीं मिला",
        processingState: "प्रोसेस किया जा रहा है",
        arrivalSpot: "आगमन (स्थान)",
        targetLabel: "लक्ष्य",
        estimatedCosts: "अनुमानित लागत",
        commissionLabel: "कमीशन",
        returnLoadMatching: "वापसी लोड मिलान",
        findCargoDesc: "अपनी वापसी यात्रा के लिए कार्गो खोजें और लाभ को अधिकतम करें।",
        currentLabel: "वर्तमान: ",
        nativeLabel: "मूल निवास: ",
        toNativeLocation: "मूल स्थान पर",
        toNearby: "आस-पास",
        noReturnLoads: "कोई वापसी लोड नहीं मिला",
        noReturnLoadsDescBase: "हम से कोई अनुरोध नहीं ढूंढ सके:",
        onTripShipments: "यात्रा पर शिपमेंट",
        completedShipments: "पूरा हुआ शिपमेंट",
        reviewCompletedDesc: "अपने पूरे किए गए और वितरित शिपमेंट की समीक्षा करें",
        trackOngoingDesc: "अपनी चल रही डिलीवरी को ट्रैक और प्रबंधित करें",
        searchShipmentsPh: "आईडी, मार्ग या क्लाइंट द्वारा खोजें...",
        allStatusOption: "सभी स्थिति",
        readyStatusLabel: "तैयार",
        arrivingStatusLabel: "आ रहा है",
        onTripStatusLabel: "यात्रा पर",
        completedStatusLabel: "पूरा हुआ",
        deliveredStatusLabel: "वितरित",
        noShipmentsFound: "कोई शिपमेंट नहीं मिला",
        checkBackLater: "बाद में वापस जांचें या अपने फ़िल्टर समायोजित करें",
        unknownStatus: "अज्ञात",
        cancelShipmentConfirm: "क्या आप वाकई इस शिपमेंट को रद्द करना चाहते हैं?",
        failedUpdateStatus: "बुकिंग स्थिति को अपडेट करने में विफल",
        failedCancelShipment: "शिपमेंट रद्द करने में विफल",
        proofSubmittedSuccess: "डिलीवरी का प्रमाण सफलतापूर्वक जमा किया गया!",
        submissionFailed: "प्रस्तुतीकरण विफल रहा",
        linkCopied: "लिंक क्लिपबोर्ड पर कॉपी किया गया! आप इसे नीचे मैन्युअल रूप से भी कॉपी कर सकते हैं:",
        failedGenerateLink: "शेयर लिंक बनाने में विफल",
        unassignedVehicle: "असाइन नहीं किया गया",
        fromLabel: "से",
        toLabel: "तक",
        revenueLabel: "राजस्व",
        startAction: "शुरू करें",
        trackAction: "ट्रैक",
        arriveAction: "पहुंचें",
        callAction: "कॉल",
        cancelAction: "रद्द करें",
        reviewProofAction: "प्रमाण की समीक्षा करें",
        uploadProofAction: "प्रमाण अपलोड करें",
        verificationPortal: "सत्यापन पोर्टल",
        snapImagesHint: "पूरा करने के लिए 3 स्पष्ट चित्र खींचें",
        snapLabel: "चित्र",
        processingVerification: "प्रसंस्करण...",
        submitVerification: "सत्यापन जमा करें",
        originLabel: "मूल",
        destinationLabel: "गंतव्य",
        fleetManagementTitle: "बेड़ा प्रबंधन",
        fleetManagementDesc: "अपने पंजीकृत वाहनों का प्रबंधन और निगरानी करें",
        addNewVehicle: "नया वाहन जोड़ें",
        searchVehiclesPh: "आईडी, प्लेट या नाम से खोजें...",
        noVehiclesFoundMsg: "आपके मानदंड से मेल खाने वाला कोई वाहन नहीं मिला",
        noCategoryFound: "कोई {{category}} नहीं मिला",
        startBusinessVehicle: "करोट्रक प्लेटफ़ॉर्म पर अपना पहला {{vehicle}} जोड़कर अपना व्यवसाय शुरू करें।",
        confirmDeleteVehicle: "क्या आप वाकई इस वाहन को हटाना चाहते हैं?",
        deleteSuccess: "वाहन सफलतापूर्वक हटा दिया गया",
        deleteFailed: "हटाना विफल: ",
        editComingSoon: "संपादन कार्यक्षमता जल्द ही आ रही है",
        trackVehicleAction: "वाहन को ट्रैक करें",
        viewDetailsFleetAction: "विवरण देखें",
        wheelsLabel: "पहिए",
        unnamedVehicle: "अनाम वाहन",
        statusLabels: {"active":"सक्रिय","onRoute":"मार्ग पर","idle":"निष्क्रिय","service":"सेवा","maintenance":"रखरखाव","draft":"मसौदा","inactive":"निष्क्रिय"},
        categoryLabel: "श्रेणी",
        yearLabel: "वर्ष",
        conditionLabel: "स्थिति",
        locationLabel: "स्थान",
        basicInfoLabel: "मूल जानकारी",
        techSpecsLabel: "तकनीकी विनिर्देश",
        equipSpecsLabel: "उपकरण विनिर्देश",
        driverDetailsLabel: "चालक का विवरण",
        pricingRatesLabel: "मूल्य निर्धारण और दरें",
        discountsLabel: "छूट",
        specialFeaturesLabel: "विशेष सुविधाएँ",
        additionalNotesLabel: "अतिरिक्त टिप्पणियाँ",
        payloadCapacity: "पेलोड क्षमता",
        lengthLabel: "लंबाई",
        widthLabel: "चौड़ाई",
        heightLabel: "ऊंचाई",
        volumeLabel: "आयतन",
        wizardSelectCategory: "श्रेणी चुनें",
        wizardAddVehicle: "नया {{vehicle}} जोड़ें",
        wizardWhatAdding: "आज आप क्या जोड़ रहे हैं?",
        wizardStepBasic: "4 में से 1 कदम: मूल विवरण",
        wizardStepTech: "4 में से 2 कदम: तकनीकी विनिर्देश",
        wizardStepPhotos: "4 में से 3 कदम: तस्वीरें और दस्तावेज़",
        wizardStepPricing: "4 में से 4 कदम: मूल्य निर्धारण",
        wizardCancel: "रद्द करें",
        wizardSaveCont: "सहेजें और जारी रखें",
        wizardPrev: "पिछला",
        wizardPublish: "वाहन प्रकाशित करें",
        wizardSaving: "सहेजा जा रहा है...",
        wizardPublishing: "प्रकाशित किया जा रहा है...",
        wizardHeavy: "भारी वाहन",
        wizardHeavyDesc: "ट्रक, हल्के वाणिज्यिक वाहन, ट्रेलर",
        wizardEquip: "उपकरण",
        wizardEquipDesc: "क्रेन, फोर्कलिफ्ट, जनरेटर",
        wizardConst: "निर्माण",
        wizardConstDesc: "जेसीबी, मिक्सर, उत्खनन यंत्र",
        wizardTanker: "टैंकर",
        wizardTankerDesc: "पानी, ईंधन, दूध टैंकर",
        wizardSuccessTitle: "{{vehicle}} सफलतापूर्वक प्रकाशित!",
        wizardSuccessDesc: "आपका {{vehicleType}} अब आपके सेवा क्षेत्र में सभी ग्राहकों को दिखाई दे रहा है।",
        wizardViewListing: "अपनी सूची देखें",
        wizardNextSteps: "आगे क्या होता है:",
        wizardStep1Help: "1. ग्राहक आपके उपकरण को खोजेंगे",
        wizardStep2Help: "2. आपको बुकिंग अनुरोध प्राप्त होंगे",
        wizardStep3Help: "3. वास्तविक समय में अनुरोध स्वीकार/अस्वीकार करें",
        wizardStep4Help: "4. यात्राएं पूरी करें और पैसे कमाएं",
        decisionTab: "निर्णय",
        analyticsTab: "विश्लेषिकी",
        recurringTab: "आवर्ती",
        comingSoonText: "जल्द आ रहा है",
        deadTripDev: "डेड ट्रिप डिटेक्शन मॉड्यूल विकास में है",
        smartLoadDev: "स्मार्ट लोड मैचिंग एकीकरण जल्द आ रहा है",
        profitCheckTitle: "लाभप्रदता जांच",
        distanceLabel: "दूरी",
        fuelPriceLabel: "ईंधन की कीमत (₹/L)",
        clientPaymentLabel: "ग्राहक भुगतान (₹)",
        perKmPriceLabel: "प्रति किमी कीमत (₹)",
        estClientPaymentLabel: "अनुमानित ग्राहक भुगतान",
        selectedPickup: "चयनित पिक-अप",
        selectedDropoff: "चयनित ड्रॉप-ऑफ़",
        vehicleRegLabel: "वाहन पंजीकरण संख्या",
        mileageLabel: "माइलेज (km/l)",
        tollsLabel: "टोल (₹)",
        driverCostLabel: "चालक लागत / यात्रा (₹)",
        maintCostLabel: "रखरखाव / यात्रा (₹)",
        calcRoutePrompt: "दूरी प्राप्त करने के लिए कृपया पहले नक्शे पर एक मार्ग की गणना करें।",
        runDecisionEngine: "निर्णय इंजन चलाएं",
        evaluatingBtn: "मूल्यांकन...",
        tripProfitable: "✅ यात्रा लाभदायक है",
        potentialLoss: "⚠️ संभावित नुकसान का पता चला",
        estProfit: "अनुमानित लाभ",
        estFuelCost: "अनुमानित ईंधन लागत",
        platformComm: "प्लेटफ़ॉर्म कमीशन",
        driverCost: "चालक लागत",
        tollsMaint: "टोल और रखरखाव",
        totalCosts: "कुल लागत",
        smartOptionsTitle: "स्मार्ट विकल्प",
        calcRouteSuggest: "बुद्धिमान सुझाव देखने के लिए मानचित्र पर एक मार्ग की गणना करें।",
        smartFromLabel: "से",
        smartToLabel: "तक",
        shortestRoute: "सबसे छोटा मार्ग",
        smartViewInMap: "मानचित्र में सबसे छोटा मार्ग देखें",
        fastestRoute: "सबसे तेज़ मार्ग",
        fuelEfficient: "ईंधन कुशल",
        balancedOption: "संतुलित विकल्प",
        alternative: "विकल्प",
        routeSelected: "चयनित",
        routeStandard: "मार्ग मानक",
        mapComingSoonDesc: "लाइव मार्ग विज़ुअलाइज़ेशन के साथ इन-प्लेटफ़ॉर्म इंटरैक्टिव मानचित्र",
        startPointPlaceholder: "प्रारंभ बिंदु (उदा: चेन्नई)",
        destinationPlaceholder: "गंतव्य (उदा: बैंगलोर)",
        plotRouteBtn: "मार्ग प्लॉट करें",
        locationNotFound: "एक या अधिक स्थान नहीं मिल सके। कृपया अपनी वर्तनी जांचें।",
        calcError: "दूरी की गणना नहीं कर सका। कृपया पुनः प्रयास करें।",
        suggestedRoute: "सुझाया गया मार्ग",
        openGoogleMaps: "Google मैप्स खोलें",
        loadingAnalytics: "विश्लेषिकी लोड हो रहा है...",
        noDataYet: "अभी कोई डेटा नहीं",
        runCalcPrompt: "यहाँ अपना प्रदर्शन विश्लेषिकी देखने के लिए लाभ मार्ग गणना चलाएँ।",
        totalTripsAnalyzed: "कुल यात्रा विश्लेषित",
        profitableRoutesKPI: "लाभदायक मार्ग",
        avgProfitTrip: "औसत लाभ / यात्रा",
        topRoutes: "शीर्ष मार्ग",
        tripsAnalyzed: "यात्रा विश्लेषित",
        loadingRecurring: "आवर्ती मार्ग लोड हो रहा है...",
        noRecurringRoutes: "कोई आवर्ती मार्ग नहीं",
        automateTripsSummary: "अपनी नियमित यात्राओं को आवर्ती मार्ग के रूप में सहेज कर स्वचालित करें।",
        setupAutomationBtn: "+ स्वचालन सेटअप करें",
        activeSchedules: "सक्रिय अनुसूचियां",
        routesCount: "{{count}} मार्ग",
        flexibleSched: "लचीला",
        assignedStatus: "- निर्दिष्ट -",
        noVehicleAssigned: "कोई वाहन निर्दिष्ट नहीं",
        assignNow: "अभी निर्दिष्ट करें",
        activityHistoryTitle: "गतिविधि इतिहास",
        trackHistoryDesc: "अपने पिछले शिपमेंट और वित्तीय रिकॉर्ड को ट्रैक करें",
        tabTransactions: "लेनदेन",
        tabPastShipments: "पिछले शिपमेंट",
        tabMaintenanceLogs: "रखरखाव लॉग",
        noMaintenanceLogs: "अभी तक कोई रखरखाव लॉग दर्ज नहीं किया गया है",
        colDate: "तारीख",
        colTransactionID: "लेनदेन आईडी",
        colClient: "ग्राहक",
        colAmount: "मात्रा",
        colStatus: "स्थिति",
        directClient: "प्रत्यक्ष ग्राहक",
        statusPaid: "भुगतान किया",
        statusPending: "लंबित",
        noTransactionsFound: "कोई लेनदेन नहीं मिला",
        earningHistoryDesc: "आपकी कमाई का इतिहास यहां दिखाई देगा",
        statusCompleted: "पूरा हुआ",
        tonsFormat: "{{weight}} टन",
        noPastShipmentsFound: "कोई पिछला शिपमेंट नहीं मिला",
        customerRatingsTitle: "ग्राहक रेटिंग",
        feedbackSubtitle: "आपके फ्लीट ग्राहकों की प्रतिक्रिया",
        totalReviews: "कुल समीक्षाएँ",
        loadingReviews: "समीक्षाएँ लोड हो रही हैं...",
        noReviewsYet: "अभी तक कोई समीक्षा नहीं",
        completeTripsFeedback: "प्रतिक्रिया प्राप्त करना शुरू करने के लिए यात्राएँ पूरी करें",
        clientDefault: "ग्राहक",
        defaultReviewComment: "प्रदर्शन उम्मीदों पर खरा उतरा।",
        linkedAssetLabel: "लिंक्ड एसेट",
        truckServiceDefault: "ट्रक सेवा",
        helpSupportTitle: "सहायता और समर्थन",
        supportSubtitle: "सहायता प्राप्त करें और अपने सवालों के जवाब पाएं",
        prioritySupportTitle: "24/7 प्राथमिकता समर्थन",
        prioritySupportDesc: "हमारी समर्पित सहायता टीम किसी भी समस्या में आपकी सहायता के लिए यहां है।",
        startLiveChatBtn: "लाइव चैट शुरू करें",
        accountManagerLbl: "खाता प्रबंधक",
        relationshipManagerLbl: "संबंध प्रबंधक",
        loadingTickets: "टिकट लोड हो रहे हैं...",
        activeTicketsTitle: "सक्रिय टिकट",
        noActiveTickets: "कोई सक्रिय टिकट नहीं",
        raiseTicketHelp: "क्या सहायता चाहिए? नीचे एक नया टिकट उठाएं",
        raiseNewTicketBtn: "नया टिकट उठाएं",
        helpCenterTitle: "सहायता केंद्र",
        searchHelpPlaceholder: "मदद के लिए खोजें...",
        noResultsFound: "कोई परिणाम नहीं मिला",
        shortFaq1Q: "मैं एक नया वाहन कैसे जोड़ूँ?",
        shortFaq1A: "फ्लीट प्रबंधन पर जाएं और 'नया वाहन जोड़ें' पर क्लिक करें। आरसी और परमिट विवरण भरें।",
        shortFaq2Q: "मुझे भुगतान कब मिलेगा?",
        shortFaq2A: "पिछले सप्ताह के सभी पूर्ण शिपमेंट के लिए भुगतान हर शुक्रवार को संसाधित किए जाते हैं।",
        shortFaq3Q: "किसी विशिष्ट ट्रक को कैसे ट्रैक करें?",
        shortFaq3A: "फ्लीट प्रबंधन या शिपमेंट मॉड्यूल में 'लाइव ट्रैकिंग' सुविधा का उपयोग करें।",
        shortFaq4Q: "देरी की स्थिति में क्या करें?",
        shortFaq4A: "शिपमेंट की स्थिति को 'पारगमन में - विलंबित' के रूप में अपडेट करें और डैशबोर्ड के माध्यम से ग्राहक को सूचित करें。",
        contactDetails: "संपर्क विवरण",
        emailLbl: "ईमेल",
        phoneLbl: "फोन",
        alternateLbl: "वैकल्पिक",
        baseLbl: "आधार",
        businessIdentity: "व्यावसायिक पहचान",
        gstLbl: "जीएसटी नंबर",
        panLbl: "पैन नंबर",
        entityLbl: "इकाई",
        joinedLbl: "जुड़े",
        bankDetailsTitle: "बैंक विवरण",
        holderLbl: "धारक",
        bankLbl: "बैंक",
        accountLbl: "खाता",
        ifscLbl: "आईएफएससी",
        typeLbl: "प्रकार",
        verifiedWithdrawalsDesc: "सत्यापित विवरण त्वरित निकासी सुनिश्चित करते हैं।",
        endOfMonthReports: "महीने के अंत की रिपोर्ट",
        recordingLbl: "रिकॉर्डिंग",
        reportFinalizedDesc: "रिपोर्ट अंतिम और सत्यापित",
        availableOn: "{{date}} को उपलब्ध",
        downloadDataSheetBtn: "डेटा शीट डाउनलोड करें",
        processingLbl: "प्रसंस्करण...",
        noHistoryObserved: "अभी तक कोई परिचालन इतिहास नहीं देखा गया",
        businessShowcaseTitle: "व्यापार शोकेस",
        viewBusinessPage: "व्यापार पृष्ठ देखें",
        createBusinessPage: "व्यापार पृष्ठ बनाएँ",
        hasBusinessPageDesc: "आपका पेशेवर शोकेस पृष्ठ जिसका उपयोग ग्राहक आपके बेड़े और सेवाओं का मूल्यांकन करने के लिए करते हैं।",
        noBusinessPageDesc: "अपने फ्लीट व्यवसाय के लिए एक पेशेवर विज्ञापन पृष्ठ बनाएं और संभावित ग्राहकों के साथ साझा करें।",
        showPageBtn: "पृष्ठ दिखाएं",
        startSetupBtn: "सेटअप प्रारंभ करें",
        backToProfile: "प्रोफ़ाइल पर वापस जाएँ",
        liveBusinessPage: "लाइव व्यापार पृष्ठ",
        livePreviewBtn: "लाइव पूर्वावलोकन",
        liveFleetInventory: "लाइव बेड़े खोज",
        synchingProfileData: "प्रोफ़ाइल डेटा सिंक हो रहा है...",
        editDetailsHint: "विवरण संपादित करने के लिए, सेटिंग्स में जाएँ",
        accountSettingsTitle: "खाता सेटिंग्स",
        settingsSubtitle: "अपनी प्रोफ़ाइल, भुगतान और प्राथमिकताएँ प्रबंधित करें",
        profileDetailsTab: "प्रोफ़ाइल विवरण",
        bankDetailsTab: "बैंक विवरण",
        securityTab: "सुरक्षा",
        notificationsTab: "सूचनाएँ",
        securitySettingsTitle: "सुरक्षा सेटिंग्स",
        securitySettingsDesc: "अपना पासवर्ड बदलें और सत्र सुरक्षा प्रबंधित करें।",
        resetPasswordBtn: "पासवर्ड रीसेट करें",
        notifPrefTitle: "सूचना प्राथमिकताएँ",
        emailAlertsBookings: "नई बुकिंग के लिए ईमेल अलर्ट",
        smsAlertsSettlement: "भुगतान निपटान के लिए एसएमएस अलर्ट",
        accountInfoTitle: "खाता जानकारी",
        fullNameLbl: "पूरा नाम",
        companyNameLbl: "कंपनी का नाम",
        emailAddressLbl: "ईमेल पता",
        mobileNumberLbl: "मोबाइल नंबर",
        stateLbl: "राज्य",
        cityLbl: "शहर",
        businessNameLbl: "व्यापार का नाम",
        businessTypeLbl: "व्यापार प्रकार",
        editProfile: "प्रोफ़ाइल संपादित करें",
        companyAddressLbl: "कंपनी का पता",
        saveChangesBtn: "बदलाव सहेजें",
        paymentSettlementTitle: "भुगतान निपटान",
        bankNameLbl: "बैंक का नाम",
        bankNamePlaceholder: "उदा: एचडीएफसी बैंक",
        accountNumberLbl: "खाता नंबर",
        accountNumberPlaceholder: "12-16 अंकों का खाता नंबर दर्ज करें",
        ifscCodeLbl: "आईएफएससी कोड",
        ifscCodePlaceholder: "उदा: HDFC0001234",
        settlementNote: "* पिछले सप्ताह की पूरी यात्राओं के लिए हर शुक्रवार को भुगतान निपटाया जाएगा।",
        updateBankDetailsBtn: "बैंक विवरण अपडेट करें",
        settlementHistoryTitle: "निपटान इतिहास",
        last30Days: "पिछले 30 दिन",
        colDateSettlement: "तारीख",
        colReference: "संदर्भ",
        colAmountSettlement: "राशि",
        colStatusSettlement: "स्थिति",
        loadingHistory: "इतिहास लोड हो रहा है...",
        noSettlementsObserved: "पिछले 30 दिनों में पूरी यात्राओं के लिए कोई निपटान नहीं देखा गया।",
        pendingLbl: "लंबित",
        settledLbl: "निपटाया गया",
        processingStatusLbl: "प्रसंस्करण",
        totalRevenueLbl: "कुल राजस्व",
        onTripFleetLbl: "यात्रा पर बेड़ा",
        vsLastMonth: "पिछले महीने की तुलना में",
        cumulativeEarnings: "संचयी कमाई",
        withdrawBtn: "निकालें",
        thisWeekLbl: "इस सप्ताह",
        fromLastSession: "पिछले सत्र से",
        profitMarginLbl: "लाभ मार्जिन",
        calculatedRealtime: "रियल-टाइम गणना",
        earningsPerformance: "कमाई प्रदर्शन",
        revenueOverTime: "समय के साथ राजस्व (साप्ताहिक दृश्य)",
        downloadDetailedReport: "विस्तृत रिपोर्ट डाउनलोड करें",
        observingPerformance: "प्रदर्शन देख रहे हैं...",
        earningsVisualizationHint: "यात्राएं पूरी होने पर कमाई दृश्य दिखाई देगा",
        withdrawFundsTitle: "धन निकालें",
        transferToBank: "पंजीकृत बैंक में स्थानांतरण",
        availableForWithdrawal: "निकासी के लिए उपलब्ध",
        withdrawalAmountLbl: "निकासी राशि",
        fundsTransferNote: "धनराशि आपके सत्यापित बैंक खाते ** 4582 में 24-48 व्यावसायिक घंटों में जमा की जाएगी।",
        confirmWithdrawalBtn: "निकासी की पुष्टि करें",
        requestSuccessful: "अनुरोध सफल",
        withdrawalInitiated: "आपका ₹{{amount}} निकासी अनुरोध शुरू किया गया है।",
        driverDirectory: "ड्राइवर निर्देशिका",
        driverDirectorySub: "अपने बेड़े के कर्मियों का प्रबंधन करें, विवरण देखें और नए ड्राइवरों को शामिल करें।",
        searchDriversPh: "ड्राइवरों को खोजें...",
        addDriver: "ड्राइवर जोड़ें",
        noDriversFound: "कोई ड्राइवर नहीं मिला",
        noDriversFoundSub: "आपकी कंपनी में अभी तक कोई ड्राइवर पंजीकृत नहीं है। शुरू करने के लिए अपना पहला ड्राइवर जोड़ें।",
        addFirstDriver: "पहला ड्राइवर जोड़ें",
        noMatchFound: "कोई मेल नहीं मिला",
        adjustSearchCriteria: "अपने खोज मानदंडों को समायोजित करने का प्रयास करें।",
        vehicleAvailabilityTip: "सुझाव: कृपया अपने वाहन की उपलब्धता को नियमित रूप से अपडेट करें। 'रखरखाव' या 'सेवा' के रूप में चिह्नित वाहन ग्राहक खोज से छिपे होते हैं!",
        paymentPending: "भुगतान लंबित",
        cancelledShipments: "रद्द किया गया",
        recentShipments: "हाल की शिपमेंट",
        searchKnowledgeBase: "ज्ञान आधार खोजें...",
        searchKnowledgeHint: "टिकट, अक्सर पूछे जाने वाले प्रश्न और सहायता लेख खोजें",
        quickContactOptions: "त्वरित संपर्क विकल्प",
        callSupport: "कॉल सपोर्ट",
        whatsAppSupport: "व्हाट्सएप सपोर्ट",
        emailSupport: "ईमेल सहायता",
        liveSupport: "लाइव सपोर्ट",
        connectToAgent: "एजेंट से जुड़ें →",
        yourAccountManager: "आपका खाता प्रबंधक",
        relationshipManager: "रिलेशनशिप मैनेजर",
        supportHours: "सहायता घंटे",
        emergencyHelpline: "आपातकालीन हेल्पलाइन",
        currentPasswordLbl: "वर्तमान पासवर्ड",
        newPasswordLbl: "नया पासवर्ड",
        updatePasswordBtn: "पासवर्ड अपडेट करें",
        enterOtpFromEmail: "ईमेल से ओटीपी दर्ज करें",
        verifyConfirmBtn: "सत्यापित करें और पुष्टि करें",
        emailAlertsLbl: "ईमेल अलर्ट",
        emailAlertsSub: "ईमेल के माध्यम से बुकिंग और यात्रा अपडेट",
        smsAlertsLbl: "एसएमएस अलर्ट",
        smsAlertsSub: "पाठ संदेश के माध्यम से महत्वपूर्ण अलर्ट",
        whatsAppAlertsLbl: "व्हाट्सएप अलर्ट",
        whatsAppAlertsSub: "व्हाट्सएप के माध्यम से अपडेट",
        changeEmailAddress: "ईमेल पता बदलें",
        updateEmailAddress: "ईमेल पता अपडेट करें",
        newEmailAddressPh: "नया ईमेल पता",
        sendOtpBtn: "ओटीपी भेजें",
        verifyApplyBtn: "सत्यापित करें और लागू करें",
        requestChangeBtn: "बदलाव का अनुरोध करें",
        frequentlyAskedQuestions: "अक्सर पूछे जाने वाले प्रश्न",
        questionsLabel: "प्रश्न",
        questionLabel: "प्रश्न",
        noQuestionsFound: "कोई प्रश्न नहीं मिला",
        tryDifferentKeywords: "अलग-अलग कीवर्ड आज़माएं या सहायता टिकट दर्ज करें।",
        activeTickets: "सक्रिय टिकट",
        activeCountLabel: "सक्रिय",
        createNewTicketBtn: "नया टिकट बनाएं",
        faq1Q: "कारोट्रक नेटवर्क में नया वाहन कैसे जोड़ें?",
        faq1A: "अपने डैशबोर्ड पर \"बेड़ा प्रबंधन\" मॉड्यूल पर जाएं और \"नया वाहन जोड़ें\" चुनें। आपको पंजीकरण संख्या, परमिट विवरण और आरसी व बीमा दस्तावेजों की स्पष्ट प्रति प्रदान करनी होगी। सत्यापन आमतौर पर 2 घंटे के भीतर पूरा हो जाता है।",
        faq2Q: "किसी विशिष्ट वाहन के लिए ड्राइवर कैसे आवंटित करें?",
        faq2A: "\"बेड़ा प्रबंधन\" मॉड्यूल पर जाएं और वांछित वाहन चुनें। अपनी सूची से किसी मौजूदा सत्यापित ड्राइवर को चुनने के लिए \"ड्राइवर आवंटित करें\" पर क्लिक करें, या उनके वाणिज्यिक लाइसेंस विवरण जमा करके नए ड्राइवर को शामिल करें।",
        faq3Q: "मानक भुगतान निपटान चक्र क्या है?",
        faq3A: "भुगतान सीधे आपके सत्यापित बैंक खाते में निपटाए जाते हैं। अग्रिम भुगतान (यदि बातचीत की गई हो) प्रेषण पर संसाधित होते हैं, और शेष राशि डिलीवरी प्रमाण (POD) अपलोड करने के 24-48 घंटों के भीतर निपटाई जाती है।",
        faq4Q: "यात्रा के लिए अग्रिम भुगतान का अनुरोध कैसे करें?",
        faq4A: "शिपमेंट की स्वीकृति चरण के दौरान अग्रिम भुगतान का अनुरोध किया जा सकता है। सटीक प्रतिशत की बातचीत सीधे ग्राहक के साथ की जाती है और कारोट्रक सिस्टम के माध्यम से सुरक्षित रूप से संसाधित की जाती है।",
        faq5Q: "अपने पंजीकृत बैंक खाते का विवरण कैसे अपडेट करें?",
        faq5A: "सेटिंग्स > बैंक विवरण पर जाएं। सुरक्षा कारणों से, अनधिकृत परिवर्तनों को रोकने के लिए वित्तीय जानकारी में बदलाव के लिए ओटीपी सत्यापन और हमारी सहायता टीम द्वारा समीक्षा की आवश्यकता होती है।",
        faq6Q: "प्रारंभिक सत्यापन के लिए कौन से दस्तावेज़ आवश्यक हैं?",
        faq6A: "अपना खाता सक्रिय करने के लिए, आपको अपना पैन कार्ड, जीएसटी प्रमाण पत्र (यदि लागू हो), बैंक प्रमाण (रद्द चेक/पासबुक) और आधार कार्ड अपलोड करना होगा। सभी दस्तावेज स्पष्ट और सुपाठ्य होने चाहिए।",
        faq7Q: "लाइव शिपमेंट ट्रैकिंग कैसे काम करती है?",
        faq7A: "सक्रिय शिपमेंट स्वचालित रूप से ड्राइवर के मोबाइल एप्लिकेशन या आपके वाहन के एकीकृत जीपीएस सिस्टम के माध्यम से ट्रैक किए जाते हैं। वास्तविक समय टेलीमेट्री आपके डैशबोर्ड पर \"शिपमेंट\" के तहत दिखाई देती है।",
        faq8Q: "ग्राहक द्वारा रद्द किए जाने का प्रोटोकॉल क्या है?",
        faq8A: "यदि कोई ग्राहक पुष्टिकृत प्रेषण को रद्द करता है, तो आपको एसएमएस और ईमेल के माध्यम से तुरंत सूचित किया जाएगा। हमारी सेवा की शर्तों के अनुसार रद्दीकरण मुआवजा स्वचालित रूप से गणना किया जाता है।",
        faq9Q: "ट्रांजिट के दौरान ग्राहक से कैसे संवाद करें?",
        faq9A: "शिपमेंट सक्रिय होने पर सीधे संचार चैनल अनलॉक हो जाते हैं। लोड करने या अनलोड करने के कार्यों के समन्वय के लिए आप सक्रिय शिपमेंट विवरण पैनल में ग्राहक का संपर्क नंबर पा सकते हैं।",
        faq10Q: "क्या मेरे द्वारा पंजीकृत किए जा सकने वाले वाहनों की संख्या की कोई सीमा है?",
        faq10A: "नहीं, कारोट्रक असीमित बेड़े स्केलिंग का समर्थन करता है। आप एक एकीकृत डैशबोर्ड से एक एकल ट्रक या सैकड़ों वाहनों के बड़े बेड़े का प्रबंधन कर सकते हैं।",
        myShipments: "मेरी शिपमेंट",
        activeCompletedTransits: "सक्रिय और पूर्ण पारगमन",
        trackLiveVehicleRoutesDesc: "बुकिंग स्वीकृति के बाद लाइव वाहन मार्ग, ड्राइवर आवंटन और POD सत्यापन विवरण ट्रैक करें",
        filterByDate: "तारीख के अनुसार फ़िल्टर करें",
        selectDate: "तारीख चुनें",
        arrivingTab: "आ रहा है",
        onServiceTab: "कार्य प्रगति पर",
        completedTab: "पूर्ण",
        noTransitsDiscovered: "कोई पारगमन नहीं मिला",
        noActiveShipmentsInState: "इस स्थिति में वर्तमान में कोई सक्रिय शिपमेंट नहीं है।",
        showDetails: "विवरण दिखाएं",
        hideDetails: "विवरण छुपाएं",
        liveStatusUpdate: "लाइव स्थिति अपडेट",
        progress: "प्रगति",
        podVerified: "POD सत्यापित",
        viewPod: "POD देखें",
        proofOfDelivery: "डिलीवरी का प्रमाण (POD)",
        podNotVerifiedByYou: "आपके द्वारा सत्यापित नहीं",
        verifyNow: "अभी सत्यापित करें",
        podNotReceivedYet: "POD अभी प्राप्त नहीं हुआ",
        liveTrack: "लाइव ट्रैक",
        awaitingPlate: "प्लेट की प्रतीक्षा है",
        assigningDriver: "ड्राइवर सौंपा जा रहा है...",
        paymentsAndInvoices: "भुगतान और चालान",
        totalSpentThisMonth: "कुल खर्च (इस महीने)",
        basedOnCompletedPayments: "पूर्ण किए गए भुगतानों के आधार पर",
        pendingInvoices: "लंबित चालान",
        awaitingPayment: "भुगतान की प्रतीक्षा में",
        gstRecords: "जीएसटी रिकॉर्ड",
        updateInProfileSettings: "प्रोफ़ाइल सेटिंग्स में अपडेट करें",
        paymentHistory: "भुगतान इतिहास",
        downloadInvoices: "चालान डाउनलोड करें",
        gstBills: "जीएसटी बिल",
        notifications: "सूचनाएं",
        markAllRead: "सभी को पढ़ा हुआ चिह्नित करें",
        noNotificationsYet: "अभी तक कोई सूचना नहीं है",
        loadingNotifications: "सूचनाएं लोड हो रही हैं...",
        reserveVehicle: "वाहन आरक्षित करें",
        confirmReservation: "आरक्षण की पुष्टि करें",
        cancel: "रद्द करें",
        submitting: "प्रस्तुत किया जा रहा है...",
        careersAtKaroTrukk: "KaroTrukk में करियर",
        careersHeroSub: "लॉजिस्टिक्स के भविष्य के निर्माण में हमारे साथ जुड़ें। हम पूरे भारत में विस्तार करने के लिए उत्साही लोगों की तलाश कर रहे हैं।",
        openPositions: "खुली रिक्तियां",
        applyNow: "अभी आवेदन करें",
        waterTankersOnDemand: "मांग पर पानी के टैंकर",
        waterSupplySub: "घरेलू, निर्माण और वाणिज्यिक जल आपूर्ति",
        waterSupplyDesc: "सत्यापित स्थानीय बेड़े के साथ घरों, स्विमिंग पूल, बोरवेल सहायता और निर्माण स्थलों के लिए त्वरित पानी का टैंकर वितरण।",
        fastLocalDispatch: "तेज़ स्थानीय प्रेषण",
        verifiedTankerFleet: "सत्यापित टैंकर बेड़ा",
        liveDriverTracking: "लाइव ड्राइवर ट्रैकिंग",
        orderTanker: "टैंकर ऑर्डर करें",
        whoUsesKaroTrukk: "KaroTrukk का उपयोग कौन करता है?",
        whoUsesKaroTrukkDesc: "आवासीय, वाणिज्यिक और साइट परियोजनाओं में विविध ग्राहकों की सेवा।",
        homeowners: "गृहस्वामी",
        builders: "बिल्डर्स",
        contractors: "ठेकेदार",
        factories: "कारखाने",
        warehouses: "गोदाम",
        shops: "दुकानें",
        eventOrganizers: "इवेंट आयोजक",
        farmers: "किसान",
        whatWeDo: "हम क्या करते हैं",
        whatWeDoDesc: "JCB और उपकरणों की कैब-स्टाइल बुकिंग बस कुछ ही चरणों में। तेज़, सत्यापित और प्रत्यक्ष।",
        everydayJobsTitle: "दैनिक कार्य जिनमें हम मदद करते हैं",
        moreVehicles: "अधिक वाहन",
        signInToViewAll: "सभी देखने के लिए साइन इन करें →",
        touchAndDragToScroll: "← स्क्रॉल करने के लिए खींचें →",
        moreArrow: "अधिक →",
        forCustomers: "ग्राहकों के लिए",
        forCustomersDesc: "मांग पर JCB और उपकरण बुक करें। डिजिटल रूप से अपना अनुरोध सबमिट करें और मिनटों में जुड़ें।",
        forFleetPartners: "फ्लीट पार्टनर्स के लिए",
        forFleetPartnersDesc: "अपने JCB और उपकरणों को सूचीबद्ध करें। सीधे बुकिंग अनुरोध प्राप्त करें और दैनिक उपयोग को अधिकतम करें।",
        howWeConnect: "हम कैसे जोड़ते हैं",
        howWeConnectDesc: "4 चरणों में JCB और उपकरण बुकिंग को सरल बनाया गया।",
        step1Title: "मशीनरी चुनें",
        step1Desc: "अपने काम के लिए आवश्यक JCB या उपकरण चुनें।",
        step2Title: "बुकिंग का अनुरोध करें",
        step2Desc: "कुछ ही चरणों में अपनी आवश्यकता सबमिट करें।",
        step3Title: "जुड़ें",
        step3Desc: "सत्यापित उपलब्ध फ्लीट पार्टनर्स से जुड़ें।",
        step4Title: "काम शुरू करें",
        step4Desc: "अपनी बुकिंग की पुष्टि करें और साइट पर काम शुरू करें।",
        whyWeDoIt: "हम यह क्यों करते हैं",
        whyWeDoItDesc: "निर्माण परियोजनाएं सही समय पर सही उपकरणों की उपलब्धता पर निर्भर करती हैं। KaroTrukk को पूरे भारत में मशीनरी को सरल और पारदर्शी बनाने के लिए बनाया गया था।",
        ourMission: "हमारा मिशन",
        ourMissionDesc: "सुलभ और भरोसेमंद बुकिंग अनुभव के माध्यम से निर्माण मशीनरी और भारी उपकरणों तक पहुंच को सरल बनाना।",
        ourVision: "हमारा विजन",
        ourVisionDesc: "पूरे भारत में निर्माण मशीनरी बुकिंग को अधिक सुविधाजनक बनाने वाला एक विश्वसनीय मंच तैयार करना।",
        ourCommitment: "हमारी प्रतिबद्धता",
        ourCommitmentDesc: "सुविधा को प्राथमिकता। विश्वसनीय सेवा, स्पष्टता और सत्यापित फ्लीट पार्टनर्स पर ध्यान केंद्रित।",
        whoWeAre: "हम कौन हैं",
        whoWeAreSub: "JCB और उपकरणों के लिए भारत का पहला कैब-शैली बुकिंग प्लेटफॉर्म।",
        jcbsEarthmoving: "JCB और अर्थमूविंग उपकरण",
        equipmentMachineries: "उपकरण मशीनरी",
        verifiedFleetPartners: "सत्यापित फ्लीट पार्टनर्स",
        heavyTrucksTitle: "भारी ट्रक और वाणिज्यिक वाहन",
        heavyTrucksDesc: "औद्योगिक रसद और परिवहन के लिए वाणिज्यिक ट्रक, LCV, टिपर और ट्रेलर किराए पर लें।",
        constructionVehiclesTitle: "निर्माण वाहन और अर्थमूवर",
        constructionVehiclesDesc: "अपनी साइट के काम के लिए सत्यापित JCB, उत्खननकर्ता, क्रेन और रोलर्स किराए पर लें।",
        equipmentRentalsPageTitle: "उपकरण किराया",
        equipmentRentalsPageDesc: "मांग पर उपलब्ध औद्योगिक जनरेटर, कंप्रेसर और उठाने वाली मशीनरी।",
        noEquipmentFound: "इस श्रेणी में कोई उपकरण नहीं मिला।",
        loadingEquipment: "उपकरण लोड हो रहे हैं...",
        aboutUsTitle: "हमारे बारे में",
        aboutLead: "कारोट्रक्क भारत भर में जेसीबी, उत्खनन (एक्सावेटर) और भारी निर्माण उपकरणों को प्रत्यक्ष, विश्वसनीय और पारदर्शी रूप से किराए पर लेने के लिए बनाया गया एक ऑन-डिमांड प्रौद्योगिकी मंच है।",
        theProblem: "समस्या",
        theProblemP1: "भारत भर में भारी निर्माण मशीनरी प्राप्त करना ऐतिहासिक रूप से खंडित और अक्षम रहा है। एक भरोसेमंद जेसीबी, एक्सावेटर, टिपर या क्रेन प्राप्त करने में आमतौर पर कई दलाल, अप्रत्याशित दरें और अनिश्चित मशीन उपलब्धता शामिल होती है।",
        theProblemP2: "मशीनरी मालिकों के लिए, महंगी संपत्तियां अक्सर स्थिर मांग के बिना अनुबंधों के बीच बेकार पड़ी रहती हैं। ठेकेदारों और साइट इंजीनियरों के लिए, मशीनरी के आगमन में देरी से परियोजना की समय सीमा रुक जाती है और खर्च बढ़ जाते हैं।",
        theSolution: "समाधान",
        theSolutionP1: "कारोट्रक्क एक एकीकृत डिजिटल मार्केटप्लेस प्रस्तुत करता है। हम ठेकेदारों, बिल्डरों और डेवलपर्स को सीधे सत्यापित फ्लीट भागीदारों से जोड़ते हैं।",
        theSolutionP2: "बिचौलियों के कमीशन को हटाकर और सीधा मिलान प्रदान करके, कारोट्रक्क उचित मूल्य निर्धारण, त्वरित प्रेषण और साइट पर विश्वसनीय निष्पादन सुनिश्चित करता है।",
        onDemandDispatch: "ऑन-डिमांड प्रेषण",
        onDemandDispatchDesc: "अपनी कार्यस्थल के लिए कुछ ही चरणों में सीधे जेसीबी, एक्सावेटर, टिपर और क्रेन बुक करें।",
        transparentTerms: "पारदर्शी शर्तें",
        transparentTermsDesc: "शून्य छिपे हुए दलाली शुल्क के साथ ग्राहकों और उपकरण मालिकों के बीच सीधा संपर्क।",
        verifiedPartnersPillar: "सत्यापित भागीदार",
        verifiedPartnersPillarDesc: "विश्वसनीय मशीन गुणवत्ता और पेशेवर साइट डिलीवरी सुनिश्चित करने के लिए प्रत्येक उपकरण भागीदार का सत्यापन किया जाता है।",
        leadership: "नेतृत्व",
        founderRole: "संस्थापक और मुख्य कार्यकारी अधिकारी (सीईओ)",
        founderBio1: "जाफ़र साहूसेन ने भारत के भारी वाहन और निर्माण मशीनरी किराये के इकोसिस्टम में परिचालन संबंधी बाधाओं और अक्षमताओं को हल करने के लिए कारोट्रक्क की स्थापना की।",
        founderQuote: "\"हमारा उद्देश्य सीधा है: उपकरण मालिकों के लिए मशीन डाउनटाइम को खत्म करना, और ठेकेदारों को कैब बुक करने जैसी आसानी और पारदर्शिता के साथ सत्यापित भारी मशीनरी बुक करने की क्षमता देना। हम इस मंच को ईमानदार उपयोगिता, विश्वसनीयता और तकनीक पर बना रहे हैं।\"",
        founderBio2: "संस्थापक और सीईओ के रूप में, जाफ़र पूरे भारत में उत्पाद विकास, प्रौद्योगिकी और फ्लीट भागीदार संचालन की देखरेख करते हैं।",
        getStartedKaroTrukk: "कारोट्रक्क के साथ शुरुआत करें",
        bookOrRegisterToday: "अपनी साइट के लिए मशीनरी बुक करें या आज ही अपना फ्लीट पंजीकृत करें।",
        joinAsFleetPartner: "फ्लीट पार्टनर के रूप में जुड़ें",
        getInTouch: "संपर्क करें",
        haveQuestionsAssistance: "उपकरण बुक करने या फ्लीट पार्टनर के रूप में जुड़ने के बारे में प्रश्न हैं? हम आपकी सहायता के लिए यहां हैं।",
        directInquiries: "प्रत्यक्ष पूछताछ",
        connectOpsTeamDesc: "कारोट्रक्क संचालन और ऑनबोर्डिंग टीम से जुड़ें। हम पूरे भारत में ठेकेदारों और फ्लीट भागीदारों की सहायता करते हैं।",
        corporateOffice: "कॉर्पोरेट कार्यालय",
        fleetPartnerDesk: "फ्लीट पार्टनर डेस्क",
        platformNotice: "मंच सूचना",
        platformNoticeDesc: "तत्काल आपातकालीन साइट बुकिंग या पार्टनर ऑनबोर्डिंग प्रश्नों के लिए, नीचे अपना संदेश सबमिट करें और हमारी टीम सीधे संपर्क करेगी।",
        connectWithKaroTrukk: "कारोट्रक्क से जुड़ें",
        reachingOutAs: "मैं संपर्क कर रहा हूँ",
        optClient: "ग्राहक (जेसीबी / भारी मशीनरी बुक करने की आवश्यकता है)",
        optFleetPartner: "फ्लीट पार्टनर (उपकरण / ट्रक मालिक)",
        optEnterprise: "एंटरप्राइज / इंफ्रास्ट्रक्चर ठेकेदार",
        optGeneralInquiry: "सामान्य पूछताछ",
        fullName: "पूरा नाम",
        enterYourName: "अपना नाम दर्ज करें",
        emailAddress: "ईमेल पता",
        phoneWhatsApp: "फोन / व्हाट्सएप नंबर",
        subject: "विषय",
        briefSubject: "पूछताछ का संक्षिप्त विषय",
        message: "संदेश",
        describeRequirement: "अपनी उपकरण आवश्यकता या फ्लीट विवरण का वर्णन करें...",
        sendInquiry: "पूछताछ भेजें",
        thankYouContact: "हमसे संपर्क करने के लिए धन्यवाद! हम शीघ्र ही आपसे संपर्क करेंगे।",
        howCanWeHelp: "हम आपकी किस प्रकार सहायता कर सकते हैं?",
        searchHelpInput: "प्रश्न खोजें (उदा. जेसीबी बुकिंग, फ्लीट पार्टनर, ट्रैकिंग)...",
        machineryBooking: "मशीनरी बुकिंग",
        machineryBookingDesc: "जेसीबी, एक्सावेटर, टिपर और क्रेन",
        fleetPartnerNetwork: "फ्लीट पार्टनर नेटवर्क",
        fleetPartnerNetworkDesc: "वाहन ऑनबोर्डिंग और सत्यापन",
        siteDispatchGps: "साइट प्रेषण और जीपीएस",
        siteDispatchGpsDesc: "लाइव ट्रैकिंग और रूट टेलीमैटिक्स",
        directBilling: "प्रत्यक्ष बिलिंग",
        directBillingDesc: "0% ब्रोकर मार्कअप और भुगतान",
        helpFaq1Q: "कारोट्रक्क पर कैब-शैली मशीनरी बुकिंग कैसे काम करती है?",
        helpFaq1A: "कारोट्रक्क निर्माण मशीनरी के लिए तैयार की गई ऑन-डिमांड राइड सेवा की तरह काम करता है। आप अपनी ज़रूरत के उपकरण का चयन करते हैं, अपनी साइट का पता और समय निर्धारित करते हैं, और कुछ ही क्लिक में अपने क्षेत्र में सत्यापित उपलब्ध फ्लीट भागीदारों से सीधे जुड़ जाते हैं।",
        helpFaq2Q: "मैं किस प्रकार की मशीनरी और भारी वाहन बुक कर सकता हूँ?",
        helpFaq2A: "आप निर्माण, साइट ग्रेडिंग, उत्खनन और औद्योगिक सामग्री परिवहन के लिए जेसीबी, एक्सावेटर, टिपर, क्रेन, पानी के टैंकर और लॉजिस्टिक्स ट्रक सहित सत्यापित उपकरणों की विस्तृत श्रृंखला बुक कर सकते हैं।",
        helpFaq3Q: "वाहन और उपकरण मालिक फ्लीट पार्टनर के रूप में कैसे शामिल हो सकते हैं?",
        helpFaq3A: "मशीनरी मालिक 'फ्लीट पार्टनर के रूप में जुड़ें' पर क्लिक करके पंजीकरण कर सकते हैं। आप अपने वाहन का विवरण, आरसी, दस्तावेज और सेवा स्थान दर्ज करते हैं। सत्यापन के बाद, आप बिना बिचौलियों के अपने डैशबोर्ड पर सीधे बुकिंग अनुरोध प्राप्त करना शुरू करते हैं।",
        helpFaq4Q: "क्या कोई छिपे हुए दलाली कमीशन या बिचौलियों का मार्कअप है?",
        helpFaq4A: "नहीं। कारोट्रक्क 0% छिपे हुए बिचौलिए मार्कअप नीति के साथ पूर्ण पारदर्शिता पर बनाया गया है। ठेकेदार और उपकरण मालिक पारदर्शी शर्तों और सीधे भुगतान के साथ काम करते हैं, जिससे दलालों की कटौती समाप्त हो जाती है।",
        helpFaq5Q: "साइट प्रेषण और ट्रैकिंग कैसे काम करती है?",
        helpFaq5A: "एक बार जब कोई फ्लीट पार्टनर आपके बुकिंग अनुरोध को स्वीकार कर लेता है, तो आप अपने डैशबोर्ड के माध्यम से वाहन की वास्तविक समय स्थिति की निगरानी कर सकते हैं, जिससे सटीक आगमन समय की जानकारी मिलती रहती है।",
        helpFaq6Q: "कारोट्रक्क की स्थापना और संचालन कौन करता है?",
        helpFaq6A: "कारोट्रक्क की स्थापना जाफ़र साहूसेन (संस्थापक और सीईओ) द्वारा की गई है। यह मंच ऑन-डिमांड बुकिंग और पारदर्शी मूल्य निर्धारण के साथ भारत के भारी वाहन और निर्माण मशीनरी किराये के इकोसिस्टम को डिजिटाइज़ करने के लिए समर्पित है।",
        haveSpecificQuery: "क्या कोई विशिष्ट साइट या फ्लीट संबंधी प्रश्न है?",
        opsTeamAssistance: "हमारी समर्पित संचालन टीम ठेकेदारों और मशीनरी मालिकों की सहायता के लिए तैयार है।",
        contactOpsTeam: "संचालन टीम से संपर्क करें",
        verifiedPartner: "सत्यापित भागीदार",
        driverIncluded: "चालक शामिल",
        helperIncluded: "सहायक शामिल",
        kmAway: "किमी दूर",
        quoteOnRequest: "अनुरोध पर कोटेशन",
        rentalRate: "किराया दर",
        featureComesSoon: "यह सुविधा जल्द ही आ रही है।",
        book: "बुक करें",
        rentalRateNotice: "किराया दर सूचना",
        rateForRentingTime: "दर किराये के समय के लिए है, वन-वे ट्रिप के लिए नहीं",
        rateForRentingTimeDesc: "प्रदर्शित मूल्य आपकी साइट पर वाहन और उपकरण के लिए प्रति घंटा या दैनिक किराया दर है।",
        notOneWayTrip: "मानक टैक्सी सवारी नहीं",
        notOneWayTripDesc: "भारी मशीनरी आवश्यक कार्य की अवधि तक आपकी साइट पर रहती है।",
        gotIt: "समझ गया",
        getEquipmentInstantly: "मांग पर भारी मशीनरी और परिवहन वाहन प्राप्त करें",
        whatDoYouNeedToday: "आज आपको क्या चाहिए?",
        heavyVehicles: "भारी वाहन",
        constructionMachinery: "निर्माण मशीनरी",
        tankers: "टैंकर",
        equipmentSiteMachinery: "उपकरण और साइट मशीनरी",
        lcvsTippers: "एलसीवी, टिपर, ट्रक",
        jcbsExcavators: "जेसीबी, एक्सावेटर, लोडर",
        waterTankerSewage: "पानी और सीवेज टैंकर",
        generatorsAirCompressors: "जनरेटर, कंप्रेसर",
        siteArrivalLocation: "साइट / आगमन स्थान",
        dropoffLocation: "ड्रॉप-ऑफ स्थान (वैकल्पिक)",
        popularHouseholdServices: "लोकप्रिय दैनिक सेवाएं",
        landGardenCleaning: "साइट और भूमि सफाई",
        moveYourLoad: "अपना भार स्थानांतरित करें",
        tankFillingWaterDelivery: "पानी का टैंकर वितरण",
        pathHoleDebrisFilling: "गड्ढे और मलबा भरना",
        generatorRental: "जनरेटर किराया",
        landLevelling: "भूमि समतलीकरण",
        availableNearYou: "आपके निकट उपलब्ध",
        discoveredWithinRadar: "0-20 किमी रडार के भीतर खोजा गया",
        heavyTab: "भारी ट्रक",
        constructionTab: "निर्माण",
        tankerTab: "टैंकर",
        equipmentTab: "उपकरण",
        noVehiclesNearby: "आस-पास इस श्रेणी में कोई वाहन नहीं मिला",
        noVehiclesNearbyDesc: "श्रेणी बदलने का प्रयास करें या अपना स्थान खोज बढ़ाएं",
        home: "होम",
        forContractors: "ठेकेदारों के लिए",
        requestQuote: "कोटेशन का अनुरोध करें",
        accountMenu: "खाता मेनू",
        back: "वापस",
        bookNowInstant: "त्वरित मशीनरी बुक करें",
        requestQuoteService: "कस्टम कोटेशन का अनुरोध करें",
        paymentsInvoices: "भुगतान और चालान",
        favoritePartners: "पसंदीदा भागीदार",
        supportCenter: "सहायता केंद्र",
        myBusiness: "मेरी बुकिंग और व्यवसाय",
        expectedRent: "अपेक्षित किराया",
        day: "दिन",
        processing: "प्रक्रिया जारी है...",
        reserveThisVehicle: "यह वाहन आरक्षित करें",
        reservationSent: "आरक्षण अनुरोध भेजा गया!",
        confirmCancelTitle: "बुकिंग रद्द करें",
        confirmCancel: "क्या आप वाकई इस बुकिंग को रद्द करना चाहते हैं?",
        notApprovedNotice: "आपका खाता सत्यापन के लिए लंबित है। हमारी ऑनबोर्डिंग टीम आपके दस्तावेज़ों की समीक्षा कर रही है।",
        newOrders: "नए ऑर्डर",
        completeProfileNotice: "प्रोफ़ाइल पूरी करें",
        drivers: "चालक",
        lightMode: "लाइट मोड",
        darkMode: "डार्क मोड",
        totalFleet: "कुल फ्लीट",
        onServiceTrips: "ऑन-सर्विस ट्रिप",
        completedShipmentsStat: "पूर्ण किए गए शिपमेंट",
        viewAll: "सभी देखें",
        payment: "भुगतान",
        contact: "संपर्क",
        confirmDeleteTitle: "वाहन हटाएं",
        delete: "हटाएं",
        profileDetailsSub: "अपनी प्रोफ़ाइल विवरण और व्यावसायिक संपर्क जानकारी प्रबंधित करें",
        yardSettingsTab: "यार्ड स्थान",
        yardSettingsSub: "अपना बेस यार्ड और प्रेषण त्रिज्या कॉन्फ़िगर करें",
        bankDetailsSub: "स्वचालित साप्ताहिक भुगतान के लिए बैंक खाते प्रबंधित करें",
        securitySub: "अपना खाता पासवर्ड और सुरक्षा प्राथमिकताएं अपडेट करें",
        notificationsSub: "एसएमएस, व्हाट्सएप और पोर्टल अलर्ट प्राथमिकताएं कॉन्फ़िगर करें",
        saving: "सहेज रहा है...",
        linkCopiedSuccess: "ट्रैकिंग लिंक क्लिपबोर्ड पर कॉपी हो गया!",
        shareFailed: "लिंक साझा करने में विफल",
        login: "लॉग इन",
        joinNow: "अभी जुड़ें",
        maximizeRevenue: "फ्लीट की कमाई अधिकतम करें",
        fleetRevenue: "फ्लीट राजस्व",
        fleetHeroSub: "अपनी जेसीबी, एक्सावेटर, टिपर और क्रेन को पूरे भारत में हजारों सत्यापित ठेकेदारों और बिल्डरों से जोड़ें।",
        startEarningToday: "आज ही कमाना शुरू करें",
        watchHowItWorks: "देखें यह कैसे काम करता है",
        fleetPartners: "फ्लीट पार्टनर्स",
        activeLoads: "सक्रिय लोड",
        citiesCovered: "कवर किए गए शहर",
        payoutsDisbursed: "संवितरित भुगतान",
        helpCenter: "सहायता केंद्र",
        rentNow: "अभी किराए पर लें",
        noWaterTankersAvailable: "फिलहाल कोई पानी का टैंकर उपलब्ध नहीं है।",
        loadingWaterTankers: "पानी के टैंकर लोड हो रहे हैं...",
        servicesNav: "सेवाएं",
    },
};
